import { Resolver as GraphCacheResolver, UpdateResolver as GraphCacheUpdateResolver, OptimisticMutationResolver as GraphCacheOptimisticMutationResolver, StorageAdapter as GraphCacheStorageAdapter } from '@urql/exchange-graphcache';
import { IntrospectionData } from '@urql/exchange-graphcache/dist/types/ast';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  jsonb: any;
  timestamptz: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "club" */
export type Club = {
  __typename?: 'club';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  exercise_club_mns: Array<Exercise_Club_Mn>;
  /** An aggregate relationship */
  exercise_club_mns_aggregate: Exercise_Club_Mn_Aggregate;
  id: Scalars['String'];
  name: Scalars['String'];
  owner_id: Scalars['String'];
  /** An array relationship */
  payments: Array<Payment>;
  /** An aggregate relationship */
  payments_aggregate: Payment_Aggregate;
  sport: Enum_Sport_Enum;
  /** An object relationship */
  sport_enum: Enum_Sport;
  /** An array relationship */
  teams: Array<Team>;
  /** An aggregate relationship */
  teams_aggregate: Team_Aggregate;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  /** An array relationship */
  user_permissions: Array<User_Permission>;
  /** An aggregate relationship */
  user_permissions_aggregate: User_Permission_Aggregate;
};


/** columns and relationships of "club" */
export type ClubExercise_Club_MnsArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Club_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Club_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Club_Mn_Bool_Exp>;
};


/** columns and relationships of "club" */
export type ClubExercise_Club_Mns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Club_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Club_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Club_Mn_Bool_Exp>;
};


/** columns and relationships of "club" */
export type ClubPaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "club" */
export type ClubPayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "club" */
export type ClubTeamsArgs = {
  distinct_on?: InputMaybe<Array<Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Order_By>>;
  where?: InputMaybe<Team_Bool_Exp>;
};


/** columns and relationships of "club" */
export type ClubTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Order_By>>;
  where?: InputMaybe<Team_Bool_Exp>;
};


/** columns and relationships of "club" */
export type ClubUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


/** columns and relationships of "club" */
export type ClubUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};

/** aggregated selection of "club" */
export type Club_Aggregate = {
  __typename?: 'club_aggregate';
  aggregate?: Maybe<Club_Aggregate_Fields>;
  nodes: Array<Club>;
};

/** aggregate fields of "club" */
export type Club_Aggregate_Fields = {
  __typename?: 'club_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Club_Max_Fields>;
  min?: Maybe<Club_Min_Fields>;
};


/** aggregate fields of "club" */
export type Club_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Club_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "club" */
export type Club_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Club_Max_Order_By>;
  min?: InputMaybe<Club_Min_Order_By>;
};

/** input type for inserting array relation for remote table "club" */
export type Club_Arr_Rel_Insert_Input = {
  data: Array<Club_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Club_On_Conflict>;
};

/** Boolean expression to filter rows from the table "club". All fields are combined with a logical 'AND'. */
export type Club_Bool_Exp = {
  _and?: InputMaybe<Array<Club_Bool_Exp>>;
  _not?: InputMaybe<Club_Bool_Exp>;
  _or?: InputMaybe<Array<Club_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  exercise_club_mns?: InputMaybe<Exercise_Club_Mn_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner_id?: InputMaybe<String_Comparison_Exp>;
  payments?: InputMaybe<Payment_Bool_Exp>;
  sport?: InputMaybe<Enum_Sport_Enum_Comparison_Exp>;
  sport_enum?: InputMaybe<Enum_Sport_Bool_Exp>;
  teams?: InputMaybe<Team_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_permissions?: InputMaybe<User_Permission_Bool_Exp>;
};

/** unique or primary key constraints on table "club" */
export enum Club_Constraint {
  /** unique or primary key constraint */
  ClubPkey = 'club_pkey'
}

/** input type for inserting data into table "club" */
export type Club_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  exercise_club_mns?: InputMaybe<Exercise_Club_Mn_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<Payment_Arr_Rel_Insert_Input>;
  sport?: InputMaybe<Enum_Sport_Enum>;
  sport_enum?: InputMaybe<Enum_Sport_Obj_Rel_Insert_Input>;
  teams?: InputMaybe<Team_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_permissions?: InputMaybe<User_Permission_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Club_Max_Fields = {
  __typename?: 'club_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "club" */
export type Club_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Club_Min_Fields = {
  __typename?: 'club_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "club" */
export type Club_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "club" */
export type Club_Mutation_Response = {
  __typename?: 'club_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Club>;
};

/** input type for inserting object relation for remote table "club" */
export type Club_Obj_Rel_Insert_Input = {
  data: Club_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Club_On_Conflict>;
};

/** on conflict condition type for table "club" */
export type Club_On_Conflict = {
  constraint: Club_Constraint;
  update_columns?: Array<Club_Update_Column>;
  where?: InputMaybe<Club_Bool_Exp>;
};

/** Ordering options when selecting data from "club". */
export type Club_Order_By = {
  created_at?: InputMaybe<Order_By>;
  exercise_club_mns_aggregate?: InputMaybe<Exercise_Club_Mn_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Order_By>;
  sport?: InputMaybe<Order_By>;
  sport_enum?: InputMaybe<Enum_Sport_Order_By>;
  teams_aggregate?: InputMaybe<Team_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_permissions_aggregate?: InputMaybe<User_Permission_Aggregate_Order_By>;
};

/** primary key columns input for table: club */
export type Club_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "club" */
export enum Club_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  Sport = 'sport',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "club" */
export type Club_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<Enum_Sport_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "club" */
export enum Club_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  Sport = 'sport',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "editor_type" */
export type Editor_Type = {
  __typename?: 'editor_type';
  name: Scalars['String'];
};

/** aggregated selection of "editor_type" */
export type Editor_Type_Aggregate = {
  __typename?: 'editor_type_aggregate';
  aggregate?: Maybe<Editor_Type_Aggregate_Fields>;
  nodes: Array<Editor_Type>;
};

/** aggregate fields of "editor_type" */
export type Editor_Type_Aggregate_Fields = {
  __typename?: 'editor_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Editor_Type_Max_Fields>;
  min?: Maybe<Editor_Type_Min_Fields>;
};


/** aggregate fields of "editor_type" */
export type Editor_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Editor_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "editor_type". All fields are combined with a logical 'AND'. */
export type Editor_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Editor_Type_Bool_Exp>>;
  _not?: InputMaybe<Editor_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Editor_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "editor_type" */
export enum Editor_Type_Constraint {
  /** unique or primary key constraint */
  ExerciseEditorTypePkey = 'exercise_editor_type_pkey'
}

/** input type for inserting data into table "editor_type" */
export type Editor_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Editor_Type_Max_Fields = {
  __typename?: 'editor_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Editor_Type_Min_Fields = {
  __typename?: 'editor_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "editor_type" */
export type Editor_Type_Mutation_Response = {
  __typename?: 'editor_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Editor_Type>;
};

/** on conflict condition type for table "editor_type" */
export type Editor_Type_On_Conflict = {
  constraint: Editor_Type_Constraint;
  update_columns?: Array<Editor_Type_Update_Column>;
  where?: InputMaybe<Editor_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "editor_type". */
export type Editor_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: editor_type */
export type Editor_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "editor_type" */
export enum Editor_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "editor_type" */
export type Editor_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "editor_type" */
export enum Editor_Type_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "enum_exercise_categories" */
export type Enum_Exercise_Categories = {
  __typename?: 'enum_exercise_categories';
  /** An array relationship */
  exercise_taxonomies: Array<Exercise_Taxonomy>;
  /** An aggregate relationship */
  exercise_taxonomies_aggregate: Exercise_Taxonomy_Aggregate;
  name: Scalars['String'];
};


/** columns and relationships of "enum_exercise_categories" */
export type Enum_Exercise_CategoriesExercise_TaxonomiesArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
};


/** columns and relationships of "enum_exercise_categories" */
export type Enum_Exercise_CategoriesExercise_Taxonomies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
};

/** aggregated selection of "enum_exercise_categories" */
export type Enum_Exercise_Categories_Aggregate = {
  __typename?: 'enum_exercise_categories_aggregate';
  aggregate?: Maybe<Enum_Exercise_Categories_Aggregate_Fields>;
  nodes: Array<Enum_Exercise_Categories>;
};

/** aggregate fields of "enum_exercise_categories" */
export type Enum_Exercise_Categories_Aggregate_Fields = {
  __typename?: 'enum_exercise_categories_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enum_Exercise_Categories_Max_Fields>;
  min?: Maybe<Enum_Exercise_Categories_Min_Fields>;
};


/** aggregate fields of "enum_exercise_categories" */
export type Enum_Exercise_Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Exercise_Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_exercise_categories". All fields are combined with a logical 'AND'. */
export type Enum_Exercise_Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Exercise_Categories_Bool_Exp>>;
  _not?: InputMaybe<Enum_Exercise_Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Exercise_Categories_Bool_Exp>>;
  exercise_taxonomies?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_exercise_categories" */
export enum Enum_Exercise_Categories_Constraint {
  /** unique or primary key constraint */
  EnumExerciseCategoriesPkey = 'enum_exercise_categories_pkey'
}

export enum Enum_Exercise_Categories_Enum {
  Age = 'age',
  ChipLabels = 'chip_labels',
  Focus = 'focus',
  Goalkeeper = 'goalkeeper',
  GroupSize = 'group_size',
  More = 'more',
  Phase = 'phase',
  Setter = 'setter',
  Tactics = 'tactics'
}

/** Boolean expression to compare columns of type "enum_exercise_categories_enum". All fields are combined with logical 'AND'. */
export type Enum_Exercise_Categories_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Exercise_Categories_Enum>;
  _in?: InputMaybe<Array<Enum_Exercise_Categories_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Enum_Exercise_Categories_Enum>;
  _nin?: InputMaybe<Array<Enum_Exercise_Categories_Enum>>;
};

/** input type for inserting data into table "enum_exercise_categories" */
export type Enum_Exercise_Categories_Insert_Input = {
  exercise_taxonomies?: InputMaybe<Exercise_Taxonomy_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Enum_Exercise_Categories_Max_Fields = {
  __typename?: 'enum_exercise_categories_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Enum_Exercise_Categories_Min_Fields = {
  __typename?: 'enum_exercise_categories_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_exercise_categories" */
export type Enum_Exercise_Categories_Mutation_Response = {
  __typename?: 'enum_exercise_categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Exercise_Categories>;
};

/** input type for inserting object relation for remote table "enum_exercise_categories" */
export type Enum_Exercise_Categories_Obj_Rel_Insert_Input = {
  data: Enum_Exercise_Categories_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Enum_Exercise_Categories_On_Conflict>;
};

/** on conflict condition type for table "enum_exercise_categories" */
export type Enum_Exercise_Categories_On_Conflict = {
  constraint: Enum_Exercise_Categories_Constraint;
  update_columns?: Array<Enum_Exercise_Categories_Update_Column>;
  where?: InputMaybe<Enum_Exercise_Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_exercise_categories". */
export type Enum_Exercise_Categories_Order_By = {
  exercise_taxonomies_aggregate?: InputMaybe<Exercise_Taxonomy_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_exercise_categories */
export type Enum_Exercise_Categories_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "enum_exercise_categories" */
export enum Enum_Exercise_Categories_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "enum_exercise_categories" */
export type Enum_Exercise_Categories_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_exercise_categories" */
export enum Enum_Exercise_Categories_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "enum_languages" */
export type Enum_Languages = {
  __typename?: 'enum_languages';
  name: Scalars['String'];
};

/** aggregated selection of "enum_languages" */
export type Enum_Languages_Aggregate = {
  __typename?: 'enum_languages_aggregate';
  aggregate?: Maybe<Enum_Languages_Aggregate_Fields>;
  nodes: Array<Enum_Languages>;
};

/** aggregate fields of "enum_languages" */
export type Enum_Languages_Aggregate_Fields = {
  __typename?: 'enum_languages_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enum_Languages_Max_Fields>;
  min?: Maybe<Enum_Languages_Min_Fields>;
};


/** aggregate fields of "enum_languages" */
export type Enum_Languages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Languages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_languages". All fields are combined with a logical 'AND'. */
export type Enum_Languages_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Languages_Bool_Exp>>;
  _not?: InputMaybe<Enum_Languages_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Languages_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_languages" */
export enum Enum_Languages_Constraint {
  /** unique or primary key constraint */
  EnumLanguagesPkey = 'enum_languages_pkey'
}

/** input type for inserting data into table "enum_languages" */
export type Enum_Languages_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Enum_Languages_Max_Fields = {
  __typename?: 'enum_languages_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Enum_Languages_Min_Fields = {
  __typename?: 'enum_languages_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_languages" */
export type Enum_Languages_Mutation_Response = {
  __typename?: 'enum_languages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Languages>;
};

/** on conflict condition type for table "enum_languages" */
export type Enum_Languages_On_Conflict = {
  constraint: Enum_Languages_Constraint;
  update_columns?: Array<Enum_Languages_Update_Column>;
  where?: InputMaybe<Enum_Languages_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_languages". */
export type Enum_Languages_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_languages */
export type Enum_Languages_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "enum_languages" */
export enum Enum_Languages_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "enum_languages" */
export type Enum_Languages_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_languages" */
export enum Enum_Languages_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "enum_sport" */
export type Enum_Sport = {
  __typename?: 'enum_sport';
  /** An array relationship */
  clubs: Array<Club>;
  /** An aggregate relationship */
  clubs_aggregate: Club_Aggregate;
  /** An array relationship */
  exercise_taxonomies: Array<Exercise_Taxonomy>;
  /** An aggregate relationship */
  exercise_taxonomies_aggregate: Exercise_Taxonomy_Aggregate;
  name: Scalars['String'];
};


/** columns and relationships of "enum_sport" */
export type Enum_SportClubsArgs = {
  distinct_on?: InputMaybe<Array<Club_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Club_Order_By>>;
  where?: InputMaybe<Club_Bool_Exp>;
};


/** columns and relationships of "enum_sport" */
export type Enum_SportClubs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Club_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Club_Order_By>>;
  where?: InputMaybe<Club_Bool_Exp>;
};


/** columns and relationships of "enum_sport" */
export type Enum_SportExercise_TaxonomiesArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
};


/** columns and relationships of "enum_sport" */
export type Enum_SportExercise_Taxonomies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
};

/** aggregated selection of "enum_sport" */
export type Enum_Sport_Aggregate = {
  __typename?: 'enum_sport_aggregate';
  aggregate?: Maybe<Enum_Sport_Aggregate_Fields>;
  nodes: Array<Enum_Sport>;
};

/** aggregate fields of "enum_sport" */
export type Enum_Sport_Aggregate_Fields = {
  __typename?: 'enum_sport_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Enum_Sport_Max_Fields>;
  min?: Maybe<Enum_Sport_Min_Fields>;
};


/** aggregate fields of "enum_sport" */
export type Enum_Sport_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enum_Sport_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "enum_sport". All fields are combined with a logical 'AND'. */
export type Enum_Sport_Bool_Exp = {
  _and?: InputMaybe<Array<Enum_Sport_Bool_Exp>>;
  _not?: InputMaybe<Enum_Sport_Bool_Exp>;
  _or?: InputMaybe<Array<Enum_Sport_Bool_Exp>>;
  clubs?: InputMaybe<Club_Bool_Exp>;
  exercise_taxonomies?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "enum_sport" */
export enum Enum_Sport_Constraint {
  /** unique or primary key constraint */
  SportPkey = 'sport_pkey'
}

export enum Enum_Sport_Enum {
  FieldHockey = 'FIELD_HOCKEY',
  Handball = 'HANDBALL',
  Soccer = 'SOCCER',
  Volleyball = 'VOLLEYBALL'
}

/** Boolean expression to compare columns of type "enum_sport_enum". All fields are combined with logical 'AND'. */
export type Enum_Sport_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enum_Sport_Enum>;
  _in?: InputMaybe<Array<Enum_Sport_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Enum_Sport_Enum>;
  _nin?: InputMaybe<Array<Enum_Sport_Enum>>;
};

/** input type for inserting data into table "enum_sport" */
export type Enum_Sport_Insert_Input = {
  clubs?: InputMaybe<Club_Arr_Rel_Insert_Input>;
  exercise_taxonomies?: InputMaybe<Exercise_Taxonomy_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Enum_Sport_Max_Fields = {
  __typename?: 'enum_sport_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Enum_Sport_Min_Fields = {
  __typename?: 'enum_sport_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "enum_sport" */
export type Enum_Sport_Mutation_Response = {
  __typename?: 'enum_sport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Enum_Sport>;
};

/** input type for inserting object relation for remote table "enum_sport" */
export type Enum_Sport_Obj_Rel_Insert_Input = {
  data: Enum_Sport_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Enum_Sport_On_Conflict>;
};

/** on conflict condition type for table "enum_sport" */
export type Enum_Sport_On_Conflict = {
  constraint: Enum_Sport_Constraint;
  update_columns?: Array<Enum_Sport_Update_Column>;
  where?: InputMaybe<Enum_Sport_Bool_Exp>;
};

/** Ordering options when selecting data from "enum_sport". */
export type Enum_Sport_Order_By = {
  clubs_aggregate?: InputMaybe<Club_Aggregate_Order_By>;
  exercise_taxonomies_aggregate?: InputMaybe<Exercise_Taxonomy_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enum_sport */
export type Enum_Sport_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "enum_sport" */
export enum Enum_Sport_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "enum_sport" */
export type Enum_Sport_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "enum_sport" */
export enum Enum_Sport_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "exercise" */
export type Exercise = {
  __typename?: 'exercise';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  exercise_club_mns: Array<Exercise_Club_Mn>;
  /** An aggregate relationship */
  exercise_club_mns_aggregate: Exercise_Club_Mn_Aggregate;
  /** An array relationship */
  exercise_content_media_mns: Array<Exercise_Content_Media_Mn>;
  /** An aggregate relationship */
  exercise_content_media_mns_aggregate: Exercise_Content_Media_Mn_Aggregate;
  /** An array relationship */
  exercise_taxonomy_mns: Array<Exercise_Taxonomy_Mn>;
  /** An aggregate relationship */
  exercise_taxonomy_mns_aggregate: Exercise_Taxonomy_Mn_Aggregate;
  fitness_stars: Scalars['Int'];
  id: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  owner_id: Scalars['String'];
  tactics_stars: Scalars['Int'];
  technique_stars: Scalars['Int'];
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "exercise" */
export type ExerciseExercise_Club_MnsArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Club_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Club_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Club_Mn_Bool_Exp>;
};


/** columns and relationships of "exercise" */
export type ExerciseExercise_Club_Mns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Club_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Club_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Club_Mn_Bool_Exp>;
};


/** columns and relationships of "exercise" */
export type ExerciseExercise_Content_Media_MnsArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Mn_Bool_Exp>;
};


/** columns and relationships of "exercise" */
export type ExerciseExercise_Content_Media_Mns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Mn_Bool_Exp>;
};


/** columns and relationships of "exercise" */
export type ExerciseExercise_Taxonomy_MnsArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Mn_Bool_Exp>;
};


/** columns and relationships of "exercise" */
export type ExerciseExercise_Taxonomy_Mns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Mn_Bool_Exp>;
};

/** aggregated selection of "exercise" */
export type Exercise_Aggregate = {
  __typename?: 'exercise_aggregate';
  aggregate?: Maybe<Exercise_Aggregate_Fields>;
  nodes: Array<Exercise>;
};

/** aggregate fields of "exercise" */
export type Exercise_Aggregate_Fields = {
  __typename?: 'exercise_aggregate_fields';
  avg?: Maybe<Exercise_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Exercise_Max_Fields>;
  min?: Maybe<Exercise_Min_Fields>;
  stddev?: Maybe<Exercise_Stddev_Fields>;
  stddev_pop?: Maybe<Exercise_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Exercise_Stddev_Samp_Fields>;
  sum?: Maybe<Exercise_Sum_Fields>;
  var_pop?: Maybe<Exercise_Var_Pop_Fields>;
  var_samp?: Maybe<Exercise_Var_Samp_Fields>;
  variance?: Maybe<Exercise_Variance_Fields>;
};


/** aggregate fields of "exercise" */
export type Exercise_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Exercise_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exercise" */
export type Exercise_Aggregate_Order_By = {
  avg?: InputMaybe<Exercise_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Exercise_Max_Order_By>;
  min?: InputMaybe<Exercise_Min_Order_By>;
  stddev?: InputMaybe<Exercise_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Exercise_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Exercise_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Exercise_Sum_Order_By>;
  var_pop?: InputMaybe<Exercise_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Exercise_Var_Samp_Order_By>;
  variance?: InputMaybe<Exercise_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "exercise" */
export type Exercise_Arr_Rel_Insert_Input = {
  data: Array<Exercise_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exercise_On_Conflict>;
};

/** aggregate avg on columns */
export type Exercise_Avg_Fields = {
  __typename?: 'exercise_avg_fields';
  fitness_stars?: Maybe<Scalars['Float']>;
  tactics_stars?: Maybe<Scalars['Float']>;
  technique_stars?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "exercise" */
export type Exercise_Avg_Order_By = {
  fitness_stars?: InputMaybe<Order_By>;
  tactics_stars?: InputMaybe<Order_By>;
  technique_stars?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "exercise". All fields are combined with a logical 'AND'. */
export type Exercise_Bool_Exp = {
  _and?: InputMaybe<Array<Exercise_Bool_Exp>>;
  _not?: InputMaybe<Exercise_Bool_Exp>;
  _or?: InputMaybe<Array<Exercise_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  exercise_club_mns?: InputMaybe<Exercise_Club_Mn_Bool_Exp>;
  exercise_content_media_mns?: InputMaybe<Exercise_Content_Media_Mn_Bool_Exp>;
  exercise_taxonomy_mns?: InputMaybe<Exercise_Taxonomy_Mn_Bool_Exp>;
  fitness_stars?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  owner_id?: InputMaybe<String_Comparison_Exp>;
  tactics_stars?: InputMaybe<Int_Comparison_Exp>;
  technique_stars?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** columns and relationships of "exercise_club_mn" */
export type Exercise_Club_Mn = {
  __typename?: 'exercise_club_mn';
  /** An object relationship */
  club: Club;
  club_id: Scalars['String'];
  /** An object relationship */
  exercise: Exercise;
  exercise_id: Scalars['String'];
};

/** aggregated selection of "exercise_club_mn" */
export type Exercise_Club_Mn_Aggregate = {
  __typename?: 'exercise_club_mn_aggregate';
  aggregate?: Maybe<Exercise_Club_Mn_Aggregate_Fields>;
  nodes: Array<Exercise_Club_Mn>;
};

/** aggregate fields of "exercise_club_mn" */
export type Exercise_Club_Mn_Aggregate_Fields = {
  __typename?: 'exercise_club_mn_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Exercise_Club_Mn_Max_Fields>;
  min?: Maybe<Exercise_Club_Mn_Min_Fields>;
};


/** aggregate fields of "exercise_club_mn" */
export type Exercise_Club_Mn_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Exercise_Club_Mn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exercise_club_mn" */
export type Exercise_Club_Mn_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Exercise_Club_Mn_Max_Order_By>;
  min?: InputMaybe<Exercise_Club_Mn_Min_Order_By>;
};

/** input type for inserting array relation for remote table "exercise_club_mn" */
export type Exercise_Club_Mn_Arr_Rel_Insert_Input = {
  data: Array<Exercise_Club_Mn_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exercise_Club_Mn_On_Conflict>;
};

/** Boolean expression to filter rows from the table "exercise_club_mn". All fields are combined with a logical 'AND'. */
export type Exercise_Club_Mn_Bool_Exp = {
  _and?: InputMaybe<Array<Exercise_Club_Mn_Bool_Exp>>;
  _not?: InputMaybe<Exercise_Club_Mn_Bool_Exp>;
  _or?: InputMaybe<Array<Exercise_Club_Mn_Bool_Exp>>;
  club?: InputMaybe<Club_Bool_Exp>;
  club_id?: InputMaybe<String_Comparison_Exp>;
  exercise?: InputMaybe<Exercise_Bool_Exp>;
  exercise_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "exercise_club_mn" */
export enum Exercise_Club_Mn_Constraint {
  /** unique or primary key constraint */
  ExerciseClubMnPkey = 'exercise_club_mn_pkey'
}

/** input type for inserting data into table "exercise_club_mn" */
export type Exercise_Club_Mn_Insert_Input = {
  club?: InputMaybe<Club_Obj_Rel_Insert_Input>;
  club_id?: InputMaybe<Scalars['String']>;
  exercise?: InputMaybe<Exercise_Obj_Rel_Insert_Input>;
  exercise_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Exercise_Club_Mn_Max_Fields = {
  __typename?: 'exercise_club_mn_max_fields';
  club_id?: Maybe<Scalars['String']>;
  exercise_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "exercise_club_mn" */
export type Exercise_Club_Mn_Max_Order_By = {
  club_id?: InputMaybe<Order_By>;
  exercise_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Exercise_Club_Mn_Min_Fields = {
  __typename?: 'exercise_club_mn_min_fields';
  club_id?: Maybe<Scalars['String']>;
  exercise_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "exercise_club_mn" */
export type Exercise_Club_Mn_Min_Order_By = {
  club_id?: InputMaybe<Order_By>;
  exercise_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "exercise_club_mn" */
export type Exercise_Club_Mn_Mutation_Response = {
  __typename?: 'exercise_club_mn_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Exercise_Club_Mn>;
};

/** on conflict condition type for table "exercise_club_mn" */
export type Exercise_Club_Mn_On_Conflict = {
  constraint: Exercise_Club_Mn_Constraint;
  update_columns?: Array<Exercise_Club_Mn_Update_Column>;
  where?: InputMaybe<Exercise_Club_Mn_Bool_Exp>;
};

/** Ordering options when selecting data from "exercise_club_mn". */
export type Exercise_Club_Mn_Order_By = {
  club?: InputMaybe<Club_Order_By>;
  club_id?: InputMaybe<Order_By>;
  exercise?: InputMaybe<Exercise_Order_By>;
  exercise_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exercise_club_mn */
export type Exercise_Club_Mn_Pk_Columns_Input = {
  club_id: Scalars['String'];
  exercise_id: Scalars['String'];
};

/** select columns of table "exercise_club_mn" */
export enum Exercise_Club_Mn_Select_Column {
  /** column name */
  ClubId = 'club_id',
  /** column name */
  ExerciseId = 'exercise_id'
}

/** input type for updating data in table "exercise_club_mn" */
export type Exercise_Club_Mn_Set_Input = {
  club_id?: InputMaybe<Scalars['String']>;
  exercise_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "exercise_club_mn" */
export enum Exercise_Club_Mn_Update_Column {
  /** column name */
  ClubId = 'club_id',
  /** column name */
  ExerciseId = 'exercise_id'
}

/** unique or primary key constraints on table "exercise" */
export enum Exercise_Constraint {
  /** unique or primary key constraint */
  ExercisePkey = 'exercise_pkey'
}

/** columns and relationships of "exercise_content_media" */
export type Exercise_Content_Media = {
  __typename?: 'exercise_content_media';
  created_at?: Maybe<Scalars['timestamptz']>;
  editor_animation_id?: Maybe<Scalars['String']>;
  editor_image_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  exercise_content_media_editor?: Maybe<Exercise_Content_Media_Editor>;
  /** An array relationship */
  exercise_content_media_mns: Array<Exercise_Content_Media_Mn>;
  /** An aggregate relationship */
  exercise_content_media_mns_aggregate: Exercise_Content_Media_Mn_Aggregate;
  /** An object relationship */
  exercise_content_media_type: Exercise_Content_Media_Type;
  id: Scalars['String'];
  is_media_right?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  s3_file?: Maybe<S3_File>;
  s3_file_id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type: Exercise_Content_Media_Type_Enum;
  updated_at?: Maybe<Scalars['timestamptz']>;
  video_url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "exercise_content_media" */
export type Exercise_Content_MediaExercise_Content_Media_MnsArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Mn_Bool_Exp>;
};


/** columns and relationships of "exercise_content_media" */
export type Exercise_Content_MediaExercise_Content_Media_Mns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Mn_Bool_Exp>;
};

/** aggregated selection of "exercise_content_media" */
export type Exercise_Content_Media_Aggregate = {
  __typename?: 'exercise_content_media_aggregate';
  aggregate?: Maybe<Exercise_Content_Media_Aggregate_Fields>;
  nodes: Array<Exercise_Content_Media>;
};

/** aggregate fields of "exercise_content_media" */
export type Exercise_Content_Media_Aggregate_Fields = {
  __typename?: 'exercise_content_media_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Exercise_Content_Media_Max_Fields>;
  min?: Maybe<Exercise_Content_Media_Min_Fields>;
};


/** aggregate fields of "exercise_content_media" */
export type Exercise_Content_Media_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Exercise_Content_Media_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exercise_content_media" */
export type Exercise_Content_Media_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Exercise_Content_Media_Max_Order_By>;
  min?: InputMaybe<Exercise_Content_Media_Min_Order_By>;
};

/** input type for inserting array relation for remote table "exercise_content_media" */
export type Exercise_Content_Media_Arr_Rel_Insert_Input = {
  data: Array<Exercise_Content_Media_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exercise_Content_Media_On_Conflict>;
};

/** Boolean expression to filter rows from the table "exercise_content_media". All fields are combined with a logical 'AND'. */
export type Exercise_Content_Media_Bool_Exp = {
  _and?: InputMaybe<Array<Exercise_Content_Media_Bool_Exp>>;
  _not?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
  _or?: InputMaybe<Array<Exercise_Content_Media_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  editor_animation_id?: InputMaybe<String_Comparison_Exp>;
  editor_image_id?: InputMaybe<String_Comparison_Exp>;
  exercise_content_media_editor?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
  exercise_content_media_mns?: InputMaybe<Exercise_Content_Media_Mn_Bool_Exp>;
  exercise_content_media_type?: InputMaybe<Exercise_Content_Media_Type_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_media_right?: InputMaybe<Boolean_Comparison_Exp>;
  s3_file?: InputMaybe<S3_File_Bool_Exp>;
  s3_file_id?: InputMaybe<String_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Exercise_Content_Media_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  video_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "exercise_content_media" */
export enum Exercise_Content_Media_Constraint {
  /** unique or primary key constraint */
  ExerciseContentMediaEditorAnimationIdKey = 'exercise_content_media_editor_animation_id_key',
  /** unique or primary key constraint */
  ExerciseContentMediaEditorImageIdKey = 'exercise_content_media_editor_image_id_key',
  /** unique or primary key constraint */
  ExerciseContentMediaPkey = 'exercise_content_media_pkey'
}

/** columns and relationships of "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor = {
  __typename?: 'exercise_content_media_editor';
  content_media_id: Scalars['String'];
  editor_data?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  exercise_content_media?: Maybe<Exercise_Content_Media>;
  id: Scalars['String'];
  image_s3_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  s3_file_image?: Maybe<S3_File>;
  /** An object relationship */
  s3_file_video?: Maybe<S3_File>;
  video_s3_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "exercise_content_media_editor" */
export type Exercise_Content_Media_EditorEditor_DataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor_Aggregate = {
  __typename?: 'exercise_content_media_editor_aggregate';
  aggregate?: Maybe<Exercise_Content_Media_Editor_Aggregate_Fields>;
  nodes: Array<Exercise_Content_Media_Editor>;
};

/** aggregate fields of "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor_Aggregate_Fields = {
  __typename?: 'exercise_content_media_editor_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Exercise_Content_Media_Editor_Max_Fields>;
  min?: Maybe<Exercise_Content_Media_Editor_Min_Fields>;
};


/** aggregate fields of "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Exercise_Content_Media_Editor_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Exercise_Content_Media_Editor_Max_Order_By>;
  min?: InputMaybe<Exercise_Content_Media_Editor_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Exercise_Content_Media_Editor_Append_Input = {
  editor_data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor_Arr_Rel_Insert_Input = {
  data: Array<Exercise_Content_Media_Editor_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exercise_Content_Media_Editor_On_Conflict>;
};

/** Boolean expression to filter rows from the table "exercise_content_media_editor". All fields are combined with a logical 'AND'. */
export type Exercise_Content_Media_Editor_Bool_Exp = {
  _and?: InputMaybe<Array<Exercise_Content_Media_Editor_Bool_Exp>>;
  _not?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
  _or?: InputMaybe<Array<Exercise_Content_Media_Editor_Bool_Exp>>;
  content_media_id?: InputMaybe<String_Comparison_Exp>;
  editor_data?: InputMaybe<Jsonb_Comparison_Exp>;
  exercise_content_media?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  image_s3_id?: InputMaybe<String_Comparison_Exp>;
  s3_file_image?: InputMaybe<S3_File_Bool_Exp>;
  s3_file_video?: InputMaybe<S3_File_Bool_Exp>;
  video_s3_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "exercise_content_media_editor" */
export enum Exercise_Content_Media_Editor_Constraint {
  /** unique or primary key constraint */
  ExerciseContentMediaEditorAnimationContentMediaIdKey = 'exercise_content_media_editor_animation_content_media_id_key',
  /** unique or primary key constraint */
  ExerciseContentMediaEditorAnimationPkey = 'exercise_content_media_editor_animation_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Exercise_Content_Media_Editor_Delete_At_Path_Input = {
  editor_data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Exercise_Content_Media_Editor_Delete_Elem_Input = {
  editor_data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Exercise_Content_Media_Editor_Delete_Key_Input = {
  editor_data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor_Insert_Input = {
  content_media_id?: InputMaybe<Scalars['String']>;
  editor_data?: InputMaybe<Scalars['jsonb']>;
  exercise_content_media?: InputMaybe<Exercise_Content_Media_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  image_s3_id?: InputMaybe<Scalars['String']>;
  s3_file_image?: InputMaybe<S3_File_Obj_Rel_Insert_Input>;
  s3_file_video?: InputMaybe<S3_File_Obj_Rel_Insert_Input>;
  video_s3_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Exercise_Content_Media_Editor_Max_Fields = {
  __typename?: 'exercise_content_media_editor_max_fields';
  content_media_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_s3_id?: Maybe<Scalars['String']>;
  video_s3_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor_Max_Order_By = {
  content_media_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_s3_id?: InputMaybe<Order_By>;
  video_s3_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Exercise_Content_Media_Editor_Min_Fields = {
  __typename?: 'exercise_content_media_editor_min_fields';
  content_media_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image_s3_id?: Maybe<Scalars['String']>;
  video_s3_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor_Min_Order_By = {
  content_media_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_s3_id?: InputMaybe<Order_By>;
  video_s3_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor_Mutation_Response = {
  __typename?: 'exercise_content_media_editor_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Exercise_Content_Media_Editor>;
};

/** input type for inserting object relation for remote table "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor_Obj_Rel_Insert_Input = {
  data: Exercise_Content_Media_Editor_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exercise_Content_Media_Editor_On_Conflict>;
};

/** on conflict condition type for table "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor_On_Conflict = {
  constraint: Exercise_Content_Media_Editor_Constraint;
  update_columns?: Array<Exercise_Content_Media_Editor_Update_Column>;
  where?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
};

/** Ordering options when selecting data from "exercise_content_media_editor". */
export type Exercise_Content_Media_Editor_Order_By = {
  content_media_id?: InputMaybe<Order_By>;
  editor_data?: InputMaybe<Order_By>;
  exercise_content_media?: InputMaybe<Exercise_Content_Media_Order_By>;
  id?: InputMaybe<Order_By>;
  image_s3_id?: InputMaybe<Order_By>;
  s3_file_image?: InputMaybe<S3_File_Order_By>;
  s3_file_video?: InputMaybe<S3_File_Order_By>;
  video_s3_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exercise_content_media_editor */
export type Exercise_Content_Media_Editor_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Exercise_Content_Media_Editor_Prepend_Input = {
  editor_data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "exercise_content_media_editor" */
export enum Exercise_Content_Media_Editor_Select_Column {
  /** column name */
  ContentMediaId = 'content_media_id',
  /** column name */
  EditorData = 'editor_data',
  /** column name */
  Id = 'id',
  /** column name */
  ImageS3Id = 'image_s3_id',
  /** column name */
  VideoS3Id = 'video_s3_id'
}

/** input type for updating data in table "exercise_content_media_editor" */
export type Exercise_Content_Media_Editor_Set_Input = {
  content_media_id?: InputMaybe<Scalars['String']>;
  editor_data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  image_s3_id?: InputMaybe<Scalars['String']>;
  video_s3_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "exercise_content_media_editor" */
export enum Exercise_Content_Media_Editor_Update_Column {
  /** column name */
  ContentMediaId = 'content_media_id',
  /** column name */
  EditorData = 'editor_data',
  /** column name */
  Id = 'id',
  /** column name */
  ImageS3Id = 'image_s3_id',
  /** column name */
  VideoS3Id = 'video_s3_id'
}

/** input type for inserting data into table "exercise_content_media" */
export type Exercise_Content_Media_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  editor_animation_id?: InputMaybe<Scalars['String']>;
  editor_image_id?: InputMaybe<Scalars['String']>;
  exercise_content_media_editor?: InputMaybe<Exercise_Content_Media_Editor_Obj_Rel_Insert_Input>;
  exercise_content_media_mns?: InputMaybe<Exercise_Content_Media_Mn_Arr_Rel_Insert_Input>;
  exercise_content_media_type?: InputMaybe<Exercise_Content_Media_Type_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  is_media_right?: InputMaybe<Scalars['Boolean']>;
  s3_file?: InputMaybe<S3_File_Obj_Rel_Insert_Input>;
  s3_file_id?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Exercise_Content_Media_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  video_url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Exercise_Content_Media_Max_Fields = {
  __typename?: 'exercise_content_media_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  editor_animation_id?: Maybe<Scalars['String']>;
  editor_image_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  s3_file_id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  video_url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "exercise_content_media" */
export type Exercise_Content_Media_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  editor_animation_id?: InputMaybe<Order_By>;
  editor_image_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  s3_file_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Exercise_Content_Media_Min_Fields = {
  __typename?: 'exercise_content_media_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  editor_animation_id?: Maybe<Scalars['String']>;
  editor_image_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  s3_file_id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  video_url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "exercise_content_media" */
export type Exercise_Content_Media_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  editor_animation_id?: InputMaybe<Order_By>;
  editor_image_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  s3_file_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
};

/** columns and relationships of "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn = {
  __typename?: 'exercise_content_media_mn';
  /** An object relationship */
  exercise: Exercise;
  /** An object relationship */
  exercise_content_media: Exercise_Content_Media;
  exercise_content_media_id: Scalars['String'];
  exercise_id: Scalars['String'];
  sort?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Aggregate = {
  __typename?: 'exercise_content_media_mn_aggregate';
  aggregate?: Maybe<Exercise_Content_Media_Mn_Aggregate_Fields>;
  nodes: Array<Exercise_Content_Media_Mn>;
};

/** aggregate fields of "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Aggregate_Fields = {
  __typename?: 'exercise_content_media_mn_aggregate_fields';
  avg?: Maybe<Exercise_Content_Media_Mn_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Exercise_Content_Media_Mn_Max_Fields>;
  min?: Maybe<Exercise_Content_Media_Mn_Min_Fields>;
  stddev?: Maybe<Exercise_Content_Media_Mn_Stddev_Fields>;
  stddev_pop?: Maybe<Exercise_Content_Media_Mn_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Exercise_Content_Media_Mn_Stddev_Samp_Fields>;
  sum?: Maybe<Exercise_Content_Media_Mn_Sum_Fields>;
  var_pop?: Maybe<Exercise_Content_Media_Mn_Var_Pop_Fields>;
  var_samp?: Maybe<Exercise_Content_Media_Mn_Var_Samp_Fields>;
  variance?: Maybe<Exercise_Content_Media_Mn_Variance_Fields>;
};


/** aggregate fields of "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Exercise_Content_Media_Mn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Aggregate_Order_By = {
  avg?: InputMaybe<Exercise_Content_Media_Mn_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Exercise_Content_Media_Mn_Max_Order_By>;
  min?: InputMaybe<Exercise_Content_Media_Mn_Min_Order_By>;
  stddev?: InputMaybe<Exercise_Content_Media_Mn_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Exercise_Content_Media_Mn_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Exercise_Content_Media_Mn_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Exercise_Content_Media_Mn_Sum_Order_By>;
  var_pop?: InputMaybe<Exercise_Content_Media_Mn_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Exercise_Content_Media_Mn_Var_Samp_Order_By>;
  variance?: InputMaybe<Exercise_Content_Media_Mn_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Arr_Rel_Insert_Input = {
  data: Array<Exercise_Content_Media_Mn_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exercise_Content_Media_Mn_On_Conflict>;
};

/** aggregate avg on columns */
export type Exercise_Content_Media_Mn_Avg_Fields = {
  __typename?: 'exercise_content_media_mn_avg_fields';
  sort?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Avg_Order_By = {
  sort?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "exercise_content_media_mn". All fields are combined with a logical 'AND'. */
export type Exercise_Content_Media_Mn_Bool_Exp = {
  _and?: InputMaybe<Array<Exercise_Content_Media_Mn_Bool_Exp>>;
  _not?: InputMaybe<Exercise_Content_Media_Mn_Bool_Exp>;
  _or?: InputMaybe<Array<Exercise_Content_Media_Mn_Bool_Exp>>;
  exercise?: InputMaybe<Exercise_Bool_Exp>;
  exercise_content_media?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
  exercise_content_media_id?: InputMaybe<String_Comparison_Exp>;
  exercise_id?: InputMaybe<String_Comparison_Exp>;
  sort?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "exercise_content_media_mn" */
export enum Exercise_Content_Media_Mn_Constraint {
  /** unique or primary key constraint */
  ExerciseContentMediaMnExerciseIdExerciseContentMediaId = 'exercise_content_media_mn_exercise_id_exercise_content_media_id',
  /** unique or primary key constraint */
  ExerciseContentMediaMnPkey = 'exercise_content_media_mn_pkey'
}

/** input type for incrementing numeric columns in table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Inc_Input = {
  sort?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Insert_Input = {
  exercise?: InputMaybe<Exercise_Obj_Rel_Insert_Input>;
  exercise_content_media?: InputMaybe<Exercise_Content_Media_Obj_Rel_Insert_Input>;
  exercise_content_media_id?: InputMaybe<Scalars['String']>;
  exercise_id?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Exercise_Content_Media_Mn_Max_Fields = {
  __typename?: 'exercise_content_media_mn_max_fields';
  exercise_content_media_id?: Maybe<Scalars['String']>;
  exercise_id?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Max_Order_By = {
  exercise_content_media_id?: InputMaybe<Order_By>;
  exercise_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Exercise_Content_Media_Mn_Min_Fields = {
  __typename?: 'exercise_content_media_mn_min_fields';
  exercise_content_media_id?: Maybe<Scalars['String']>;
  exercise_id?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Min_Order_By = {
  exercise_content_media_id?: InputMaybe<Order_By>;
  exercise_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Mutation_Response = {
  __typename?: 'exercise_content_media_mn_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Exercise_Content_Media_Mn>;
};

/** on conflict condition type for table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_On_Conflict = {
  constraint: Exercise_Content_Media_Mn_Constraint;
  update_columns?: Array<Exercise_Content_Media_Mn_Update_Column>;
  where?: InputMaybe<Exercise_Content_Media_Mn_Bool_Exp>;
};

/** Ordering options when selecting data from "exercise_content_media_mn". */
export type Exercise_Content_Media_Mn_Order_By = {
  exercise?: InputMaybe<Exercise_Order_By>;
  exercise_content_media?: InputMaybe<Exercise_Content_Media_Order_By>;
  exercise_content_media_id?: InputMaybe<Order_By>;
  exercise_id?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exercise_content_media_mn */
export type Exercise_Content_Media_Mn_Pk_Columns_Input = {
  exercise_content_media_id: Scalars['String'];
  exercise_id: Scalars['String'];
};

/** select columns of table "exercise_content_media_mn" */
export enum Exercise_Content_Media_Mn_Select_Column {
  /** column name */
  ExerciseContentMediaId = 'exercise_content_media_id',
  /** column name */
  ExerciseId = 'exercise_id',
  /** column name */
  Sort = 'sort'
}

/** input type for updating data in table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Set_Input = {
  exercise_content_media_id?: InputMaybe<Scalars['String']>;
  exercise_id?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Exercise_Content_Media_Mn_Stddev_Fields = {
  __typename?: 'exercise_content_media_mn_stddev_fields';
  sort?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Stddev_Order_By = {
  sort?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Exercise_Content_Media_Mn_Stddev_Pop_Fields = {
  __typename?: 'exercise_content_media_mn_stddev_pop_fields';
  sort?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Stddev_Pop_Order_By = {
  sort?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Exercise_Content_Media_Mn_Stddev_Samp_Fields = {
  __typename?: 'exercise_content_media_mn_stddev_samp_fields';
  sort?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Stddev_Samp_Order_By = {
  sort?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Exercise_Content_Media_Mn_Sum_Fields = {
  __typename?: 'exercise_content_media_mn_sum_fields';
  sort?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Sum_Order_By = {
  sort?: InputMaybe<Order_By>;
};

/** update columns of table "exercise_content_media_mn" */
export enum Exercise_Content_Media_Mn_Update_Column {
  /** column name */
  ExerciseContentMediaId = 'exercise_content_media_id',
  /** column name */
  ExerciseId = 'exercise_id',
  /** column name */
  Sort = 'sort'
}

/** aggregate var_pop on columns */
export type Exercise_Content_Media_Mn_Var_Pop_Fields = {
  __typename?: 'exercise_content_media_mn_var_pop_fields';
  sort?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Var_Pop_Order_By = {
  sort?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Exercise_Content_Media_Mn_Var_Samp_Fields = {
  __typename?: 'exercise_content_media_mn_var_samp_fields';
  sort?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Var_Samp_Order_By = {
  sort?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Exercise_Content_Media_Mn_Variance_Fields = {
  __typename?: 'exercise_content_media_mn_variance_fields';
  sort?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "exercise_content_media_mn" */
export type Exercise_Content_Media_Mn_Variance_Order_By = {
  sort?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "exercise_content_media" */
export type Exercise_Content_Media_Mutation_Response = {
  __typename?: 'exercise_content_media_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Exercise_Content_Media>;
};

/** input type for inserting object relation for remote table "exercise_content_media" */
export type Exercise_Content_Media_Obj_Rel_Insert_Input = {
  data: Exercise_Content_Media_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exercise_Content_Media_On_Conflict>;
};

/** on conflict condition type for table "exercise_content_media" */
export type Exercise_Content_Media_On_Conflict = {
  constraint: Exercise_Content_Media_Constraint;
  update_columns?: Array<Exercise_Content_Media_Update_Column>;
  where?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
};

/** Ordering options when selecting data from "exercise_content_media". */
export type Exercise_Content_Media_Order_By = {
  created_at?: InputMaybe<Order_By>;
  editor_animation_id?: InputMaybe<Order_By>;
  editor_image_id?: InputMaybe<Order_By>;
  exercise_content_media_editor?: InputMaybe<Exercise_Content_Media_Editor_Order_By>;
  exercise_content_media_mns_aggregate?: InputMaybe<Exercise_Content_Media_Mn_Aggregate_Order_By>;
  exercise_content_media_type?: InputMaybe<Exercise_Content_Media_Type_Order_By>;
  id?: InputMaybe<Order_By>;
  is_media_right?: InputMaybe<Order_By>;
  s3_file?: InputMaybe<S3_File_Order_By>;
  s3_file_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exercise_content_media */
export type Exercise_Content_Media_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "exercise_content_media" */
export enum Exercise_Content_Media_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EditorAnimationId = 'editor_animation_id',
  /** column name */
  EditorImageId = 'editor_image_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsMediaRight = 'is_media_right',
  /** column name */
  S3FileId = 's3_file_id',
  /** column name */
  Text = 'text',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VideoUrl = 'video_url'
}

/** input type for updating data in table "exercise_content_media" */
export type Exercise_Content_Media_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  editor_animation_id?: InputMaybe<Scalars['String']>;
  editor_image_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  is_media_right?: InputMaybe<Scalars['Boolean']>;
  s3_file_id?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Exercise_Content_Media_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  video_url?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "exercise_content_media_type" */
export type Exercise_Content_Media_Type = {
  __typename?: 'exercise_content_media_type';
  /** An array relationship */
  exercise_content_media: Array<Exercise_Content_Media>;
  /** An aggregate relationship */
  exercise_content_media_aggregate: Exercise_Content_Media_Aggregate;
  name: Scalars['String'];
};


/** columns and relationships of "exercise_content_media_type" */
export type Exercise_Content_Media_TypeExercise_Content_MediaArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
};


/** columns and relationships of "exercise_content_media_type" */
export type Exercise_Content_Media_TypeExercise_Content_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
};

/** aggregated selection of "exercise_content_media_type" */
export type Exercise_Content_Media_Type_Aggregate = {
  __typename?: 'exercise_content_media_type_aggregate';
  aggregate?: Maybe<Exercise_Content_Media_Type_Aggregate_Fields>;
  nodes: Array<Exercise_Content_Media_Type>;
};

/** aggregate fields of "exercise_content_media_type" */
export type Exercise_Content_Media_Type_Aggregate_Fields = {
  __typename?: 'exercise_content_media_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Exercise_Content_Media_Type_Max_Fields>;
  min?: Maybe<Exercise_Content_Media_Type_Min_Fields>;
};


/** aggregate fields of "exercise_content_media_type" */
export type Exercise_Content_Media_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Exercise_Content_Media_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "exercise_content_media_type". All fields are combined with a logical 'AND'. */
export type Exercise_Content_Media_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Exercise_Content_Media_Type_Bool_Exp>>;
  _not?: InputMaybe<Exercise_Content_Media_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Exercise_Content_Media_Type_Bool_Exp>>;
  exercise_content_media?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "exercise_content_media_type" */
export enum Exercise_Content_Media_Type_Constraint {
  /** unique or primary key constraint */
  ExerciseContentMediaTypePkey = 'exercise_content_media_type_pkey'
}

export enum Exercise_Content_Media_Type_Enum {
  EditorAnimation = 'EDITOR_ANIMATION',
  EditorImage = 'EDITOR_IMAGE',
  S3File = 'S3_FILE',
  Text = 'TEXT',
  VideoUrl = 'VIDEO_URL'
}

/** Boolean expression to compare columns of type "exercise_content_media_type_enum". All fields are combined with logical 'AND'. */
export type Exercise_Content_Media_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Exercise_Content_Media_Type_Enum>;
  _in?: InputMaybe<Array<Exercise_Content_Media_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Exercise_Content_Media_Type_Enum>;
  _nin?: InputMaybe<Array<Exercise_Content_Media_Type_Enum>>;
};

/** input type for inserting data into table "exercise_content_media_type" */
export type Exercise_Content_Media_Type_Insert_Input = {
  exercise_content_media?: InputMaybe<Exercise_Content_Media_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Exercise_Content_Media_Type_Max_Fields = {
  __typename?: 'exercise_content_media_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Exercise_Content_Media_Type_Min_Fields = {
  __typename?: 'exercise_content_media_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "exercise_content_media_type" */
export type Exercise_Content_Media_Type_Mutation_Response = {
  __typename?: 'exercise_content_media_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Exercise_Content_Media_Type>;
};

/** input type for inserting object relation for remote table "exercise_content_media_type" */
export type Exercise_Content_Media_Type_Obj_Rel_Insert_Input = {
  data: Exercise_Content_Media_Type_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exercise_Content_Media_Type_On_Conflict>;
};

/** on conflict condition type for table "exercise_content_media_type" */
export type Exercise_Content_Media_Type_On_Conflict = {
  constraint: Exercise_Content_Media_Type_Constraint;
  update_columns?: Array<Exercise_Content_Media_Type_Update_Column>;
  where?: InputMaybe<Exercise_Content_Media_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "exercise_content_media_type". */
export type Exercise_Content_Media_Type_Order_By = {
  exercise_content_media_aggregate?: InputMaybe<Exercise_Content_Media_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exercise_content_media_type */
export type Exercise_Content_Media_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "exercise_content_media_type" */
export enum Exercise_Content_Media_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "exercise_content_media_type" */
export type Exercise_Content_Media_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "exercise_content_media_type" */
export enum Exercise_Content_Media_Type_Update_Column {
  /** column name */
  Name = 'name'
}

/** update columns of table "exercise_content_media" */
export enum Exercise_Content_Media_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EditorAnimationId = 'editor_animation_id',
  /** column name */
  EditorImageId = 'editor_image_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsMediaRight = 'is_media_right',
  /** column name */
  S3FileId = 's3_file_id',
  /** column name */
  Text = 'text',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VideoUrl = 'video_url'
}

/** input type for incrementing numeric columns in table "exercise" */
export type Exercise_Inc_Input = {
  fitness_stars?: InputMaybe<Scalars['Int']>;
  tactics_stars?: InputMaybe<Scalars['Int']>;
  technique_stars?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "exercise" */
export type Exercise_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  exercise_club_mns?: InputMaybe<Exercise_Club_Mn_Arr_Rel_Insert_Input>;
  exercise_content_media_mns?: InputMaybe<Exercise_Content_Media_Mn_Arr_Rel_Insert_Input>;
  exercise_taxonomy_mns?: InputMaybe<Exercise_Taxonomy_Mn_Arr_Rel_Insert_Input>;
  fitness_stars?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['String']>;
  tactics_stars?: InputMaybe<Scalars['Int']>;
  technique_stars?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Exercise_Max_Fields = {
  __typename?: 'exercise_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  fitness_stars?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['String']>;
  tactics_stars?: Maybe<Scalars['Int']>;
  technique_stars?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "exercise" */
export type Exercise_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fitness_stars?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  tactics_stars?: InputMaybe<Order_By>;
  technique_stars?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Exercise_Min_Fields = {
  __typename?: 'exercise_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  fitness_stars?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  owner_id?: Maybe<Scalars['String']>;
  tactics_stars?: Maybe<Scalars['Int']>;
  technique_stars?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "exercise" */
export type Exercise_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fitness_stars?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  tactics_stars?: InputMaybe<Order_By>;
  technique_stars?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "exercise" */
export type Exercise_Mutation_Response = {
  __typename?: 'exercise_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Exercise>;
};

/** input type for inserting object relation for remote table "exercise" */
export type Exercise_Obj_Rel_Insert_Input = {
  data: Exercise_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exercise_On_Conflict>;
};

/** on conflict condition type for table "exercise" */
export type Exercise_On_Conflict = {
  constraint: Exercise_Constraint;
  update_columns?: Array<Exercise_Update_Column>;
  where?: InputMaybe<Exercise_Bool_Exp>;
};

/** Ordering options when selecting data from "exercise". */
export type Exercise_Order_By = {
  created_at?: InputMaybe<Order_By>;
  exercise_club_mns_aggregate?: InputMaybe<Exercise_Club_Mn_Aggregate_Order_By>;
  exercise_content_media_mns_aggregate?: InputMaybe<Exercise_Content_Media_Mn_Aggregate_Order_By>;
  exercise_taxonomy_mns_aggregate?: InputMaybe<Exercise_Taxonomy_Mn_Aggregate_Order_By>;
  fitness_stars?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  owner_id?: InputMaybe<Order_By>;
  tactics_stars?: InputMaybe<Order_By>;
  technique_stars?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: exercise */
export type Exercise_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "exercise" */
export enum Exercise_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FitnessStars = 'fitness_stars',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  TacticsStars = 'tactics_stars',
  /** column name */
  TechniqueStars = 'technique_stars',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "exercise" */
export type Exercise_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fitness_stars?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  owner_id?: InputMaybe<Scalars['String']>;
  tactics_stars?: InputMaybe<Scalars['Int']>;
  technique_stars?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Exercise_Stddev_Fields = {
  __typename?: 'exercise_stddev_fields';
  fitness_stars?: Maybe<Scalars['Float']>;
  tactics_stars?: Maybe<Scalars['Float']>;
  technique_stars?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "exercise" */
export type Exercise_Stddev_Order_By = {
  fitness_stars?: InputMaybe<Order_By>;
  tactics_stars?: InputMaybe<Order_By>;
  technique_stars?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Exercise_Stddev_Pop_Fields = {
  __typename?: 'exercise_stddev_pop_fields';
  fitness_stars?: Maybe<Scalars['Float']>;
  tactics_stars?: Maybe<Scalars['Float']>;
  technique_stars?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "exercise" */
export type Exercise_Stddev_Pop_Order_By = {
  fitness_stars?: InputMaybe<Order_By>;
  tactics_stars?: InputMaybe<Order_By>;
  technique_stars?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Exercise_Stddev_Samp_Fields = {
  __typename?: 'exercise_stddev_samp_fields';
  fitness_stars?: Maybe<Scalars['Float']>;
  tactics_stars?: Maybe<Scalars['Float']>;
  technique_stars?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "exercise" */
export type Exercise_Stddev_Samp_Order_By = {
  fitness_stars?: InputMaybe<Order_By>;
  tactics_stars?: InputMaybe<Order_By>;
  technique_stars?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Exercise_Sum_Fields = {
  __typename?: 'exercise_sum_fields';
  fitness_stars?: Maybe<Scalars['Int']>;
  tactics_stars?: Maybe<Scalars['Int']>;
  technique_stars?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "exercise" */
export type Exercise_Sum_Order_By = {
  fitness_stars?: InputMaybe<Order_By>;
  tactics_stars?: InputMaybe<Order_By>;
  technique_stars?: InputMaybe<Order_By>;
};

/** columns and relationships of "exercise_taxonomy" */
export type Exercise_Taxonomy = {
  __typename?: 'exercise_taxonomy';
  category: Enum_Exercise_Categories_Enum;
  club_id?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  enum_exercise_category: Enum_Exercise_Categories;
  /** An object relationship */
  enum_sport: Enum_Sport;
  /** An array relationship */
  exercise_taxonomy_mns: Array<Exercise_Taxonomy_Mn>;
  /** An aggregate relationship */
  exercise_taxonomy_mns_aggregate: Exercise_Taxonomy_Mn_Aggregate;
  id: Scalars['String'];
  locale?: Maybe<Scalars['String']>;
  sport: Enum_Sport_Enum;
  translation_key: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "exercise_taxonomy" */
export type Exercise_TaxonomyExercise_Taxonomy_MnsArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Mn_Bool_Exp>;
};


/** columns and relationships of "exercise_taxonomy" */
export type Exercise_TaxonomyExercise_Taxonomy_Mns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Mn_Bool_Exp>;
};

/** aggregated selection of "exercise_taxonomy" */
export type Exercise_Taxonomy_Aggregate = {
  __typename?: 'exercise_taxonomy_aggregate';
  aggregate?: Maybe<Exercise_Taxonomy_Aggregate_Fields>;
  nodes: Array<Exercise_Taxonomy>;
};

/** aggregate fields of "exercise_taxonomy" */
export type Exercise_Taxonomy_Aggregate_Fields = {
  __typename?: 'exercise_taxonomy_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Exercise_Taxonomy_Max_Fields>;
  min?: Maybe<Exercise_Taxonomy_Min_Fields>;
};


/** aggregate fields of "exercise_taxonomy" */
export type Exercise_Taxonomy_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Exercise_Taxonomy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exercise_taxonomy" */
export type Exercise_Taxonomy_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Exercise_Taxonomy_Max_Order_By>;
  min?: InputMaybe<Exercise_Taxonomy_Min_Order_By>;
};

/** input type for inserting array relation for remote table "exercise_taxonomy" */
export type Exercise_Taxonomy_Arr_Rel_Insert_Input = {
  data: Array<Exercise_Taxonomy_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exercise_Taxonomy_On_Conflict>;
};

/** Boolean expression to filter rows from the table "exercise_taxonomy". All fields are combined with a logical 'AND'. */
export type Exercise_Taxonomy_Bool_Exp = {
  _and?: InputMaybe<Array<Exercise_Taxonomy_Bool_Exp>>;
  _not?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
  _or?: InputMaybe<Array<Exercise_Taxonomy_Bool_Exp>>;
  category?: InputMaybe<Enum_Exercise_Categories_Enum_Comparison_Exp>;
  club_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  enum_exercise_category?: InputMaybe<Enum_Exercise_Categories_Bool_Exp>;
  enum_sport?: InputMaybe<Enum_Sport_Bool_Exp>;
  exercise_taxonomy_mns?: InputMaybe<Exercise_Taxonomy_Mn_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  sport?: InputMaybe<Enum_Sport_Enum_Comparison_Exp>;
  translation_key?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "exercise_taxonomy" */
export enum Exercise_Taxonomy_Constraint {
  /** unique or primary key constraint */
  ExerciseTaxonomyPkey = 'exercise_taxonomy_pkey'
}

/** input type for inserting data into table "exercise_taxonomy" */
export type Exercise_Taxonomy_Insert_Input = {
  category?: InputMaybe<Enum_Exercise_Categories_Enum>;
  club_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  enum_exercise_category?: InputMaybe<Enum_Exercise_Categories_Obj_Rel_Insert_Input>;
  enum_sport?: InputMaybe<Enum_Sport_Obj_Rel_Insert_Input>;
  exercise_taxonomy_mns?: InputMaybe<Exercise_Taxonomy_Mn_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<Enum_Sport_Enum>;
  translation_key?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Exercise_Taxonomy_Max_Fields = {
  __typename?: 'exercise_taxonomy_max_fields';
  club_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  translation_key?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "exercise_taxonomy" */
export type Exercise_Taxonomy_Max_Order_By = {
  club_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  translation_key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Exercise_Taxonomy_Min_Fields = {
  __typename?: 'exercise_taxonomy_min_fields';
  club_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  translation_key?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "exercise_taxonomy" */
export type Exercise_Taxonomy_Min_Order_By = {
  club_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  translation_key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "exercise_taxonomy_mn" */
export type Exercise_Taxonomy_Mn = {
  __typename?: 'exercise_taxonomy_mn';
  /** An object relationship */
  exercise: Exercise;
  exercise_id: Scalars['String'];
  /** An object relationship */
  exercise_taxonomy: Exercise_Taxonomy;
  taxonomy_id: Scalars['String'];
};

/** aggregated selection of "exercise_taxonomy_mn" */
export type Exercise_Taxonomy_Mn_Aggregate = {
  __typename?: 'exercise_taxonomy_mn_aggregate';
  aggregate?: Maybe<Exercise_Taxonomy_Mn_Aggregate_Fields>;
  nodes: Array<Exercise_Taxonomy_Mn>;
};

/** aggregate fields of "exercise_taxonomy_mn" */
export type Exercise_Taxonomy_Mn_Aggregate_Fields = {
  __typename?: 'exercise_taxonomy_mn_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Exercise_Taxonomy_Mn_Max_Fields>;
  min?: Maybe<Exercise_Taxonomy_Mn_Min_Fields>;
};


/** aggregate fields of "exercise_taxonomy_mn" */
export type Exercise_Taxonomy_Mn_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Exercise_Taxonomy_Mn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exercise_taxonomy_mn" */
export type Exercise_Taxonomy_Mn_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Exercise_Taxonomy_Mn_Max_Order_By>;
  min?: InputMaybe<Exercise_Taxonomy_Mn_Min_Order_By>;
};

/** input type for inserting array relation for remote table "exercise_taxonomy_mn" */
export type Exercise_Taxonomy_Mn_Arr_Rel_Insert_Input = {
  data: Array<Exercise_Taxonomy_Mn_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exercise_Taxonomy_Mn_On_Conflict>;
};

/** Boolean expression to filter rows from the table "exercise_taxonomy_mn". All fields are combined with a logical 'AND'. */
export type Exercise_Taxonomy_Mn_Bool_Exp = {
  _and?: InputMaybe<Array<Exercise_Taxonomy_Mn_Bool_Exp>>;
  _not?: InputMaybe<Exercise_Taxonomy_Mn_Bool_Exp>;
  _or?: InputMaybe<Array<Exercise_Taxonomy_Mn_Bool_Exp>>;
  exercise?: InputMaybe<Exercise_Bool_Exp>;
  exercise_id?: InputMaybe<String_Comparison_Exp>;
  exercise_taxonomy?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
  taxonomy_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "exercise_taxonomy_mn" */
export enum Exercise_Taxonomy_Mn_Constraint {
  /** unique or primary key constraint */
  ExerciseTaxonomyMnPkey = 'exercise_taxonomy_mn_pkey'
}

/** input type for inserting data into table "exercise_taxonomy_mn" */
export type Exercise_Taxonomy_Mn_Insert_Input = {
  exercise?: InputMaybe<Exercise_Obj_Rel_Insert_Input>;
  exercise_id?: InputMaybe<Scalars['String']>;
  exercise_taxonomy?: InputMaybe<Exercise_Taxonomy_Obj_Rel_Insert_Input>;
  taxonomy_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Exercise_Taxonomy_Mn_Max_Fields = {
  __typename?: 'exercise_taxonomy_mn_max_fields';
  exercise_id?: Maybe<Scalars['String']>;
  taxonomy_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "exercise_taxonomy_mn" */
export type Exercise_Taxonomy_Mn_Max_Order_By = {
  exercise_id?: InputMaybe<Order_By>;
  taxonomy_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Exercise_Taxonomy_Mn_Min_Fields = {
  __typename?: 'exercise_taxonomy_mn_min_fields';
  exercise_id?: Maybe<Scalars['String']>;
  taxonomy_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "exercise_taxonomy_mn" */
export type Exercise_Taxonomy_Mn_Min_Order_By = {
  exercise_id?: InputMaybe<Order_By>;
  taxonomy_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "exercise_taxonomy_mn" */
export type Exercise_Taxonomy_Mn_Mutation_Response = {
  __typename?: 'exercise_taxonomy_mn_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Exercise_Taxonomy_Mn>;
};

/** on conflict condition type for table "exercise_taxonomy_mn" */
export type Exercise_Taxonomy_Mn_On_Conflict = {
  constraint: Exercise_Taxonomy_Mn_Constraint;
  update_columns?: Array<Exercise_Taxonomy_Mn_Update_Column>;
  where?: InputMaybe<Exercise_Taxonomy_Mn_Bool_Exp>;
};

/** Ordering options when selecting data from "exercise_taxonomy_mn". */
export type Exercise_Taxonomy_Mn_Order_By = {
  exercise?: InputMaybe<Exercise_Order_By>;
  exercise_id?: InputMaybe<Order_By>;
  exercise_taxonomy?: InputMaybe<Exercise_Taxonomy_Order_By>;
  taxonomy_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exercise_taxonomy_mn */
export type Exercise_Taxonomy_Mn_Pk_Columns_Input = {
  exercise_id: Scalars['String'];
  taxonomy_id: Scalars['String'];
};

/** select columns of table "exercise_taxonomy_mn" */
export enum Exercise_Taxonomy_Mn_Select_Column {
  /** column name */
  ExerciseId = 'exercise_id',
  /** column name */
  TaxonomyId = 'taxonomy_id'
}

/** input type for updating data in table "exercise_taxonomy_mn" */
export type Exercise_Taxonomy_Mn_Set_Input = {
  exercise_id?: InputMaybe<Scalars['String']>;
  taxonomy_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "exercise_taxonomy_mn" */
export enum Exercise_Taxonomy_Mn_Update_Column {
  /** column name */
  ExerciseId = 'exercise_id',
  /** column name */
  TaxonomyId = 'taxonomy_id'
}

/** response of any mutation on the table "exercise_taxonomy" */
export type Exercise_Taxonomy_Mutation_Response = {
  __typename?: 'exercise_taxonomy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Exercise_Taxonomy>;
};

/** input type for inserting object relation for remote table "exercise_taxonomy" */
export type Exercise_Taxonomy_Obj_Rel_Insert_Input = {
  data: Exercise_Taxonomy_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Exercise_Taxonomy_On_Conflict>;
};

/** on conflict condition type for table "exercise_taxonomy" */
export type Exercise_Taxonomy_On_Conflict = {
  constraint: Exercise_Taxonomy_Constraint;
  update_columns?: Array<Exercise_Taxonomy_Update_Column>;
  where?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
};

/** Ordering options when selecting data from "exercise_taxonomy". */
export type Exercise_Taxonomy_Order_By = {
  category?: InputMaybe<Order_By>;
  club_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  enum_exercise_category?: InputMaybe<Enum_Exercise_Categories_Order_By>;
  enum_sport?: InputMaybe<Enum_Sport_Order_By>;
  exercise_taxonomy_mns_aggregate?: InputMaybe<Exercise_Taxonomy_Mn_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  sport?: InputMaybe<Order_By>;
  translation_key?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: exercise_taxonomy */
export type Exercise_Taxonomy_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "exercise_taxonomy" */
export enum Exercise_Taxonomy_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  ClubId = 'club_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  Sport = 'sport',
  /** column name */
  TranslationKey = 'translation_key',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "exercise_taxonomy" */
export type Exercise_Taxonomy_Set_Input = {
  category?: InputMaybe<Enum_Exercise_Categories_Enum>;
  club_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<Enum_Sport_Enum>;
  translation_key?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "exercise_taxonomy" */
export enum Exercise_Taxonomy_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  ClubId = 'club_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  Sport = 'sport',
  /** column name */
  TranslationKey = 'translation_key',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** update columns of table "exercise" */
export enum Exercise_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FitnessStars = 'fitness_stars',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  OwnerId = 'owner_id',
  /** column name */
  TacticsStars = 'tactics_stars',
  /** column name */
  TechniqueStars = 'technique_stars',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate var_pop on columns */
export type Exercise_Var_Pop_Fields = {
  __typename?: 'exercise_var_pop_fields';
  fitness_stars?: Maybe<Scalars['Float']>;
  tactics_stars?: Maybe<Scalars['Float']>;
  technique_stars?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "exercise" */
export type Exercise_Var_Pop_Order_By = {
  fitness_stars?: InputMaybe<Order_By>;
  tactics_stars?: InputMaybe<Order_By>;
  technique_stars?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Exercise_Var_Samp_Fields = {
  __typename?: 'exercise_var_samp_fields';
  fitness_stars?: Maybe<Scalars['Float']>;
  tactics_stars?: Maybe<Scalars['Float']>;
  technique_stars?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "exercise" */
export type Exercise_Var_Samp_Order_By = {
  fitness_stars?: InputMaybe<Order_By>;
  tactics_stars?: InputMaybe<Order_By>;
  technique_stars?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Exercise_Variance_Fields = {
  __typename?: 'exercise_variance_fields';
  fitness_stars?: Maybe<Scalars['Float']>;
  tactics_stars?: Maybe<Scalars['Float']>;
  technique_stars?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "exercise" */
export type Exercise_Variance_Order_By = {
  fitness_stars?: InputMaybe<Order_By>;
  tactics_stars?: InputMaybe<Order_By>;
  technique_stars?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "license" */
export type License = {
  __typename?: 'license';
  name: Scalars['String'];
  /** An array relationship */
  payments: Array<Payment>;
  /** An aggregate relationship */
  payments_aggregate: Payment_Aggregate;
};


/** columns and relationships of "license" */
export type LicensePaymentsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


/** columns and relationships of "license" */
export type LicensePayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};

/** aggregated selection of "license" */
export type License_Aggregate = {
  __typename?: 'license_aggregate';
  aggregate?: Maybe<License_Aggregate_Fields>;
  nodes: Array<License>;
};

/** aggregate fields of "license" */
export type License_Aggregate_Fields = {
  __typename?: 'license_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<License_Max_Fields>;
  min?: Maybe<License_Min_Fields>;
};


/** aggregate fields of "license" */
export type License_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<License_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "license". All fields are combined with a logical 'AND'. */
export type License_Bool_Exp = {
  _and?: InputMaybe<Array<License_Bool_Exp>>;
  _not?: InputMaybe<License_Bool_Exp>;
  _or?: InputMaybe<Array<License_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  payments?: InputMaybe<Payment_Bool_Exp>;
};

/** unique or primary key constraints on table "license" */
export enum License_Constraint {
  /** unique or primary key constraint */
  LicensePkey = 'license_pkey'
}

export enum License_Enum {
  Trial = 'TRIAL'
}

/** Boolean expression to compare columns of type "license_enum". All fields are combined with logical 'AND'. */
export type License_Enum_Comparison_Exp = {
  _eq?: InputMaybe<License_Enum>;
  _in?: InputMaybe<Array<License_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<License_Enum>;
  _nin?: InputMaybe<Array<License_Enum>>;
};

/** input type for inserting data into table "license" */
export type License_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<Payment_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type License_Max_Fields = {
  __typename?: 'license_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type License_Min_Fields = {
  __typename?: 'license_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "license" */
export type License_Mutation_Response = {
  __typename?: 'license_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<License>;
};

/** input type for inserting object relation for remote table "license" */
export type License_Obj_Rel_Insert_Input = {
  data: License_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<License_On_Conflict>;
};

/** on conflict condition type for table "license" */
export type License_On_Conflict = {
  constraint: License_Constraint;
  update_columns?: Array<License_Update_Column>;
  where?: InputMaybe<License_Bool_Exp>;
};

/** Ordering options when selecting data from "license". */
export type License_Order_By = {
  name?: InputMaybe<Order_By>;
  payments_aggregate?: InputMaybe<Payment_Aggregate_Order_By>;
};

/** primary key columns input for table: license */
export type License_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "license" */
export enum License_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "license" */
export type License_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "license" */
export enum License_Update_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "member" */
export type Member = {
  __typename?: 'member';
  email?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  id: Scalars['String'];
  last_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "member" */
export type Member_Aggregate = {
  __typename?: 'member_aggregate';
  aggregate?: Maybe<Member_Aggregate_Fields>;
  nodes: Array<Member>;
};

/** aggregate fields of "member" */
export type Member_Aggregate_Fields = {
  __typename?: 'member_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Member_Max_Fields>;
  min?: Maybe<Member_Min_Fields>;
};


/** aggregate fields of "member" */
export type Member_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "member". All fields are combined with a logical 'AND'. */
export type Member_Bool_Exp = {
  _and?: InputMaybe<Array<Member_Bool_Exp>>;
  _not?: InputMaybe<Member_Bool_Exp>;
  _or?: InputMaybe<Array<Member_Bool_Exp>>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "member" */
export enum Member_Constraint {
  /** unique or primary key constraint */
  MemberPkey = 'member_pkey'
}

/** columns and relationships of "member_group" */
export type Member_Group = {
  __typename?: 'member_group';
  name: Scalars['String'];
};

/** aggregated selection of "member_group" */
export type Member_Group_Aggregate = {
  __typename?: 'member_group_aggregate';
  aggregate?: Maybe<Member_Group_Aggregate_Fields>;
  nodes: Array<Member_Group>;
};

/** aggregate fields of "member_group" */
export type Member_Group_Aggregate_Fields = {
  __typename?: 'member_group_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Member_Group_Max_Fields>;
  min?: Maybe<Member_Group_Min_Fields>;
};


/** aggregate fields of "member_group" */
export type Member_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Member_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "member_group". All fields are combined with a logical 'AND'. */
export type Member_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Member_Group_Bool_Exp>>;
  _not?: InputMaybe<Member_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Member_Group_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "member_group" */
export enum Member_Group_Constraint {
  /** unique or primary key constraint */
  MemberGroupPkey = 'member_group_pkey'
}

/** input type for inserting data into table "member_group" */
export type Member_Group_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Member_Group_Max_Fields = {
  __typename?: 'member_group_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Member_Group_Min_Fields = {
  __typename?: 'member_group_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** columns and relationships of "member_group_mn" */
export type Member_Group_Mn = {
  __typename?: 'member_group_mn';
  group_id: Scalars['String'];
  member_id: Scalars['String'];
};

/** aggregated selection of "member_group_mn" */
export type Member_Group_Mn_Aggregate = {
  __typename?: 'member_group_mn_aggregate';
  aggregate?: Maybe<Member_Group_Mn_Aggregate_Fields>;
  nodes: Array<Member_Group_Mn>;
};

/** aggregate fields of "member_group_mn" */
export type Member_Group_Mn_Aggregate_Fields = {
  __typename?: 'member_group_mn_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Member_Group_Mn_Max_Fields>;
  min?: Maybe<Member_Group_Mn_Min_Fields>;
};


/** aggregate fields of "member_group_mn" */
export type Member_Group_Mn_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Member_Group_Mn_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "member_group_mn". All fields are combined with a logical 'AND'. */
export type Member_Group_Mn_Bool_Exp = {
  _and?: InputMaybe<Array<Member_Group_Mn_Bool_Exp>>;
  _not?: InputMaybe<Member_Group_Mn_Bool_Exp>;
  _or?: InputMaybe<Array<Member_Group_Mn_Bool_Exp>>;
  group_id?: InputMaybe<String_Comparison_Exp>;
  member_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "member_group_mn" */
export enum Member_Group_Mn_Constraint {
  /** unique or primary key constraint */
  MemberGroupMnPkey = 'member_group_mn_pkey'
}

/** input type for inserting data into table "member_group_mn" */
export type Member_Group_Mn_Insert_Input = {
  group_id?: InputMaybe<Scalars['String']>;
  member_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Member_Group_Mn_Max_Fields = {
  __typename?: 'member_group_mn_max_fields';
  group_id?: Maybe<Scalars['String']>;
  member_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Member_Group_Mn_Min_Fields = {
  __typename?: 'member_group_mn_min_fields';
  group_id?: Maybe<Scalars['String']>;
  member_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "member_group_mn" */
export type Member_Group_Mn_Mutation_Response = {
  __typename?: 'member_group_mn_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Member_Group_Mn>;
};

/** on conflict condition type for table "member_group_mn" */
export type Member_Group_Mn_On_Conflict = {
  constraint: Member_Group_Mn_Constraint;
  update_columns?: Array<Member_Group_Mn_Update_Column>;
  where?: InputMaybe<Member_Group_Mn_Bool_Exp>;
};

/** Ordering options when selecting data from "member_group_mn". */
export type Member_Group_Mn_Order_By = {
  group_id?: InputMaybe<Order_By>;
  member_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: member_group_mn */
export type Member_Group_Mn_Pk_Columns_Input = {
  group_id: Scalars['String'];
  member_id: Scalars['String'];
};

/** select columns of table "member_group_mn" */
export enum Member_Group_Mn_Select_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  MemberId = 'member_id'
}

/** input type for updating data in table "member_group_mn" */
export type Member_Group_Mn_Set_Input = {
  group_id?: InputMaybe<Scalars['String']>;
  member_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "member_group_mn" */
export enum Member_Group_Mn_Update_Column {
  /** column name */
  GroupId = 'group_id',
  /** column name */
  MemberId = 'member_id'
}

/** response of any mutation on the table "member_group" */
export type Member_Group_Mutation_Response = {
  __typename?: 'member_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Member_Group>;
};

/** on conflict condition type for table "member_group" */
export type Member_Group_On_Conflict = {
  constraint: Member_Group_Constraint;
  update_columns?: Array<Member_Group_Update_Column>;
  where?: InputMaybe<Member_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "member_group". */
export type Member_Group_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: member_group */
export type Member_Group_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "member_group" */
export enum Member_Group_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "member_group" */
export type Member_Group_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "member_group" */
export enum Member_Group_Update_Column {
  /** column name */
  Name = 'name'
}

/** input type for inserting data into table "member" */
export type Member_Insert_Input = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Member_Max_Fields = {
  __typename?: 'member_max_fields';
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Member_Min_Fields = {
  __typename?: 'member_min_fields';
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "member" */
export type Member_Mutation_Response = {
  __typename?: 'member_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Member>;
};

/** on conflict condition type for table "member" */
export type Member_On_Conflict = {
  constraint: Member_Constraint;
  update_columns?: Array<Member_Update_Column>;
  where?: InputMaybe<Member_Bool_Exp>;
};

/** Ordering options when selecting data from "member". */
export type Member_Order_By = {
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: member */
export type Member_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "member" */
export enum Member_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "member" */
export type Member_Set_Input = {
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "member" */
export enum Member_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  UserId = 'user_id'
}

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "club" */
  delete_club?: Maybe<Club_Mutation_Response>;
  /** delete single row from the table: "club" */
  delete_club_by_pk?: Maybe<Club>;
  /** delete data from the table: "editor_type" */
  delete_editor_type?: Maybe<Editor_Type_Mutation_Response>;
  /** delete single row from the table: "editor_type" */
  delete_editor_type_by_pk?: Maybe<Editor_Type>;
  /** delete data from the table: "enum_exercise_categories" */
  delete_enum_exercise_categories?: Maybe<Enum_Exercise_Categories_Mutation_Response>;
  /** delete single row from the table: "enum_exercise_categories" */
  delete_enum_exercise_categories_by_pk?: Maybe<Enum_Exercise_Categories>;
  /** delete data from the table: "enum_languages" */
  delete_enum_languages?: Maybe<Enum_Languages_Mutation_Response>;
  /** delete single row from the table: "enum_languages" */
  delete_enum_languages_by_pk?: Maybe<Enum_Languages>;
  /** delete data from the table: "enum_sport" */
  delete_enum_sport?: Maybe<Enum_Sport_Mutation_Response>;
  /** delete single row from the table: "enum_sport" */
  delete_enum_sport_by_pk?: Maybe<Enum_Sport>;
  /** delete data from the table: "exercise" */
  delete_exercise?: Maybe<Exercise_Mutation_Response>;
  /** delete single row from the table: "exercise" */
  delete_exercise_by_pk?: Maybe<Exercise>;
  /** delete data from the table: "exercise_club_mn" */
  delete_exercise_club_mn?: Maybe<Exercise_Club_Mn_Mutation_Response>;
  /** delete single row from the table: "exercise_club_mn" */
  delete_exercise_club_mn_by_pk?: Maybe<Exercise_Club_Mn>;
  /** delete data from the table: "exercise_content_media" */
  delete_exercise_content_media?: Maybe<Exercise_Content_Media_Mutation_Response>;
  /** delete single row from the table: "exercise_content_media" */
  delete_exercise_content_media_by_pk?: Maybe<Exercise_Content_Media>;
  /** delete data from the table: "exercise_content_media_editor" */
  delete_exercise_content_media_editor?: Maybe<Exercise_Content_Media_Editor_Mutation_Response>;
  /** delete single row from the table: "exercise_content_media_editor" */
  delete_exercise_content_media_editor_by_pk?: Maybe<Exercise_Content_Media_Editor>;
  /** delete data from the table: "exercise_content_media_mn" */
  delete_exercise_content_media_mn?: Maybe<Exercise_Content_Media_Mn_Mutation_Response>;
  /** delete single row from the table: "exercise_content_media_mn" */
  delete_exercise_content_media_mn_by_pk?: Maybe<Exercise_Content_Media_Mn>;
  /** delete data from the table: "exercise_content_media_type" */
  delete_exercise_content_media_type?: Maybe<Exercise_Content_Media_Type_Mutation_Response>;
  /** delete single row from the table: "exercise_content_media_type" */
  delete_exercise_content_media_type_by_pk?: Maybe<Exercise_Content_Media_Type>;
  /** delete data from the table: "exercise_taxonomy" */
  delete_exercise_taxonomy?: Maybe<Exercise_Taxonomy_Mutation_Response>;
  /** delete single row from the table: "exercise_taxonomy" */
  delete_exercise_taxonomy_by_pk?: Maybe<Exercise_Taxonomy>;
  /** delete data from the table: "exercise_taxonomy_mn" */
  delete_exercise_taxonomy_mn?: Maybe<Exercise_Taxonomy_Mn_Mutation_Response>;
  /** delete single row from the table: "exercise_taxonomy_mn" */
  delete_exercise_taxonomy_mn_by_pk?: Maybe<Exercise_Taxonomy_Mn>;
  /** delete data from the table: "license" */
  delete_license?: Maybe<License_Mutation_Response>;
  /** delete single row from the table: "license" */
  delete_license_by_pk?: Maybe<License>;
  /** delete data from the table: "member" */
  delete_member?: Maybe<Member_Mutation_Response>;
  /** delete single row from the table: "member" */
  delete_member_by_pk?: Maybe<Member>;
  /** delete data from the table: "member_group" */
  delete_member_group?: Maybe<Member_Group_Mutation_Response>;
  /** delete single row from the table: "member_group" */
  delete_member_group_by_pk?: Maybe<Member_Group>;
  /** delete data from the table: "member_group_mn" */
  delete_member_group_mn?: Maybe<Member_Group_Mn_Mutation_Response>;
  /** delete single row from the table: "member_group_mn" */
  delete_member_group_mn_by_pk?: Maybe<Member_Group_Mn>;
  /** delete data from the table: "payment" */
  delete_payment?: Maybe<Payment_Mutation_Response>;
  /** delete single row from the table: "payment" */
  delete_payment_by_pk?: Maybe<Payment>;
  /** delete data from the table: "s3_file" */
  delete_s3_file?: Maybe<S3_File_Mutation_Response>;
  /** delete single row from the table: "s3_file" */
  delete_s3_file_by_pk?: Maybe<S3_File>;
  /** delete data from the table: "team" */
  delete_team?: Maybe<Team_Mutation_Response>;
  /** delete single row from the table: "team" */
  delete_team_by_pk?: Maybe<Team>;
  /** delete data from the table: "user_permission" */
  delete_user_permission?: Maybe<User_Permission_Mutation_Response>;
  /** delete single row from the table: "user_permission" */
  delete_user_permission_by_pk?: Maybe<User_Permission>;
  /** delete data from the table: "user_permission_role" */
  delete_user_permission_role?: Maybe<User_Permission_Role_Mutation_Response>;
  /** delete single row from the table: "user_permission_role" */
  delete_user_permission_role_by_pk?: Maybe<User_Permission_Role>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** insert data into the table: "club" */
  insert_club?: Maybe<Club_Mutation_Response>;
  /** insert a single row into the table: "club" */
  insert_club_one?: Maybe<Club>;
  /** insert data into the table: "editor_type" */
  insert_editor_type?: Maybe<Editor_Type_Mutation_Response>;
  /** insert a single row into the table: "editor_type" */
  insert_editor_type_one?: Maybe<Editor_Type>;
  /** insert data into the table: "enum_exercise_categories" */
  insert_enum_exercise_categories?: Maybe<Enum_Exercise_Categories_Mutation_Response>;
  /** insert a single row into the table: "enum_exercise_categories" */
  insert_enum_exercise_categories_one?: Maybe<Enum_Exercise_Categories>;
  /** insert data into the table: "enum_languages" */
  insert_enum_languages?: Maybe<Enum_Languages_Mutation_Response>;
  /** insert a single row into the table: "enum_languages" */
  insert_enum_languages_one?: Maybe<Enum_Languages>;
  /** insert data into the table: "enum_sport" */
  insert_enum_sport?: Maybe<Enum_Sport_Mutation_Response>;
  /** insert a single row into the table: "enum_sport" */
  insert_enum_sport_one?: Maybe<Enum_Sport>;
  /** insert data into the table: "exercise" */
  insert_exercise?: Maybe<Exercise_Mutation_Response>;
  /** insert data into the table: "exercise_club_mn" */
  insert_exercise_club_mn?: Maybe<Exercise_Club_Mn_Mutation_Response>;
  /** insert a single row into the table: "exercise_club_mn" */
  insert_exercise_club_mn_one?: Maybe<Exercise_Club_Mn>;
  /** insert data into the table: "exercise_content_media" */
  insert_exercise_content_media?: Maybe<Exercise_Content_Media_Mutation_Response>;
  /** insert data into the table: "exercise_content_media_editor" */
  insert_exercise_content_media_editor?: Maybe<Exercise_Content_Media_Editor_Mutation_Response>;
  /** insert a single row into the table: "exercise_content_media_editor" */
  insert_exercise_content_media_editor_one?: Maybe<Exercise_Content_Media_Editor>;
  /** insert data into the table: "exercise_content_media_mn" */
  insert_exercise_content_media_mn?: Maybe<Exercise_Content_Media_Mn_Mutation_Response>;
  /** insert a single row into the table: "exercise_content_media_mn" */
  insert_exercise_content_media_mn_one?: Maybe<Exercise_Content_Media_Mn>;
  /** insert a single row into the table: "exercise_content_media" */
  insert_exercise_content_media_one?: Maybe<Exercise_Content_Media>;
  /** insert data into the table: "exercise_content_media_type" */
  insert_exercise_content_media_type?: Maybe<Exercise_Content_Media_Type_Mutation_Response>;
  /** insert a single row into the table: "exercise_content_media_type" */
  insert_exercise_content_media_type_one?: Maybe<Exercise_Content_Media_Type>;
  /** insert a single row into the table: "exercise" */
  insert_exercise_one?: Maybe<Exercise>;
  /** insert data into the table: "exercise_taxonomy" */
  insert_exercise_taxonomy?: Maybe<Exercise_Taxonomy_Mutation_Response>;
  /** insert data into the table: "exercise_taxonomy_mn" */
  insert_exercise_taxonomy_mn?: Maybe<Exercise_Taxonomy_Mn_Mutation_Response>;
  /** insert a single row into the table: "exercise_taxonomy_mn" */
  insert_exercise_taxonomy_mn_one?: Maybe<Exercise_Taxonomy_Mn>;
  /** insert a single row into the table: "exercise_taxonomy" */
  insert_exercise_taxonomy_one?: Maybe<Exercise_Taxonomy>;
  /** insert data into the table: "license" */
  insert_license?: Maybe<License_Mutation_Response>;
  /** insert a single row into the table: "license" */
  insert_license_one?: Maybe<License>;
  /** insert data into the table: "member" */
  insert_member?: Maybe<Member_Mutation_Response>;
  /** insert data into the table: "member_group" */
  insert_member_group?: Maybe<Member_Group_Mutation_Response>;
  /** insert data into the table: "member_group_mn" */
  insert_member_group_mn?: Maybe<Member_Group_Mn_Mutation_Response>;
  /** insert a single row into the table: "member_group_mn" */
  insert_member_group_mn_one?: Maybe<Member_Group_Mn>;
  /** insert a single row into the table: "member_group" */
  insert_member_group_one?: Maybe<Member_Group>;
  /** insert a single row into the table: "member" */
  insert_member_one?: Maybe<Member>;
  /** insert data into the table: "payment" */
  insert_payment?: Maybe<Payment_Mutation_Response>;
  /** insert a single row into the table: "payment" */
  insert_payment_one?: Maybe<Payment>;
  /** insert data into the table: "s3_file" */
  insert_s3_file?: Maybe<S3_File_Mutation_Response>;
  /** insert a single row into the table: "s3_file" */
  insert_s3_file_one?: Maybe<S3_File>;
  /** insert data into the table: "team" */
  insert_team?: Maybe<Team_Mutation_Response>;
  /** insert a single row into the table: "team" */
  insert_team_one?: Maybe<Team>;
  /** insert data into the table: "user_permission" */
  insert_user_permission?: Maybe<User_Permission_Mutation_Response>;
  /** insert a single row into the table: "user_permission" */
  insert_user_permission_one?: Maybe<User_Permission>;
  /** insert data into the table: "user_permission_role" */
  insert_user_permission_role?: Maybe<User_Permission_Role_Mutation_Response>;
  /** insert a single row into the table: "user_permission_role" */
  insert_user_permission_role_one?: Maybe<User_Permission_Role>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** update data of the table: "club" */
  update_club?: Maybe<Club_Mutation_Response>;
  /** update single row of the table: "club" */
  update_club_by_pk?: Maybe<Club>;
  /** update data of the table: "editor_type" */
  update_editor_type?: Maybe<Editor_Type_Mutation_Response>;
  /** update single row of the table: "editor_type" */
  update_editor_type_by_pk?: Maybe<Editor_Type>;
  /** update data of the table: "enum_exercise_categories" */
  update_enum_exercise_categories?: Maybe<Enum_Exercise_Categories_Mutation_Response>;
  /** update single row of the table: "enum_exercise_categories" */
  update_enum_exercise_categories_by_pk?: Maybe<Enum_Exercise_Categories>;
  /** update data of the table: "enum_languages" */
  update_enum_languages?: Maybe<Enum_Languages_Mutation_Response>;
  /** update single row of the table: "enum_languages" */
  update_enum_languages_by_pk?: Maybe<Enum_Languages>;
  /** update data of the table: "enum_sport" */
  update_enum_sport?: Maybe<Enum_Sport_Mutation_Response>;
  /** update single row of the table: "enum_sport" */
  update_enum_sport_by_pk?: Maybe<Enum_Sport>;
  /** update data of the table: "exercise" */
  update_exercise?: Maybe<Exercise_Mutation_Response>;
  /** update single row of the table: "exercise" */
  update_exercise_by_pk?: Maybe<Exercise>;
  /** update data of the table: "exercise_club_mn" */
  update_exercise_club_mn?: Maybe<Exercise_Club_Mn_Mutation_Response>;
  /** update single row of the table: "exercise_club_mn" */
  update_exercise_club_mn_by_pk?: Maybe<Exercise_Club_Mn>;
  /** update data of the table: "exercise_content_media" */
  update_exercise_content_media?: Maybe<Exercise_Content_Media_Mutation_Response>;
  /** update single row of the table: "exercise_content_media" */
  update_exercise_content_media_by_pk?: Maybe<Exercise_Content_Media>;
  /** update data of the table: "exercise_content_media_editor" */
  update_exercise_content_media_editor?: Maybe<Exercise_Content_Media_Editor_Mutation_Response>;
  /** update single row of the table: "exercise_content_media_editor" */
  update_exercise_content_media_editor_by_pk?: Maybe<Exercise_Content_Media_Editor>;
  /** update data of the table: "exercise_content_media_mn" */
  update_exercise_content_media_mn?: Maybe<Exercise_Content_Media_Mn_Mutation_Response>;
  /** update single row of the table: "exercise_content_media_mn" */
  update_exercise_content_media_mn_by_pk?: Maybe<Exercise_Content_Media_Mn>;
  /** update data of the table: "exercise_content_media_type" */
  update_exercise_content_media_type?: Maybe<Exercise_Content_Media_Type_Mutation_Response>;
  /** update single row of the table: "exercise_content_media_type" */
  update_exercise_content_media_type_by_pk?: Maybe<Exercise_Content_Media_Type>;
  /** update data of the table: "exercise_taxonomy" */
  update_exercise_taxonomy?: Maybe<Exercise_Taxonomy_Mutation_Response>;
  /** update single row of the table: "exercise_taxonomy" */
  update_exercise_taxonomy_by_pk?: Maybe<Exercise_Taxonomy>;
  /** update data of the table: "exercise_taxonomy_mn" */
  update_exercise_taxonomy_mn?: Maybe<Exercise_Taxonomy_Mn_Mutation_Response>;
  /** update single row of the table: "exercise_taxonomy_mn" */
  update_exercise_taxonomy_mn_by_pk?: Maybe<Exercise_Taxonomy_Mn>;
  /** update data of the table: "license" */
  update_license?: Maybe<License_Mutation_Response>;
  /** update single row of the table: "license" */
  update_license_by_pk?: Maybe<License>;
  /** update data of the table: "member" */
  update_member?: Maybe<Member_Mutation_Response>;
  /** update single row of the table: "member" */
  update_member_by_pk?: Maybe<Member>;
  /** update data of the table: "member_group" */
  update_member_group?: Maybe<Member_Group_Mutation_Response>;
  /** update single row of the table: "member_group" */
  update_member_group_by_pk?: Maybe<Member_Group>;
  /** update data of the table: "member_group_mn" */
  update_member_group_mn?: Maybe<Member_Group_Mn_Mutation_Response>;
  /** update single row of the table: "member_group_mn" */
  update_member_group_mn_by_pk?: Maybe<Member_Group_Mn>;
  /** update data of the table: "payment" */
  update_payment?: Maybe<Payment_Mutation_Response>;
  /** update single row of the table: "payment" */
  update_payment_by_pk?: Maybe<Payment>;
  /** update data of the table: "s3_file" */
  update_s3_file?: Maybe<S3_File_Mutation_Response>;
  /** update single row of the table: "s3_file" */
  update_s3_file_by_pk?: Maybe<S3_File>;
  /** update data of the table: "team" */
  update_team?: Maybe<Team_Mutation_Response>;
  /** update single row of the table: "team" */
  update_team_by_pk?: Maybe<Team>;
  /** update data of the table: "user_permission" */
  update_user_permission?: Maybe<User_Permission_Mutation_Response>;
  /** update single row of the table: "user_permission" */
  update_user_permission_by_pk?: Maybe<User_Permission>;
  /** update data of the table: "user_permission_role" */
  update_user_permission_role?: Maybe<User_Permission_Role_Mutation_Response>;
  /** update single row of the table: "user_permission_role" */
  update_user_permission_role_by_pk?: Maybe<User_Permission_Role>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
};


/** mutation root */
export type Mutation_RootDelete_ClubArgs = {
  where: Club_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Club_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Editor_TypeArgs = {
  where: Editor_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Editor_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_Exercise_CategoriesArgs = {
  where: Enum_Exercise_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Exercise_Categories_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_LanguagesArgs = {
  where: Enum_Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Languages_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Enum_SportArgs = {
  where: Enum_Sport_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enum_Sport_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ExerciseArgs = {
  where: Exercise_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exercise_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Club_MnArgs = {
  where: Exercise_Club_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Club_Mn_By_PkArgs = {
  club_id: Scalars['String'];
  exercise_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Content_MediaArgs = {
  where: Exercise_Content_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Content_Media_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Content_Media_EditorArgs = {
  where: Exercise_Content_Media_Editor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Content_Media_Editor_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Content_Media_MnArgs = {
  where: Exercise_Content_Media_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Content_Media_Mn_By_PkArgs = {
  exercise_content_media_id: Scalars['String'];
  exercise_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Content_Media_TypeArgs = {
  where: Exercise_Content_Media_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Content_Media_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Exercise_TaxonomyArgs = {
  where: Exercise_Taxonomy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Taxonomy_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Taxonomy_MnArgs = {
  where: Exercise_Taxonomy_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Exercise_Taxonomy_Mn_By_PkArgs = {
  exercise_id: Scalars['String'];
  taxonomy_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_LicenseArgs = {
  where: License_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_License_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_MemberArgs = {
  where: Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Member_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Member_GroupArgs = {
  where: Member_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Member_Group_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Member_Group_MnArgs = {
  where: Member_Group_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Member_Group_Mn_By_PkArgs = {
  group_id: Scalars['String'];
  member_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_PaymentArgs = {
  where: Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_S3_FileArgs = {
  where: S3_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_S3_File_By_PkArgs = {
  s3key: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_TeamArgs = {
  where: Team_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_PermissionArgs = {
  where: User_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Permission_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_User_Permission_RoleArgs = {
  where: User_Permission_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Permission_Role_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_ClubArgs = {
  objects: Array<Club_Insert_Input>;
  on_conflict?: InputMaybe<Club_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Club_OneArgs = {
  object: Club_Insert_Input;
  on_conflict?: InputMaybe<Club_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Editor_TypeArgs = {
  objects: Array<Editor_Type_Insert_Input>;
  on_conflict?: InputMaybe<Editor_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Editor_Type_OneArgs = {
  object: Editor_Type_Insert_Input;
  on_conflict?: InputMaybe<Editor_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Exercise_CategoriesArgs = {
  objects: Array<Enum_Exercise_Categories_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Exercise_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Exercise_Categories_OneArgs = {
  object: Enum_Exercise_Categories_Insert_Input;
  on_conflict?: InputMaybe<Enum_Exercise_Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_LanguagesArgs = {
  objects: Array<Enum_Languages_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Languages_OneArgs = {
  object: Enum_Languages_Insert_Input;
  on_conflict?: InputMaybe<Enum_Languages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_SportArgs = {
  objects: Array<Enum_Sport_Insert_Input>;
  on_conflict?: InputMaybe<Enum_Sport_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enum_Sport_OneArgs = {
  object: Enum_Sport_Insert_Input;
  on_conflict?: InputMaybe<Enum_Sport_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ExerciseArgs = {
  objects: Array<Exercise_Insert_Input>;
  on_conflict?: InputMaybe<Exercise_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Club_MnArgs = {
  objects: Array<Exercise_Club_Mn_Insert_Input>;
  on_conflict?: InputMaybe<Exercise_Club_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Club_Mn_OneArgs = {
  object: Exercise_Club_Mn_Insert_Input;
  on_conflict?: InputMaybe<Exercise_Club_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Content_MediaArgs = {
  objects: Array<Exercise_Content_Media_Insert_Input>;
  on_conflict?: InputMaybe<Exercise_Content_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Content_Media_EditorArgs = {
  objects: Array<Exercise_Content_Media_Editor_Insert_Input>;
  on_conflict?: InputMaybe<Exercise_Content_Media_Editor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Content_Media_Editor_OneArgs = {
  object: Exercise_Content_Media_Editor_Insert_Input;
  on_conflict?: InputMaybe<Exercise_Content_Media_Editor_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Content_Media_MnArgs = {
  objects: Array<Exercise_Content_Media_Mn_Insert_Input>;
  on_conflict?: InputMaybe<Exercise_Content_Media_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Content_Media_Mn_OneArgs = {
  object: Exercise_Content_Media_Mn_Insert_Input;
  on_conflict?: InputMaybe<Exercise_Content_Media_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Content_Media_OneArgs = {
  object: Exercise_Content_Media_Insert_Input;
  on_conflict?: InputMaybe<Exercise_Content_Media_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Content_Media_TypeArgs = {
  objects: Array<Exercise_Content_Media_Type_Insert_Input>;
  on_conflict?: InputMaybe<Exercise_Content_Media_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Content_Media_Type_OneArgs = {
  object: Exercise_Content_Media_Type_Insert_Input;
  on_conflict?: InputMaybe<Exercise_Content_Media_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_OneArgs = {
  object: Exercise_Insert_Input;
  on_conflict?: InputMaybe<Exercise_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_TaxonomyArgs = {
  objects: Array<Exercise_Taxonomy_Insert_Input>;
  on_conflict?: InputMaybe<Exercise_Taxonomy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Taxonomy_MnArgs = {
  objects: Array<Exercise_Taxonomy_Mn_Insert_Input>;
  on_conflict?: InputMaybe<Exercise_Taxonomy_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Taxonomy_Mn_OneArgs = {
  object: Exercise_Taxonomy_Mn_Insert_Input;
  on_conflict?: InputMaybe<Exercise_Taxonomy_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Exercise_Taxonomy_OneArgs = {
  object: Exercise_Taxonomy_Insert_Input;
  on_conflict?: InputMaybe<Exercise_Taxonomy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LicenseArgs = {
  objects: Array<License_Insert_Input>;
  on_conflict?: InputMaybe<License_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_License_OneArgs = {
  object: License_Insert_Input;
  on_conflict?: InputMaybe<License_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MemberArgs = {
  objects: Array<Member_Insert_Input>;
  on_conflict?: InputMaybe<Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Member_GroupArgs = {
  objects: Array<Member_Group_Insert_Input>;
  on_conflict?: InputMaybe<Member_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Member_Group_MnArgs = {
  objects: Array<Member_Group_Mn_Insert_Input>;
  on_conflict?: InputMaybe<Member_Group_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Member_Group_Mn_OneArgs = {
  object: Member_Group_Mn_Insert_Input;
  on_conflict?: InputMaybe<Member_Group_Mn_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Member_Group_OneArgs = {
  object: Member_Group_Insert_Input;
  on_conflict?: InputMaybe<Member_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Member_OneArgs = {
  object: Member_Insert_Input;
  on_conflict?: InputMaybe<Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PaymentArgs = {
  objects: Array<Payment_Insert_Input>;
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_OneArgs = {
  object: Payment_Insert_Input;
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_S3_FileArgs = {
  objects: Array<S3_File_Insert_Input>;
  on_conflict?: InputMaybe<S3_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_S3_File_OneArgs = {
  object: S3_File_Insert_Input;
  on_conflict?: InputMaybe<S3_File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeamArgs = {
  objects: Array<Team_Insert_Input>;
  on_conflict?: InputMaybe<Team_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_OneArgs = {
  object: Team_Insert_Input;
  on_conflict?: InputMaybe<Team_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_PermissionArgs = {
  objects: Array<User_Permission_Insert_Input>;
  on_conflict?: InputMaybe<User_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Permission_OneArgs = {
  object: User_Permission_Insert_Input;
  on_conflict?: InputMaybe<User_Permission_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Permission_RoleArgs = {
  objects: Array<User_Permission_Role_Insert_Input>;
  on_conflict?: InputMaybe<User_Permission_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Permission_Role_OneArgs = {
  object: User_Permission_Role_Insert_Input;
  on_conflict?: InputMaybe<User_Permission_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_ClubArgs = {
  _set?: InputMaybe<Club_Set_Input>;
  where: Club_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Club_By_PkArgs = {
  _set?: InputMaybe<Club_Set_Input>;
  pk_columns: Club_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Editor_TypeArgs = {
  _set?: InputMaybe<Editor_Type_Set_Input>;
  where: Editor_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Editor_Type_By_PkArgs = {
  _set?: InputMaybe<Editor_Type_Set_Input>;
  pk_columns: Editor_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Exercise_CategoriesArgs = {
  _set?: InputMaybe<Enum_Exercise_Categories_Set_Input>;
  where: Enum_Exercise_Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Exercise_Categories_By_PkArgs = {
  _set?: InputMaybe<Enum_Exercise_Categories_Set_Input>;
  pk_columns: Enum_Exercise_Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_LanguagesArgs = {
  _set?: InputMaybe<Enum_Languages_Set_Input>;
  where: Enum_Languages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Languages_By_PkArgs = {
  _set?: InputMaybe<Enum_Languages_Set_Input>;
  pk_columns: Enum_Languages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_SportArgs = {
  _set?: InputMaybe<Enum_Sport_Set_Input>;
  where: Enum_Sport_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enum_Sport_By_PkArgs = {
  _set?: InputMaybe<Enum_Sport_Set_Input>;
  pk_columns: Enum_Sport_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ExerciseArgs = {
  _inc?: InputMaybe<Exercise_Inc_Input>;
  _set?: InputMaybe<Exercise_Set_Input>;
  where: Exercise_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_By_PkArgs = {
  _inc?: InputMaybe<Exercise_Inc_Input>;
  _set?: InputMaybe<Exercise_Set_Input>;
  pk_columns: Exercise_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Club_MnArgs = {
  _set?: InputMaybe<Exercise_Club_Mn_Set_Input>;
  where: Exercise_Club_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Club_Mn_By_PkArgs = {
  _set?: InputMaybe<Exercise_Club_Mn_Set_Input>;
  pk_columns: Exercise_Club_Mn_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Content_MediaArgs = {
  _set?: InputMaybe<Exercise_Content_Media_Set_Input>;
  where: Exercise_Content_Media_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Content_Media_By_PkArgs = {
  _set?: InputMaybe<Exercise_Content_Media_Set_Input>;
  pk_columns: Exercise_Content_Media_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Content_Media_EditorArgs = {
  _append?: InputMaybe<Exercise_Content_Media_Editor_Append_Input>;
  _delete_at_path?: InputMaybe<Exercise_Content_Media_Editor_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Exercise_Content_Media_Editor_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Exercise_Content_Media_Editor_Delete_Key_Input>;
  _prepend?: InputMaybe<Exercise_Content_Media_Editor_Prepend_Input>;
  _set?: InputMaybe<Exercise_Content_Media_Editor_Set_Input>;
  where: Exercise_Content_Media_Editor_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Content_Media_Editor_By_PkArgs = {
  _append?: InputMaybe<Exercise_Content_Media_Editor_Append_Input>;
  _delete_at_path?: InputMaybe<Exercise_Content_Media_Editor_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Exercise_Content_Media_Editor_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Exercise_Content_Media_Editor_Delete_Key_Input>;
  _prepend?: InputMaybe<Exercise_Content_Media_Editor_Prepend_Input>;
  _set?: InputMaybe<Exercise_Content_Media_Editor_Set_Input>;
  pk_columns: Exercise_Content_Media_Editor_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Content_Media_MnArgs = {
  _inc?: InputMaybe<Exercise_Content_Media_Mn_Inc_Input>;
  _set?: InputMaybe<Exercise_Content_Media_Mn_Set_Input>;
  where: Exercise_Content_Media_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Content_Media_Mn_By_PkArgs = {
  _inc?: InputMaybe<Exercise_Content_Media_Mn_Inc_Input>;
  _set?: InputMaybe<Exercise_Content_Media_Mn_Set_Input>;
  pk_columns: Exercise_Content_Media_Mn_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Content_Media_TypeArgs = {
  _set?: InputMaybe<Exercise_Content_Media_Type_Set_Input>;
  where: Exercise_Content_Media_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Content_Media_Type_By_PkArgs = {
  _set?: InputMaybe<Exercise_Content_Media_Type_Set_Input>;
  pk_columns: Exercise_Content_Media_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_TaxonomyArgs = {
  _set?: InputMaybe<Exercise_Taxonomy_Set_Input>;
  where: Exercise_Taxonomy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Taxonomy_By_PkArgs = {
  _set?: InputMaybe<Exercise_Taxonomy_Set_Input>;
  pk_columns: Exercise_Taxonomy_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Taxonomy_MnArgs = {
  _set?: InputMaybe<Exercise_Taxonomy_Mn_Set_Input>;
  where: Exercise_Taxonomy_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Exercise_Taxonomy_Mn_By_PkArgs = {
  _set?: InputMaybe<Exercise_Taxonomy_Mn_Set_Input>;
  pk_columns: Exercise_Taxonomy_Mn_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LicenseArgs = {
  _set?: InputMaybe<License_Set_Input>;
  where: License_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_License_By_PkArgs = {
  _set?: InputMaybe<License_Set_Input>;
  pk_columns: License_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MemberArgs = {
  _set?: InputMaybe<Member_Set_Input>;
  where: Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Member_By_PkArgs = {
  _set?: InputMaybe<Member_Set_Input>;
  pk_columns: Member_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Member_GroupArgs = {
  _set?: InputMaybe<Member_Group_Set_Input>;
  where: Member_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Member_Group_By_PkArgs = {
  _set?: InputMaybe<Member_Group_Set_Input>;
  pk_columns: Member_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Member_Group_MnArgs = {
  _set?: InputMaybe<Member_Group_Mn_Set_Input>;
  where: Member_Group_Mn_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Member_Group_Mn_By_PkArgs = {
  _set?: InputMaybe<Member_Group_Mn_Set_Input>;
  pk_columns: Member_Group_Mn_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_PaymentArgs = {
  _set?: InputMaybe<Payment_Set_Input>;
  where: Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_By_PkArgs = {
  _set?: InputMaybe<Payment_Set_Input>;
  pk_columns: Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_S3_FileArgs = {
  _inc?: InputMaybe<S3_File_Inc_Input>;
  _set?: InputMaybe<S3_File_Set_Input>;
  where: S3_File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_S3_File_By_PkArgs = {
  _inc?: InputMaybe<S3_File_Inc_Input>;
  _set?: InputMaybe<S3_File_Set_Input>;
  pk_columns: S3_File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_TeamArgs = {
  _set?: InputMaybe<Team_Set_Input>;
  where: Team_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Team_By_PkArgs = {
  _set?: InputMaybe<Team_Set_Input>;
  pk_columns: Team_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_PermissionArgs = {
  _inc?: InputMaybe<User_Permission_Inc_Input>;
  _set?: InputMaybe<User_Permission_Set_Input>;
  where: User_Permission_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permission_By_PkArgs = {
  _inc?: InputMaybe<User_Permission_Inc_Input>;
  _set?: InputMaybe<User_Permission_Set_Input>;
  pk_columns: User_Permission_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permission_RoleArgs = {
  _set?: InputMaybe<User_Permission_Role_Set_Input>;
  where: User_Permission_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permission_Role_By_PkArgs = {
  _set?: InputMaybe<User_Permission_Role_Set_Input>;
  pk_columns: User_Permission_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "payment" */
export type Payment = {
  __typename?: 'payment';
  active?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  club: Club;
  club_id: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  fastspring_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_trial?: Maybe<Scalars['Boolean']>;
  license?: Maybe<License_Enum>;
  /** An object relationship */
  licenseByLicense?: Maybe<License>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_until?: Maybe<Scalars['date']>;
};

/** aggregated selection of "payment" */
export type Payment_Aggregate = {
  __typename?: 'payment_aggregate';
  aggregate?: Maybe<Payment_Aggregate_Fields>;
  nodes: Array<Payment>;
};

/** aggregate fields of "payment" */
export type Payment_Aggregate_Fields = {
  __typename?: 'payment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Payment_Max_Fields>;
  min?: Maybe<Payment_Min_Fields>;
};


/** aggregate fields of "payment" */
export type Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "payment" */
export type Payment_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Payment_Max_Order_By>;
  min?: InputMaybe<Payment_Min_Order_By>;
};

/** input type for inserting array relation for remote table "payment" */
export type Payment_Arr_Rel_Insert_Input = {
  data: Array<Payment_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Payment_On_Conflict>;
};

/** Boolean expression to filter rows from the table "payment". All fields are combined with a logical 'AND'. */
export type Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Bool_Exp>>;
  _not?: InputMaybe<Payment_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  club?: InputMaybe<Club_Bool_Exp>;
  club_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fastspring_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  is_trial?: InputMaybe<Boolean_Comparison_Exp>;
  license?: InputMaybe<License_Enum_Comparison_Exp>;
  licenseByLicense?: InputMaybe<License_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_until?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment" */
export enum Payment_Constraint {
  /** unique or primary key constraint */
  PaymentFastspringIdKey = 'payment_fastspring_id_key',
  /** unique or primary key constraint */
  PaymentPkey = 'payment_pkey'
}

/** input type for inserting data into table "payment" */
export type Payment_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  club?: InputMaybe<Club_Obj_Rel_Insert_Input>;
  club_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fastspring_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  is_trial?: InputMaybe<Scalars['Boolean']>;
  license?: InputMaybe<License_Enum>;
  licenseByLicense?: InputMaybe<License_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_until?: InputMaybe<Scalars['date']>;
};

/** aggregate max on columns */
export type Payment_Max_Fields = {
  __typename?: 'payment_max_fields';
  club_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fastspring_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_until?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "payment" */
export type Payment_Max_Order_By = {
  club_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fastspring_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Payment_Min_Fields = {
  __typename?: 'payment_min_fields';
  club_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fastspring_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid_until?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "payment" */
export type Payment_Min_Order_By = {
  club_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fastspring_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "payment" */
export type Payment_Mutation_Response = {
  __typename?: 'payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment>;
};

/** on conflict condition type for table "payment" */
export type Payment_On_Conflict = {
  constraint: Payment_Constraint;
  update_columns?: Array<Payment_Update_Column>;
  where?: InputMaybe<Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "payment". */
export type Payment_Order_By = {
  active?: InputMaybe<Order_By>;
  club?: InputMaybe<Club_Order_By>;
  club_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fastspring_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_trial?: InputMaybe<Order_By>;
  license?: InputMaybe<Order_By>;
  licenseByLicense?: InputMaybe<License_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment */
export type Payment_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "payment" */
export enum Payment_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ClubId = 'club_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FastspringId = 'fastspring_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsTrial = 'is_trial',
  /** column name */
  License = 'license',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidUntil = 'valid_until'
}

/** input type for updating data in table "payment" */
export type Payment_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  club_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  fastspring_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  is_trial?: InputMaybe<Scalars['Boolean']>;
  license?: InputMaybe<License_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_until?: InputMaybe<Scalars['date']>;
};

/** update columns of table "payment" */
export enum Payment_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ClubId = 'club_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FastspringId = 'fastspring_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsTrial = 'is_trial',
  /** column name */
  License = 'license',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidUntil = 'valid_until'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "club" */
  club: Array<Club>;
  /** fetch aggregated fields from the table: "club" */
  club_aggregate: Club_Aggregate;
  /** fetch data from the table: "club" using primary key columns */
  club_by_pk?: Maybe<Club>;
  /** fetch data from the table: "editor_type" */
  editor_type: Array<Editor_Type>;
  /** fetch aggregated fields from the table: "editor_type" */
  editor_type_aggregate: Editor_Type_Aggregate;
  /** fetch data from the table: "editor_type" using primary key columns */
  editor_type_by_pk?: Maybe<Editor_Type>;
  /** fetch data from the table: "enum_exercise_categories" */
  enum_exercise_categories: Array<Enum_Exercise_Categories>;
  /** fetch aggregated fields from the table: "enum_exercise_categories" */
  enum_exercise_categories_aggregate: Enum_Exercise_Categories_Aggregate;
  /** fetch data from the table: "enum_exercise_categories" using primary key columns */
  enum_exercise_categories_by_pk?: Maybe<Enum_Exercise_Categories>;
  /** fetch data from the table: "enum_languages" */
  enum_languages: Array<Enum_Languages>;
  /** fetch aggregated fields from the table: "enum_languages" */
  enum_languages_aggregate: Enum_Languages_Aggregate;
  /** fetch data from the table: "enum_languages" using primary key columns */
  enum_languages_by_pk?: Maybe<Enum_Languages>;
  /** fetch data from the table: "enum_sport" */
  enum_sport: Array<Enum_Sport>;
  /** fetch aggregated fields from the table: "enum_sport" */
  enum_sport_aggregate: Enum_Sport_Aggregate;
  /** fetch data from the table: "enum_sport" using primary key columns */
  enum_sport_by_pk?: Maybe<Enum_Sport>;
  /** fetch data from the table: "exercise" */
  exercise: Array<Exercise>;
  /** fetch aggregated fields from the table: "exercise" */
  exercise_aggregate: Exercise_Aggregate;
  /** fetch data from the table: "exercise" using primary key columns */
  exercise_by_pk?: Maybe<Exercise>;
  /** fetch data from the table: "exercise_club_mn" */
  exercise_club_mn: Array<Exercise_Club_Mn>;
  /** fetch aggregated fields from the table: "exercise_club_mn" */
  exercise_club_mn_aggregate: Exercise_Club_Mn_Aggregate;
  /** fetch data from the table: "exercise_club_mn" using primary key columns */
  exercise_club_mn_by_pk?: Maybe<Exercise_Club_Mn>;
  /** An array relationship */
  exercise_content_media: Array<Exercise_Content_Media>;
  /** An aggregate relationship */
  exercise_content_media_aggregate: Exercise_Content_Media_Aggregate;
  /** fetch data from the table: "exercise_content_media" using primary key columns */
  exercise_content_media_by_pk?: Maybe<Exercise_Content_Media>;
  /** fetch data from the table: "exercise_content_media_editor" */
  exercise_content_media_editor: Array<Exercise_Content_Media_Editor>;
  /** fetch aggregated fields from the table: "exercise_content_media_editor" */
  exercise_content_media_editor_aggregate: Exercise_Content_Media_Editor_Aggregate;
  /** fetch data from the table: "exercise_content_media_editor" using primary key columns */
  exercise_content_media_editor_by_pk?: Maybe<Exercise_Content_Media_Editor>;
  /** fetch data from the table: "exercise_content_media_mn" */
  exercise_content_media_mn: Array<Exercise_Content_Media_Mn>;
  /** fetch aggregated fields from the table: "exercise_content_media_mn" */
  exercise_content_media_mn_aggregate: Exercise_Content_Media_Mn_Aggregate;
  /** fetch data from the table: "exercise_content_media_mn" using primary key columns */
  exercise_content_media_mn_by_pk?: Maybe<Exercise_Content_Media_Mn>;
  /** fetch data from the table: "exercise_content_media_type" */
  exercise_content_media_type: Array<Exercise_Content_Media_Type>;
  /** fetch aggregated fields from the table: "exercise_content_media_type" */
  exercise_content_media_type_aggregate: Exercise_Content_Media_Type_Aggregate;
  /** fetch data from the table: "exercise_content_media_type" using primary key columns */
  exercise_content_media_type_by_pk?: Maybe<Exercise_Content_Media_Type>;
  /** fetch data from the table: "exercise_taxonomy" */
  exercise_taxonomy: Array<Exercise_Taxonomy>;
  /** fetch aggregated fields from the table: "exercise_taxonomy" */
  exercise_taxonomy_aggregate: Exercise_Taxonomy_Aggregate;
  /** fetch data from the table: "exercise_taxonomy" using primary key columns */
  exercise_taxonomy_by_pk?: Maybe<Exercise_Taxonomy>;
  /** fetch data from the table: "exercise_taxonomy_mn" */
  exercise_taxonomy_mn: Array<Exercise_Taxonomy_Mn>;
  /** fetch aggregated fields from the table: "exercise_taxonomy_mn" */
  exercise_taxonomy_mn_aggregate: Exercise_Taxonomy_Mn_Aggregate;
  /** fetch data from the table: "exercise_taxonomy_mn" using primary key columns */
  exercise_taxonomy_mn_by_pk?: Maybe<Exercise_Taxonomy_Mn>;
  /** fetch data from the table: "license" */
  license: Array<License>;
  /** fetch aggregated fields from the table: "license" */
  license_aggregate: License_Aggregate;
  /** fetch data from the table: "license" using primary key columns */
  license_by_pk?: Maybe<License>;
  /** fetch data from the table: "member" */
  member: Array<Member>;
  /** fetch aggregated fields from the table: "member" */
  member_aggregate: Member_Aggregate;
  /** fetch data from the table: "member" using primary key columns */
  member_by_pk?: Maybe<Member>;
  /** fetch data from the table: "member_group" */
  member_group: Array<Member_Group>;
  /** fetch aggregated fields from the table: "member_group" */
  member_group_aggregate: Member_Group_Aggregate;
  /** fetch data from the table: "member_group" using primary key columns */
  member_group_by_pk?: Maybe<Member_Group>;
  /** fetch data from the table: "member_group_mn" */
  member_group_mn: Array<Member_Group_Mn>;
  /** fetch aggregated fields from the table: "member_group_mn" */
  member_group_mn_aggregate: Member_Group_Mn_Aggregate;
  /** fetch data from the table: "member_group_mn" using primary key columns */
  member_group_mn_by_pk?: Maybe<Member_Group_Mn>;
  /** fetch data from the table: "payment" */
  payment: Array<Payment>;
  /** fetch aggregated fields from the table: "payment" */
  payment_aggregate: Payment_Aggregate;
  /** fetch data from the table: "payment" using primary key columns */
  payment_by_pk?: Maybe<Payment>;
  /** fetch data from the table: "s3_file" */
  s3_file: Array<S3_File>;
  /** fetch aggregated fields from the table: "s3_file" */
  s3_file_aggregate: S3_File_Aggregate;
  /** fetch data from the table: "s3_file" using primary key columns */
  s3_file_by_pk?: Maybe<S3_File>;
  /** fetch data from the table: "team" */
  team: Array<Team>;
  /** fetch aggregated fields from the table: "team" */
  team_aggregate: Team_Aggregate;
  /** fetch data from the table: "team" using primary key columns */
  team_by_pk?: Maybe<Team>;
  /** fetch data from the table: "user_permission" */
  user_permission: Array<User_Permission>;
  /** fetch aggregated fields from the table: "user_permission" */
  user_permission_aggregate: User_Permission_Aggregate;
  /** fetch data from the table: "user_permission" using primary key columns */
  user_permission_by_pk?: Maybe<User_Permission>;
  /** fetch data from the table: "user_permission_role" */
  user_permission_role: Array<User_Permission_Role>;
  /** fetch aggregated fields from the table: "user_permission_role" */
  user_permission_role_aggregate: User_Permission_Role_Aggregate;
  /** fetch data from the table: "user_permission_role" using primary key columns */
  user_permission_role_by_pk?: Maybe<User_Permission_Role>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Query_RootClubArgs = {
  distinct_on?: InputMaybe<Array<Club_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Club_Order_By>>;
  where?: InputMaybe<Club_Bool_Exp>;
};


export type Query_RootClub_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Club_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Club_Order_By>>;
  where?: InputMaybe<Club_Bool_Exp>;
};


export type Query_RootClub_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootEditor_TypeArgs = {
  distinct_on?: InputMaybe<Array<Editor_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Editor_Type_Order_By>>;
  where?: InputMaybe<Editor_Type_Bool_Exp>;
};


export type Query_RootEditor_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Editor_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Editor_Type_Order_By>>;
  where?: InputMaybe<Editor_Type_Bool_Exp>;
};


export type Query_RootEditor_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEnum_Exercise_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Enum_Exercise_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enum_Exercise_Categories_Order_By>>;
  where?: InputMaybe<Enum_Exercise_Categories_Bool_Exp>;
};


export type Query_RootEnum_Exercise_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Exercise_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enum_Exercise_Categories_Order_By>>;
  where?: InputMaybe<Enum_Exercise_Categories_Bool_Exp>;
};


export type Query_RootEnum_Exercise_Categories_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEnum_LanguagesArgs = {
  distinct_on?: InputMaybe<Array<Enum_Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enum_Languages_Order_By>>;
  where?: InputMaybe<Enum_Languages_Bool_Exp>;
};


export type Query_RootEnum_Languages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enum_Languages_Order_By>>;
  where?: InputMaybe<Enum_Languages_Bool_Exp>;
};


export type Query_RootEnum_Languages_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootEnum_SportArgs = {
  distinct_on?: InputMaybe<Array<Enum_Sport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enum_Sport_Order_By>>;
  where?: InputMaybe<Enum_Sport_Bool_Exp>;
};


export type Query_RootEnum_Sport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Sport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enum_Sport_Order_By>>;
  where?: InputMaybe<Enum_Sport_Bool_Exp>;
};


export type Query_RootEnum_Sport_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootExerciseArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Order_By>>;
  where?: InputMaybe<Exercise_Bool_Exp>;
};


export type Query_RootExercise_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Order_By>>;
  where?: InputMaybe<Exercise_Bool_Exp>;
};


export type Query_RootExercise_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootExercise_Club_MnArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Club_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Club_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Club_Mn_Bool_Exp>;
};


export type Query_RootExercise_Club_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Club_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Club_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Club_Mn_Bool_Exp>;
};


export type Query_RootExercise_Club_Mn_By_PkArgs = {
  club_id: Scalars['String'];
  exercise_id: Scalars['String'];
};


export type Query_RootExercise_Content_MediaArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
};


export type Query_RootExercise_Content_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
};


export type Query_RootExercise_Content_Media_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootExercise_Content_Media_EditorArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Editor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Editor_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
};


export type Query_RootExercise_Content_Media_Editor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Editor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Editor_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
};


export type Query_RootExercise_Content_Media_Editor_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootExercise_Content_Media_MnArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Mn_Bool_Exp>;
};


export type Query_RootExercise_Content_Media_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Mn_Bool_Exp>;
};


export type Query_RootExercise_Content_Media_Mn_By_PkArgs = {
  exercise_content_media_id: Scalars['String'];
  exercise_id: Scalars['String'];
};


export type Query_RootExercise_Content_Media_TypeArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Type_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Type_Bool_Exp>;
};


export type Query_RootExercise_Content_Media_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Type_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Type_Bool_Exp>;
};


export type Query_RootExercise_Content_Media_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootExercise_TaxonomyArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
};


export type Query_RootExercise_Taxonomy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
};


export type Query_RootExercise_Taxonomy_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootExercise_Taxonomy_MnArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Mn_Bool_Exp>;
};


export type Query_RootExercise_Taxonomy_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Mn_Bool_Exp>;
};


export type Query_RootExercise_Taxonomy_Mn_By_PkArgs = {
  exercise_id: Scalars['String'];
  taxonomy_id: Scalars['String'];
};


export type Query_RootLicenseArgs = {
  distinct_on?: InputMaybe<Array<License_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<License_Order_By>>;
  where?: InputMaybe<License_Bool_Exp>;
};


export type Query_RootLicense_AggregateArgs = {
  distinct_on?: InputMaybe<Array<License_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<License_Order_By>>;
  where?: InputMaybe<License_Bool_Exp>;
};


export type Query_RootLicense_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootMemberArgs = {
  distinct_on?: InputMaybe<Array<Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Order_By>>;
  where?: InputMaybe<Member_Bool_Exp>;
};


export type Query_RootMember_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Order_By>>;
  where?: InputMaybe<Member_Bool_Exp>;
};


export type Query_RootMember_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootMember_GroupArgs = {
  distinct_on?: InputMaybe<Array<Member_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Group_Order_By>>;
  where?: InputMaybe<Member_Group_Bool_Exp>;
};


export type Query_RootMember_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Member_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Group_Order_By>>;
  where?: InputMaybe<Member_Group_Bool_Exp>;
};


export type Query_RootMember_Group_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootMember_Group_MnArgs = {
  distinct_on?: InputMaybe<Array<Member_Group_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Group_Mn_Order_By>>;
  where?: InputMaybe<Member_Group_Mn_Bool_Exp>;
};


export type Query_RootMember_Group_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Member_Group_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Group_Mn_Order_By>>;
  where?: InputMaybe<Member_Group_Mn_Bool_Exp>;
};


export type Query_RootMember_Group_Mn_By_PkArgs = {
  group_id: Scalars['String'];
  member_id: Scalars['String'];
};


export type Query_RootPaymentArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Query_RootPayment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Query_RootPayment_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootS3_FileArgs = {
  distinct_on?: InputMaybe<Array<S3_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<S3_File_Order_By>>;
  where?: InputMaybe<S3_File_Bool_Exp>;
};


export type Query_RootS3_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<S3_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<S3_File_Order_By>>;
  where?: InputMaybe<S3_File_Bool_Exp>;
};


export type Query_RootS3_File_By_PkArgs = {
  s3key: Scalars['String'];
};


export type Query_RootTeamArgs = {
  distinct_on?: InputMaybe<Array<Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Order_By>>;
  where?: InputMaybe<Team_Bool_Exp>;
};


export type Query_RootTeam_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Order_By>>;
  where?: InputMaybe<Team_Bool_Exp>;
};


export type Query_RootTeam_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUser_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


export type Query_RootUser_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


export type Query_RootUser_Permission_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUser_Permission_RoleArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Role_Order_By>>;
  where?: InputMaybe<User_Permission_Role_Bool_Exp>;
};


export type Query_RootUser_Permission_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Role_Order_By>>;
  where?: InputMaybe<User_Permission_Role_Bool_Exp>;
};


export type Query_RootUser_Permission_Role_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['String'];
};

/** columns and relationships of "s3_file" */
export type S3_File = {
  __typename?: 's3_file';
  /** An array relationship */
  exercise_content_media: Array<Exercise_Content_Media>;
  /** An aggregate relationship */
  exercise_content_media_aggregate: Exercise_Content_Media_Aggregate;
  /** An array relationship */
  exercise_content_media_editor_image: Array<Exercise_Content_Media_Editor>;
  /** An aggregate relationship */
  exercise_content_media_editor_image_aggregate: Exercise_Content_Media_Editor_Aggregate;
  /** An array relationship */
  exercise_content_media_editor_video: Array<Exercise_Content_Media_Editor>;
  /** An aggregate relationship */
  exercise_content_media_editor_video_aggregate: Exercise_Content_Media_Editor_Aggregate;
  name?: Maybe<Scalars['String']>;
  s3key: Scalars['String'];
  size: Scalars['bigint'];
  type: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "s3_file" */
export type S3_FileExercise_Content_MediaArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
};


/** columns and relationships of "s3_file" */
export type S3_FileExercise_Content_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
};


/** columns and relationships of "s3_file" */
export type S3_FileExercise_Content_Media_Editor_ImageArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Editor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Editor_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
};


/** columns and relationships of "s3_file" */
export type S3_FileExercise_Content_Media_Editor_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Editor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Editor_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
};


/** columns and relationships of "s3_file" */
export type S3_FileExercise_Content_Media_Editor_VideoArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Editor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Editor_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
};


/** columns and relationships of "s3_file" */
export type S3_FileExercise_Content_Media_Editor_Video_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Editor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Editor_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
};

/** aggregated selection of "s3_file" */
export type S3_File_Aggregate = {
  __typename?: 's3_file_aggregate';
  aggregate?: Maybe<S3_File_Aggregate_Fields>;
  nodes: Array<S3_File>;
};

/** aggregate fields of "s3_file" */
export type S3_File_Aggregate_Fields = {
  __typename?: 's3_file_aggregate_fields';
  avg?: Maybe<S3_File_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<S3_File_Max_Fields>;
  min?: Maybe<S3_File_Min_Fields>;
  stddev?: Maybe<S3_File_Stddev_Fields>;
  stddev_pop?: Maybe<S3_File_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<S3_File_Stddev_Samp_Fields>;
  sum?: Maybe<S3_File_Sum_Fields>;
  var_pop?: Maybe<S3_File_Var_Pop_Fields>;
  var_samp?: Maybe<S3_File_Var_Samp_Fields>;
  variance?: Maybe<S3_File_Variance_Fields>;
};


/** aggregate fields of "s3_file" */
export type S3_File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<S3_File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type S3_File_Avg_Fields = {
  __typename?: 's3_file_avg_fields';
  size?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "s3_file". All fields are combined with a logical 'AND'. */
export type S3_File_Bool_Exp = {
  _and?: InputMaybe<Array<S3_File_Bool_Exp>>;
  _not?: InputMaybe<S3_File_Bool_Exp>;
  _or?: InputMaybe<Array<S3_File_Bool_Exp>>;
  exercise_content_media?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
  exercise_content_media_editor_image?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
  exercise_content_media_editor_video?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  s3key?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "s3_file" */
export enum S3_File_Constraint {
  /** unique or primary key constraint */
  S3FilePkey = 's3_file_pkey'
}

/** input type for incrementing numeric columns in table "s3_file" */
export type S3_File_Inc_Input = {
  size?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "s3_file" */
export type S3_File_Insert_Input = {
  exercise_content_media?: InputMaybe<Exercise_Content_Media_Arr_Rel_Insert_Input>;
  exercise_content_media_editor_image?: InputMaybe<Exercise_Content_Media_Editor_Arr_Rel_Insert_Input>;
  exercise_content_media_editor_video?: InputMaybe<Exercise_Content_Media_Editor_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  s3key?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type S3_File_Max_Fields = {
  __typename?: 's3_file_max_fields';
  name?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type S3_File_Min_Fields = {
  __typename?: 's3_file_min_fields';
  name?: Maybe<Scalars['String']>;
  s3key?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['bigint']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "s3_file" */
export type S3_File_Mutation_Response = {
  __typename?: 's3_file_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<S3_File>;
};

/** input type for inserting object relation for remote table "s3_file" */
export type S3_File_Obj_Rel_Insert_Input = {
  data: S3_File_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<S3_File_On_Conflict>;
};

/** on conflict condition type for table "s3_file" */
export type S3_File_On_Conflict = {
  constraint: S3_File_Constraint;
  update_columns?: Array<S3_File_Update_Column>;
  where?: InputMaybe<S3_File_Bool_Exp>;
};

/** Ordering options when selecting data from "s3_file". */
export type S3_File_Order_By = {
  exercise_content_media_aggregate?: InputMaybe<Exercise_Content_Media_Aggregate_Order_By>;
  exercise_content_media_editor_image_aggregate?: InputMaybe<Exercise_Content_Media_Editor_Aggregate_Order_By>;
  exercise_content_media_editor_video_aggregate?: InputMaybe<Exercise_Content_Media_Editor_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  s3key?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: s3_file */
export type S3_File_Pk_Columns_Input = {
  s3key: Scalars['String'];
};

/** select columns of table "s3_file" */
export enum S3_File_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  S3key = 's3key',
  /** column name */
  Size = 'size',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "s3_file" */
export type S3_File_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
  s3key?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type S3_File_Stddev_Fields = {
  __typename?: 's3_file_stddev_fields';
  size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type S3_File_Stddev_Pop_Fields = {
  __typename?: 's3_file_stddev_pop_fields';
  size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type S3_File_Stddev_Samp_Fields = {
  __typename?: 's3_file_stddev_samp_fields';
  size?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type S3_File_Sum_Fields = {
  __typename?: 's3_file_sum_fields';
  size?: Maybe<Scalars['bigint']>;
};

/** update columns of table "s3_file" */
export enum S3_File_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  S3key = 's3key',
  /** column name */
  Size = 'size',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url'
}

/** aggregate var_pop on columns */
export type S3_File_Var_Pop_Fields = {
  __typename?: 's3_file_var_pop_fields';
  size?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type S3_File_Var_Samp_Fields = {
  __typename?: 's3_file_var_samp_fields';
  size?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type S3_File_Variance_Fields = {
  __typename?: 's3_file_variance_fields';
  size?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "club" */
  club: Array<Club>;
  /** fetch aggregated fields from the table: "club" */
  club_aggregate: Club_Aggregate;
  /** fetch data from the table: "club" using primary key columns */
  club_by_pk?: Maybe<Club>;
  /** fetch data from the table: "editor_type" */
  editor_type: Array<Editor_Type>;
  /** fetch aggregated fields from the table: "editor_type" */
  editor_type_aggregate: Editor_Type_Aggregate;
  /** fetch data from the table: "editor_type" using primary key columns */
  editor_type_by_pk?: Maybe<Editor_Type>;
  /** fetch data from the table: "enum_exercise_categories" */
  enum_exercise_categories: Array<Enum_Exercise_Categories>;
  /** fetch aggregated fields from the table: "enum_exercise_categories" */
  enum_exercise_categories_aggregate: Enum_Exercise_Categories_Aggregate;
  /** fetch data from the table: "enum_exercise_categories" using primary key columns */
  enum_exercise_categories_by_pk?: Maybe<Enum_Exercise_Categories>;
  /** fetch data from the table: "enum_languages" */
  enum_languages: Array<Enum_Languages>;
  /** fetch aggregated fields from the table: "enum_languages" */
  enum_languages_aggregate: Enum_Languages_Aggregate;
  /** fetch data from the table: "enum_languages" using primary key columns */
  enum_languages_by_pk?: Maybe<Enum_Languages>;
  /** fetch data from the table: "enum_sport" */
  enum_sport: Array<Enum_Sport>;
  /** fetch aggregated fields from the table: "enum_sport" */
  enum_sport_aggregate: Enum_Sport_Aggregate;
  /** fetch data from the table: "enum_sport" using primary key columns */
  enum_sport_by_pk?: Maybe<Enum_Sport>;
  /** fetch data from the table: "exercise" */
  exercise: Array<Exercise>;
  /** fetch aggregated fields from the table: "exercise" */
  exercise_aggregate: Exercise_Aggregate;
  /** fetch data from the table: "exercise" using primary key columns */
  exercise_by_pk?: Maybe<Exercise>;
  /** fetch data from the table: "exercise_club_mn" */
  exercise_club_mn: Array<Exercise_Club_Mn>;
  /** fetch aggregated fields from the table: "exercise_club_mn" */
  exercise_club_mn_aggregate: Exercise_Club_Mn_Aggregate;
  /** fetch data from the table: "exercise_club_mn" using primary key columns */
  exercise_club_mn_by_pk?: Maybe<Exercise_Club_Mn>;
  /** An array relationship */
  exercise_content_media: Array<Exercise_Content_Media>;
  /** An aggregate relationship */
  exercise_content_media_aggregate: Exercise_Content_Media_Aggregate;
  /** fetch data from the table: "exercise_content_media" using primary key columns */
  exercise_content_media_by_pk?: Maybe<Exercise_Content_Media>;
  /** fetch data from the table: "exercise_content_media_editor" */
  exercise_content_media_editor: Array<Exercise_Content_Media_Editor>;
  /** fetch aggregated fields from the table: "exercise_content_media_editor" */
  exercise_content_media_editor_aggregate: Exercise_Content_Media_Editor_Aggregate;
  /** fetch data from the table: "exercise_content_media_editor" using primary key columns */
  exercise_content_media_editor_by_pk?: Maybe<Exercise_Content_Media_Editor>;
  /** fetch data from the table: "exercise_content_media_mn" */
  exercise_content_media_mn: Array<Exercise_Content_Media_Mn>;
  /** fetch aggregated fields from the table: "exercise_content_media_mn" */
  exercise_content_media_mn_aggregate: Exercise_Content_Media_Mn_Aggregate;
  /** fetch data from the table: "exercise_content_media_mn" using primary key columns */
  exercise_content_media_mn_by_pk?: Maybe<Exercise_Content_Media_Mn>;
  /** fetch data from the table: "exercise_content_media_type" */
  exercise_content_media_type: Array<Exercise_Content_Media_Type>;
  /** fetch aggregated fields from the table: "exercise_content_media_type" */
  exercise_content_media_type_aggregate: Exercise_Content_Media_Type_Aggregate;
  /** fetch data from the table: "exercise_content_media_type" using primary key columns */
  exercise_content_media_type_by_pk?: Maybe<Exercise_Content_Media_Type>;
  /** fetch data from the table: "exercise_taxonomy" */
  exercise_taxonomy: Array<Exercise_Taxonomy>;
  /** fetch aggregated fields from the table: "exercise_taxonomy" */
  exercise_taxonomy_aggregate: Exercise_Taxonomy_Aggregate;
  /** fetch data from the table: "exercise_taxonomy" using primary key columns */
  exercise_taxonomy_by_pk?: Maybe<Exercise_Taxonomy>;
  /** fetch data from the table: "exercise_taxonomy_mn" */
  exercise_taxonomy_mn: Array<Exercise_Taxonomy_Mn>;
  /** fetch aggregated fields from the table: "exercise_taxonomy_mn" */
  exercise_taxonomy_mn_aggregate: Exercise_Taxonomy_Mn_Aggregate;
  /** fetch data from the table: "exercise_taxonomy_mn" using primary key columns */
  exercise_taxonomy_mn_by_pk?: Maybe<Exercise_Taxonomy_Mn>;
  /** fetch data from the table: "license" */
  license: Array<License>;
  /** fetch aggregated fields from the table: "license" */
  license_aggregate: License_Aggregate;
  /** fetch data from the table: "license" using primary key columns */
  license_by_pk?: Maybe<License>;
  /** fetch data from the table: "member" */
  member: Array<Member>;
  /** fetch aggregated fields from the table: "member" */
  member_aggregate: Member_Aggregate;
  /** fetch data from the table: "member" using primary key columns */
  member_by_pk?: Maybe<Member>;
  /** fetch data from the table: "member_group" */
  member_group: Array<Member_Group>;
  /** fetch aggregated fields from the table: "member_group" */
  member_group_aggregate: Member_Group_Aggregate;
  /** fetch data from the table: "member_group" using primary key columns */
  member_group_by_pk?: Maybe<Member_Group>;
  /** fetch data from the table: "member_group_mn" */
  member_group_mn: Array<Member_Group_Mn>;
  /** fetch aggregated fields from the table: "member_group_mn" */
  member_group_mn_aggregate: Member_Group_Mn_Aggregate;
  /** fetch data from the table: "member_group_mn" using primary key columns */
  member_group_mn_by_pk?: Maybe<Member_Group_Mn>;
  /** fetch data from the table: "payment" */
  payment: Array<Payment>;
  /** fetch aggregated fields from the table: "payment" */
  payment_aggregate: Payment_Aggregate;
  /** fetch data from the table: "payment" using primary key columns */
  payment_by_pk?: Maybe<Payment>;
  /** fetch data from the table: "s3_file" */
  s3_file: Array<S3_File>;
  /** fetch aggregated fields from the table: "s3_file" */
  s3_file_aggregate: S3_File_Aggregate;
  /** fetch data from the table: "s3_file" using primary key columns */
  s3_file_by_pk?: Maybe<S3_File>;
  /** fetch data from the table: "team" */
  team: Array<Team>;
  /** fetch aggregated fields from the table: "team" */
  team_aggregate: Team_Aggregate;
  /** fetch data from the table: "team" using primary key columns */
  team_by_pk?: Maybe<Team>;
  /** fetch data from the table: "user_permission" */
  user_permission: Array<User_Permission>;
  /** fetch aggregated fields from the table: "user_permission" */
  user_permission_aggregate: User_Permission_Aggregate;
  /** fetch data from the table: "user_permission" using primary key columns */
  user_permission_by_pk?: Maybe<User_Permission>;
  /** fetch data from the table: "user_permission_role" */
  user_permission_role: Array<User_Permission_Role>;
  /** fetch aggregated fields from the table: "user_permission_role" */
  user_permission_role_aggregate: User_Permission_Role_Aggregate;
  /** fetch data from the table: "user_permission_role" using primary key columns */
  user_permission_role_by_pk?: Maybe<User_Permission_Role>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Subscription_RootClubArgs = {
  distinct_on?: InputMaybe<Array<Club_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Club_Order_By>>;
  where?: InputMaybe<Club_Bool_Exp>;
};


export type Subscription_RootClub_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Club_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Club_Order_By>>;
  where?: InputMaybe<Club_Bool_Exp>;
};


export type Subscription_RootClub_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootEditor_TypeArgs = {
  distinct_on?: InputMaybe<Array<Editor_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Editor_Type_Order_By>>;
  where?: InputMaybe<Editor_Type_Bool_Exp>;
};


export type Subscription_RootEditor_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Editor_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Editor_Type_Order_By>>;
  where?: InputMaybe<Editor_Type_Bool_Exp>;
};


export type Subscription_RootEditor_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEnum_Exercise_CategoriesArgs = {
  distinct_on?: InputMaybe<Array<Enum_Exercise_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enum_Exercise_Categories_Order_By>>;
  where?: InputMaybe<Enum_Exercise_Categories_Bool_Exp>;
};


export type Subscription_RootEnum_Exercise_Categories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Exercise_Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enum_Exercise_Categories_Order_By>>;
  where?: InputMaybe<Enum_Exercise_Categories_Bool_Exp>;
};


export type Subscription_RootEnum_Exercise_Categories_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEnum_LanguagesArgs = {
  distinct_on?: InputMaybe<Array<Enum_Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enum_Languages_Order_By>>;
  where?: InputMaybe<Enum_Languages_Bool_Exp>;
};


export type Subscription_RootEnum_Languages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Languages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enum_Languages_Order_By>>;
  where?: InputMaybe<Enum_Languages_Bool_Exp>;
};


export type Subscription_RootEnum_Languages_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootEnum_SportArgs = {
  distinct_on?: InputMaybe<Array<Enum_Sport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enum_Sport_Order_By>>;
  where?: InputMaybe<Enum_Sport_Bool_Exp>;
};


export type Subscription_RootEnum_Sport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enum_Sport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Enum_Sport_Order_By>>;
  where?: InputMaybe<Enum_Sport_Bool_Exp>;
};


export type Subscription_RootEnum_Sport_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootExerciseArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Order_By>>;
  where?: InputMaybe<Exercise_Bool_Exp>;
};


export type Subscription_RootExercise_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Order_By>>;
  where?: InputMaybe<Exercise_Bool_Exp>;
};


export type Subscription_RootExercise_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootExercise_Club_MnArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Club_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Club_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Club_Mn_Bool_Exp>;
};


export type Subscription_RootExercise_Club_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Club_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Club_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Club_Mn_Bool_Exp>;
};


export type Subscription_RootExercise_Club_Mn_By_PkArgs = {
  club_id: Scalars['String'];
  exercise_id: Scalars['String'];
};


export type Subscription_RootExercise_Content_MediaArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
};


export type Subscription_RootExercise_Content_Media_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Bool_Exp>;
};


export type Subscription_RootExercise_Content_Media_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootExercise_Content_Media_EditorArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Editor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Editor_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
};


export type Subscription_RootExercise_Content_Media_Editor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Editor_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Editor_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Editor_Bool_Exp>;
};


export type Subscription_RootExercise_Content_Media_Editor_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootExercise_Content_Media_MnArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Mn_Bool_Exp>;
};


export type Subscription_RootExercise_Content_Media_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Mn_Bool_Exp>;
};


export type Subscription_RootExercise_Content_Media_Mn_By_PkArgs = {
  exercise_content_media_id: Scalars['String'];
  exercise_id: Scalars['String'];
};


export type Subscription_RootExercise_Content_Media_TypeArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Type_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Type_Bool_Exp>;
};


export type Subscription_RootExercise_Content_Media_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Content_Media_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Content_Media_Type_Order_By>>;
  where?: InputMaybe<Exercise_Content_Media_Type_Bool_Exp>;
};


export type Subscription_RootExercise_Content_Media_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootExercise_TaxonomyArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
};


export type Subscription_RootExercise_Taxonomy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Bool_Exp>;
};


export type Subscription_RootExercise_Taxonomy_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootExercise_Taxonomy_MnArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Mn_Bool_Exp>;
};


export type Subscription_RootExercise_Taxonomy_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Taxonomy_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Taxonomy_Mn_Order_By>>;
  where?: InputMaybe<Exercise_Taxonomy_Mn_Bool_Exp>;
};


export type Subscription_RootExercise_Taxonomy_Mn_By_PkArgs = {
  exercise_id: Scalars['String'];
  taxonomy_id: Scalars['String'];
};


export type Subscription_RootLicenseArgs = {
  distinct_on?: InputMaybe<Array<License_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<License_Order_By>>;
  where?: InputMaybe<License_Bool_Exp>;
};


export type Subscription_RootLicense_AggregateArgs = {
  distinct_on?: InputMaybe<Array<License_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<License_Order_By>>;
  where?: InputMaybe<License_Bool_Exp>;
};


export type Subscription_RootLicense_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootMemberArgs = {
  distinct_on?: InputMaybe<Array<Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Order_By>>;
  where?: InputMaybe<Member_Bool_Exp>;
};


export type Subscription_RootMember_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Order_By>>;
  where?: InputMaybe<Member_Bool_Exp>;
};


export type Subscription_RootMember_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootMember_GroupArgs = {
  distinct_on?: InputMaybe<Array<Member_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Group_Order_By>>;
  where?: InputMaybe<Member_Group_Bool_Exp>;
};


export type Subscription_RootMember_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Member_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Group_Order_By>>;
  where?: InputMaybe<Member_Group_Bool_Exp>;
};


export type Subscription_RootMember_Group_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootMember_Group_MnArgs = {
  distinct_on?: InputMaybe<Array<Member_Group_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Group_Mn_Order_By>>;
  where?: InputMaybe<Member_Group_Mn_Bool_Exp>;
};


export type Subscription_RootMember_Group_Mn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Member_Group_Mn_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Member_Group_Mn_Order_By>>;
  where?: InputMaybe<Member_Group_Mn_Bool_Exp>;
};


export type Subscription_RootMember_Group_Mn_By_PkArgs = {
  group_id: Scalars['String'];
  member_id: Scalars['String'];
};


export type Subscription_RootPaymentArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Subscription_RootPayment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Order_By>>;
  where?: InputMaybe<Payment_Bool_Exp>;
};


export type Subscription_RootPayment_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootS3_FileArgs = {
  distinct_on?: InputMaybe<Array<S3_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<S3_File_Order_By>>;
  where?: InputMaybe<S3_File_Bool_Exp>;
};


export type Subscription_RootS3_File_AggregateArgs = {
  distinct_on?: InputMaybe<Array<S3_File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<S3_File_Order_By>>;
  where?: InputMaybe<S3_File_Bool_Exp>;
};


export type Subscription_RootS3_File_By_PkArgs = {
  s3key: Scalars['String'];
};


export type Subscription_RootTeamArgs = {
  distinct_on?: InputMaybe<Array<Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Order_By>>;
  where?: InputMaybe<Team_Bool_Exp>;
};


export type Subscription_RootTeam_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Team_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Team_Order_By>>;
  where?: InputMaybe<Team_Bool_Exp>;
};


export type Subscription_RootTeam_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUser_PermissionArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


export type Subscription_RootUser_Permission_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


export type Subscription_RootUser_Permission_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUser_Permission_RoleArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Role_Order_By>>;
  where?: InputMaybe<User_Permission_Role_Bool_Exp>;
};


export type Subscription_RootUser_Permission_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Role_Order_By>>;
  where?: InputMaybe<User_Permission_Role_Bool_Exp>;
};


export type Subscription_RootUser_Permission_Role_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['String'];
};

/** columns and relationships of "team" */
export type Team = {
  __typename?: 'team';
  /** An object relationship */
  club: Club;
  club_id: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['String'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  user_permissions: Array<User_Permission>;
  /** An aggregate relationship */
  user_permissions_aggregate: User_Permission_Aggregate;
};


/** columns and relationships of "team" */
export type TeamUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


/** columns and relationships of "team" */
export type TeamUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};

/** aggregated selection of "team" */
export type Team_Aggregate = {
  __typename?: 'team_aggregate';
  aggregate?: Maybe<Team_Aggregate_Fields>;
  nodes: Array<Team>;
};

/** aggregate fields of "team" */
export type Team_Aggregate_Fields = {
  __typename?: 'team_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Team_Max_Fields>;
  min?: Maybe<Team_Min_Fields>;
};


/** aggregate fields of "team" */
export type Team_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Team_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "team" */
export type Team_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Team_Max_Order_By>;
  min?: InputMaybe<Team_Min_Order_By>;
};

/** input type for inserting array relation for remote table "team" */
export type Team_Arr_Rel_Insert_Input = {
  data: Array<Team_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<Team_On_Conflict>;
};

/** Boolean expression to filter rows from the table "team". All fields are combined with a logical 'AND'. */
export type Team_Bool_Exp = {
  _and?: InputMaybe<Array<Team_Bool_Exp>>;
  _not?: InputMaybe<Team_Bool_Exp>;
  _or?: InputMaybe<Array<Team_Bool_Exp>>;
  club?: InputMaybe<Club_Bool_Exp>;
  club_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_permissions?: InputMaybe<User_Permission_Bool_Exp>;
};

/** unique or primary key constraints on table "team" */
export enum Team_Constraint {
  /** unique or primary key constraint */
  TeamPkey = 'team_pkey'
}

/** input type for inserting data into table "team" */
export type Team_Insert_Input = {
  club?: InputMaybe<Club_Obj_Rel_Insert_Input>;
  club_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_permissions?: InputMaybe<User_Permission_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Team_Max_Fields = {
  __typename?: 'team_max_fields';
  club_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "team" */
export type Team_Max_Order_By = {
  club_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Team_Min_Fields = {
  __typename?: 'team_min_fields';
  club_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "team" */
export type Team_Min_Order_By = {
  club_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "team" */
export type Team_Mutation_Response = {
  __typename?: 'team_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Team>;
};

/** input type for inserting object relation for remote table "team" */
export type Team_Obj_Rel_Insert_Input = {
  data: Team_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Team_On_Conflict>;
};

/** on conflict condition type for table "team" */
export type Team_On_Conflict = {
  constraint: Team_Constraint;
  update_columns?: Array<Team_Update_Column>;
  where?: InputMaybe<Team_Bool_Exp>;
};

/** Ordering options when selecting data from "team". */
export type Team_Order_By = {
  club?: InputMaybe<Club_Order_By>;
  club_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_permissions_aggregate?: InputMaybe<User_Permission_Aggregate_Order_By>;
};

/** primary key columns input for table: team */
export type Team_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "team" */
export enum Team_Select_Column {
  /** column name */
  ClubId = 'club_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "team" */
export type Team_Set_Input = {
  club_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "team" */
export enum Team_Update_Column {
  /** column name */
  ClubId = 'club_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "user_permission" */
export type User_Permission = {
  __typename?: 'user_permission';
  /** An object relationship */
  club: Club;
  club_id: Scalars['String'];
  id: Scalars['Int'];
  role: User_Permission_Role_Enum;
  /** An object relationship */
  team?: Maybe<Team>;
  team_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['String'];
  /** An object relationship */
  user_permission_role: User_Permission_Role;
};

/** aggregated selection of "user_permission" */
export type User_Permission_Aggregate = {
  __typename?: 'user_permission_aggregate';
  aggregate?: Maybe<User_Permission_Aggregate_Fields>;
  nodes: Array<User_Permission>;
};

/** aggregate fields of "user_permission" */
export type User_Permission_Aggregate_Fields = {
  __typename?: 'user_permission_aggregate_fields';
  avg?: Maybe<User_Permission_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Permission_Max_Fields>;
  min?: Maybe<User_Permission_Min_Fields>;
  stddev?: Maybe<User_Permission_Stddev_Fields>;
  stddev_pop?: Maybe<User_Permission_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Permission_Stddev_Samp_Fields>;
  sum?: Maybe<User_Permission_Sum_Fields>;
  var_pop?: Maybe<User_Permission_Var_Pop_Fields>;
  var_samp?: Maybe<User_Permission_Var_Samp_Fields>;
  variance?: Maybe<User_Permission_Variance_Fields>;
};


/** aggregate fields of "user_permission" */
export type User_Permission_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Permission_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_permission" */
export type User_Permission_Aggregate_Order_By = {
  avg?: InputMaybe<User_Permission_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Permission_Max_Order_By>;
  min?: InputMaybe<User_Permission_Min_Order_By>;
  stddev?: InputMaybe<User_Permission_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Permission_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Permission_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Permission_Sum_Order_By>;
  var_pop?: InputMaybe<User_Permission_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Permission_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Permission_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_permission" */
export type User_Permission_Arr_Rel_Insert_Input = {
  data: Array<User_Permission_Insert_Input>;
  /** on conflict condition */
  on_conflict?: InputMaybe<User_Permission_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Permission_Avg_Fields = {
  __typename?: 'user_permission_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_permission" */
export type User_Permission_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_permission". All fields are combined with a logical 'AND'. */
export type User_Permission_Bool_Exp = {
  _and?: InputMaybe<Array<User_Permission_Bool_Exp>>;
  _not?: InputMaybe<User_Permission_Bool_Exp>;
  _or?: InputMaybe<Array<User_Permission_Bool_Exp>>;
  club?: InputMaybe<Club_Bool_Exp>;
  club_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  role?: InputMaybe<User_Permission_Role_Enum_Comparison_Exp>;
  team?: InputMaybe<Team_Bool_Exp>;
  team_id?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_permission_role?: InputMaybe<User_Permission_Role_Bool_Exp>;
};

/** unique or primary key constraints on table "user_permission" */
export enum User_Permission_Constraint {
  /** unique or primary key constraint */
  UserPermissionPkey = 'user_permission_pkey'
}

/** input type for incrementing numeric columns in table "user_permission" */
export type User_Permission_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_permission" */
export type User_Permission_Insert_Input = {
  club?: InputMaybe<Club_Obj_Rel_Insert_Input>;
  club_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<User_Permission_Role_Enum>;
  team?: InputMaybe<Team_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']>;
  user_permission_role?: InputMaybe<User_Permission_Role_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Permission_Max_Fields = {
  __typename?: 'user_permission_max_fields';
  club_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_permission" */
export type User_Permission_Max_Order_By = {
  club_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Permission_Min_Fields = {
  __typename?: 'user_permission_min_fields';
  club_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  team_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_permission" */
export type User_Permission_Min_Order_By = {
  club_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_permission" */
export type User_Permission_Mutation_Response = {
  __typename?: 'user_permission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Permission>;
};

/** on conflict condition type for table "user_permission" */
export type User_Permission_On_Conflict = {
  constraint: User_Permission_Constraint;
  update_columns?: Array<User_Permission_Update_Column>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};

/** Ordering options when selecting data from "user_permission". */
export type User_Permission_Order_By = {
  club?: InputMaybe<Club_Order_By>;
  club_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  team?: InputMaybe<Team_Order_By>;
  team_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_permission_role?: InputMaybe<User_Permission_Role_Order_By>;
};

/** primary key columns input for table: user_permission */
export type User_Permission_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** columns and relationships of "user_permission_role" */
export type User_Permission_Role = {
  __typename?: 'user_permission_role';
  name: Scalars['String'];
  /** An array relationship */
  user_permissions: Array<User_Permission>;
  /** An aggregate relationship */
  user_permissions_aggregate: User_Permission_Aggregate;
};


/** columns and relationships of "user_permission_role" */
export type User_Permission_RoleUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


/** columns and relationships of "user_permission_role" */
export type User_Permission_RoleUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};

/** aggregated selection of "user_permission_role" */
export type User_Permission_Role_Aggregate = {
  __typename?: 'user_permission_role_aggregate';
  aggregate?: Maybe<User_Permission_Role_Aggregate_Fields>;
  nodes: Array<User_Permission_Role>;
};

/** aggregate fields of "user_permission_role" */
export type User_Permission_Role_Aggregate_Fields = {
  __typename?: 'user_permission_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Permission_Role_Max_Fields>;
  min?: Maybe<User_Permission_Role_Min_Fields>;
};


/** aggregate fields of "user_permission_role" */
export type User_Permission_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Permission_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_permission_role". All fields are combined with a logical 'AND'. */
export type User_Permission_Role_Bool_Exp = {
  _and?: InputMaybe<Array<User_Permission_Role_Bool_Exp>>;
  _not?: InputMaybe<User_Permission_Role_Bool_Exp>;
  _or?: InputMaybe<Array<User_Permission_Role_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  user_permissions?: InputMaybe<User_Permission_Bool_Exp>;
};

/** unique or primary key constraints on table "user_permission_role" */
export enum User_Permission_Role_Constraint {
  /** unique or primary key constraint */
  UserPermissionRolePkey = 'user_permission_role_pkey'
}

export enum User_Permission_Role_Enum {
  ClubAdmin = 'CLUB_ADMIN',
  ClubAdminView = 'CLUB_ADMIN_VIEW',
  ClubExerciseCreate = 'CLUB_EXERCISE_CREATE',
  ClubExerciseDelete = 'CLUB_EXERCISE_DELETE',
  ClubExerciseUpdate = 'CLUB_EXERCISE_UPDATE',
  ClubExerciseView = 'CLUB_EXERCISE_VIEW'
}

/** Boolean expression to compare columns of type "user_permission_role_enum". All fields are combined with logical 'AND'. */
export type User_Permission_Role_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Permission_Role_Enum>;
  _in?: InputMaybe<Array<User_Permission_Role_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Permission_Role_Enum>;
  _nin?: InputMaybe<Array<User_Permission_Role_Enum>>;
};

/** input type for inserting data into table "user_permission_role" */
export type User_Permission_Role_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
  user_permissions?: InputMaybe<User_Permission_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Permission_Role_Max_Fields = {
  __typename?: 'user_permission_role_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Permission_Role_Min_Fields = {
  __typename?: 'user_permission_role_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_permission_role" */
export type User_Permission_Role_Mutation_Response = {
  __typename?: 'user_permission_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Permission_Role>;
};

/** input type for inserting object relation for remote table "user_permission_role" */
export type User_Permission_Role_Obj_Rel_Insert_Input = {
  data: User_Permission_Role_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<User_Permission_Role_On_Conflict>;
};

/** on conflict condition type for table "user_permission_role" */
export type User_Permission_Role_On_Conflict = {
  constraint: User_Permission_Role_Constraint;
  update_columns?: Array<User_Permission_Role_Update_Column>;
  where?: InputMaybe<User_Permission_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "user_permission_role". */
export type User_Permission_Role_Order_By = {
  name?: InputMaybe<Order_By>;
  user_permissions_aggregate?: InputMaybe<User_Permission_Aggregate_Order_By>;
};

/** primary key columns input for table: user_permission_role */
export type User_Permission_Role_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "user_permission_role" */
export enum User_Permission_Role_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "user_permission_role" */
export type User_Permission_Role_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_permission_role" */
export enum User_Permission_Role_Update_Column {
  /** column name */
  Name = 'name'
}

/** select columns of table "user_permission" */
export enum User_Permission_Select_Column {
  /** column name */
  ClubId = 'club_id',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_permission" */
export type User_Permission_Set_Input = {
  club_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<User_Permission_Role_Enum>;
  team_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type User_Permission_Stddev_Fields = {
  __typename?: 'user_permission_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_permission" */
export type User_Permission_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Permission_Stddev_Pop_Fields = {
  __typename?: 'user_permission_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_permission" */
export type User_Permission_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Permission_Stddev_Samp_Fields = {
  __typename?: 'user_permission_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_permission" */
export type User_Permission_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type User_Permission_Sum_Fields = {
  __typename?: 'user_permission_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_permission" */
export type User_Permission_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** update columns of table "user_permission" */
export enum User_Permission_Update_Column {
  /** column name */
  ClubId = 'club_id',
  /** column name */
  Id = 'id',
  /** column name */
  Role = 'role',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type User_Permission_Var_Pop_Fields = {
  __typename?: 'user_permission_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_permission" */
export type User_Permission_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Permission_Var_Samp_Fields = {
  __typename?: 'user_permission_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_permission" */
export type User_Permission_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Permission_Variance_Fields = {
  __typename?: 'user_permission_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_permission" */
export type User_Permission_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  /** An array relationship */
  clubs: Array<Club>;
  /** An aggregate relationship */
  clubs_aggregate: Club_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  exercises: Array<Exercise>;
  /** An aggregate relationship */
  exercises_aggregate: Exercise_Aggregate;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  last_login?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  user_permissions: Array<User_Permission>;
  /** An aggregate relationship */
  user_permissions_aggregate: User_Permission_Aggregate;
};


/** columns and relationships of "users" */
export type UsersClubsArgs = {
  distinct_on?: InputMaybe<Array<Club_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Club_Order_By>>;
  where?: InputMaybe<Club_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersClubs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Club_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Club_Order_By>>;
  where?: InputMaybe<Club_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersExercisesArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Order_By>>;
  where?: InputMaybe<Exercise_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersExercises_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Exercise_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Exercise_Order_By>>;
  where?: InputMaybe<Exercise_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Permission_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Permission_Order_By>>;
  where?: InputMaybe<User_Permission_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  clubs?: InputMaybe<Club_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  exercises?: InputMaybe<Exercise_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_permissions?: InputMaybe<User_Permission_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint */
  UserPkey = 'user_pkey'
}

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  clubs?: InputMaybe<Club_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  exercises?: InputMaybe<Exercise_Arr_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_permissions?: InputMaybe<User_Permission_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_login?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** on conflict condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  clubs_aggregate?: InputMaybe<Club_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  exercises_aggregate?: InputMaybe<Exercise_Aggregate_Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_permissions_aggregate?: InputMaybe<User_Permission_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  last_login?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type ClubFragment = { __typename?: 'club', id: string, name: string, sport: Enum_Sport_Enum, owner_id: string };

export type DeleteClubByPkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteClubByPkMutation = { __typename?: 'mutation_root', delete_club_by_pk?: { __typename?: 'club', id: string } | null };

export type InsertClubOneMutationVariables = Exact<{
  data: Club_Insert_Input;
  payment: Payment_Insert_Input;
}>;


export type InsertClubOneMutation = { __typename?: 'mutation_root', insert_club_one?: { __typename?: 'club', id: string, name: string, sport: Enum_Sport_Enum, owner_id: string, payments: Array<{ __typename?: 'payment', id: string, active?: boolean | null, license?: License_Enum | null, is_trial?: boolean | null, valid_until?: any | null, fastspring_id?: string | null, club_id: string }>, user_permissions: Array<{ __typename?: 'user_permission', id: number, role: User_Permission_Role_Enum, user_id: string, team_id?: string | null, team?: { __typename?: 'team', id: string, name: string } | null }> } | null, insert_payment_one?: { __typename?: 'payment', id: string, active?: boolean | null, license?: License_Enum | null, is_trial?: boolean | null, valid_until?: any | null, fastspring_id?: string | null, club_id: string } | null };

export type PaymentFragment = { __typename?: 'payment', id: string, active?: boolean | null, license?: License_Enum | null, is_trial?: boolean | null, valid_until?: any | null, fastspring_id?: string | null, club_id: string };

export type UpdateClubMutationVariables = Exact<{
  data: Club_Set_Input;
  id: Scalars['String'];
}>;


export type UpdateClubMutation = { __typename?: 'mutation_root', update_club_by_pk?: { __typename?: 'club', id: string, name: string, sport: Enum_Sport_Enum, owner_id: string } | null };

export type UserClubFragment = { __typename?: 'club', id: string, name: string, sport: Enum_Sport_Enum, owner_id: string, payments: Array<{ __typename?: 'payment', id: string, active?: boolean | null, license?: License_Enum | null, is_trial?: boolean | null, valid_until?: any | null, fastspring_id?: string | null, club_id: string }>, user_permissions: Array<{ __typename?: 'user_permission', id: number, role: User_Permission_Role_Enum, user_id: string, team_id?: string | null, team?: { __typename?: 'team', id: string, name: string } | null }> };

export type UserPermissionFragment = { __typename?: 'user_permission', id: number, role: User_Permission_Role_Enum, user_id: string, team_id?: string | null, team?: { __typename?: 'team', id: string, name: string } | null };

export type UserClubPermissionsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UserClubPermissionsQuery = { __typename?: 'query_root', club: Array<{ __typename?: 'club', id: string, name: string, sport: Enum_Sport_Enum, owner_id: string, payments: Array<{ __typename?: 'payment', id: string, active?: boolean | null, license?: License_Enum | null, is_trial?: boolean | null, valid_until?: any | null, fastspring_id?: string | null, club_id: string }>, user_permissions: Array<{ __typename?: 'user_permission', id: number, role: User_Permission_Role_Enum, user_id: string, team_id?: string | null, team?: { __typename?: 'team', id: string, name: string } | null }> }> };

export type AllExercisesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllExercisesQuery = { __typename?: 'query_root', exercise: Array<{ __typename?: 'exercise', id: string, created_at: any, updated_at: any, owner_id: string, title: string, exercise_club_mns: Array<{ __typename: 'exercise_club_mn', club_id: string, exercise_id: string, club: { __typename?: 'club', id: string, name: string, sport: Enum_Sport_Enum, owner_id: string, payments: Array<{ __typename?: 'payment', id: string, active?: boolean | null, license?: License_Enum | null, is_trial?: boolean | null, valid_until?: any | null, fastspring_id?: string | null, club_id: string }>, user_permissions: Array<{ __typename?: 'user_permission', id: number, role: User_Permission_Role_Enum, user_id: string, team_id?: string | null, team?: { __typename?: 'team', id: string, name: string } | null }> } }>, exercise_content_media_mns: Array<{ __typename: 'exercise_content_media_mn', exercise_id: string, exercise_content_media_id: string, sort?: number | null, exercise_content_media: { __typename?: 'exercise_content_media', id: string, type: Exercise_Content_Media_Type_Enum, text?: string | null, is_media_right?: boolean | null, video_url?: string | null, created_at?: any | null, updated_at?: any | null, s3_file?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, exercise_content_media_editor?: { __typename?: 'exercise_content_media_editor', id: string, editor_data?: any | null, s3_file_image?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, s3_file_video?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null } | null } }> }> };

export type CreateExerciseMutationVariables = Exact<{
  object: Exercise_Insert_Input;
}>;


export type CreateExerciseMutation = { __typename?: 'mutation_root', insert_exercise_one?: { __typename?: 'exercise', id: string, created_at: any, updated_at: any, owner_id: string, title: string, fitness_stars: number, technique_stars: number, tactics_stars: number, locale?: string | null, exercise_club_mns: Array<{ __typename: 'exercise_club_mn', club_id: string, exercise_id: string, club: { __typename?: 'club', id: string, name: string, sport: Enum_Sport_Enum, owner_id: string, payments: Array<{ __typename?: 'payment', id: string, active?: boolean | null, license?: License_Enum | null, is_trial?: boolean | null, valid_until?: any | null, fastspring_id?: string | null, club_id: string }>, user_permissions: Array<{ __typename?: 'user_permission', id: number, role: User_Permission_Role_Enum, user_id: string, team_id?: string | null, team?: { __typename?: 'team', id: string, name: string } | null }> } }>, exercise_content_media_mns: Array<{ __typename: 'exercise_content_media_mn', exercise_id: string, exercise_content_media_id: string, sort?: number | null, exercise_content_media: { __typename?: 'exercise_content_media', id: string, type: Exercise_Content_Media_Type_Enum, text?: string | null, is_media_right?: boolean | null, video_url?: string | null, created_at?: any | null, updated_at?: any | null, s3_file?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, exercise_content_media_editor?: { __typename?: 'exercise_content_media_editor', id: string, editor_data?: any | null, s3_file_image?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, s3_file_video?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null } | null } }>, exercise_taxonomy_mns: Array<{ __typename?: 'exercise_taxonomy_mn', exercise_id: string, taxonomy_id: string, exercise_taxonomy: { __typename?: 'exercise_taxonomy', id: string, category: Enum_Exercise_Categories_Enum, locale?: string | null, translation_key: string, created_at: any, updated_at?: any | null } }> } | null };

export type DeleteExerciseMediaMnMutationVariables = Exact<{
  exerciseId: Scalars['String'];
  exerciseContentMediaId: Scalars['String'];
  updatedMn: Array<Exercise_Content_Media_Mn_Insert_Input> | Exercise_Content_Media_Mn_Insert_Input;
}>;


export type DeleteExerciseMediaMnMutation = { __typename?: 'mutation_root', delete_exercise_content_media_mn_by_pk?: { __typename: 'exercise_content_media_mn', exercise_content_media_id: string, exercise_id: string } | null, insert_exercise_content_media_mn?: { __typename: 'exercise_content_media_mn_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'exercise_content_media_mn', exercise_content_media_id: string, exercise_id: string, sort?: number | null }> } | null };

export type ExerciseByPkQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ExerciseByPkQuery = { __typename?: 'query_root', exercise_by_pk?: { __typename?: 'exercise', id: string, created_at: any, updated_at: any, owner_id: string, title: string, fitness_stars: number, technique_stars: number, tactics_stars: number, locale?: string | null, exercise_club_mns: Array<{ __typename: 'exercise_club_mn', club_id: string, exercise_id: string, club: { __typename?: 'club', id: string, name: string, sport: Enum_Sport_Enum, owner_id: string, payments: Array<{ __typename?: 'payment', id: string, active?: boolean | null, license?: License_Enum | null, is_trial?: boolean | null, valid_until?: any | null, fastspring_id?: string | null, club_id: string }>, user_permissions: Array<{ __typename?: 'user_permission', id: number, role: User_Permission_Role_Enum, user_id: string, team_id?: string | null, team?: { __typename?: 'team', id: string, name: string } | null }> } }>, exercise_content_media_mns: Array<{ __typename: 'exercise_content_media_mn', exercise_id: string, exercise_content_media_id: string, sort?: number | null, exercise_content_media: { __typename?: 'exercise_content_media', id: string, type: Exercise_Content_Media_Type_Enum, text?: string | null, is_media_right?: boolean | null, video_url?: string | null, created_at?: any | null, updated_at?: any | null, s3_file?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, exercise_content_media_editor?: { __typename?: 'exercise_content_media_editor', id: string, editor_data?: any | null, s3_file_image?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, s3_file_video?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null } | null } }>, exercise_taxonomy_mns: Array<{ __typename?: 'exercise_taxonomy_mn', exercise_id: string, taxonomy_id: string, exercise_taxonomy: { __typename?: 'exercise_taxonomy', id: string, category: Enum_Exercise_Categories_Enum, locale?: string | null, translation_key: string, created_at: any, updated_at?: any | null } }> } | null };

export type ExerciseClubMnsFragment = { __typename: 'exercise_club_mn', club_id: string, exercise_id: string };

export type ExerciseContentMediaEditorFragment = { __typename?: 'exercise_content_media_editor', id: string, editor_data?: any | null, s3_file_image?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, s3_file_video?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null };

export type ExerciseContentMediaFragment = { __typename?: 'exercise_content_media', id: string, text?: string | null, is_media_right?: boolean | null, type: Exercise_Content_Media_Type_Enum, video_url?: string | null, created_at?: any | null, updated_at?: any | null };

export type ExerciseContentMnsFragment = { __typename: 'exercise_content_media_mn', exercise_id: string, exercise_content_media_id: string, sort?: number | null, exercise_content_media: { __typename?: 'exercise_content_media', id: string, type: Exercise_Content_Media_Type_Enum } };

export type ExerciseDetailFragment = { __typename?: 'exercise', id: string, created_at: any, updated_at: any, owner_id: string, title: string, fitness_stars: number, technique_stars: number, tactics_stars: number, locale?: string | null, exercise_club_mns: Array<{ __typename: 'exercise_club_mn', club_id: string, exercise_id: string, club: { __typename?: 'club', id: string, name: string, sport: Enum_Sport_Enum, owner_id: string, payments: Array<{ __typename?: 'payment', id: string, active?: boolean | null, license?: License_Enum | null, is_trial?: boolean | null, valid_until?: any | null, fastspring_id?: string | null, club_id: string }>, user_permissions: Array<{ __typename?: 'user_permission', id: number, role: User_Permission_Role_Enum, user_id: string, team_id?: string | null, team?: { __typename?: 'team', id: string, name: string } | null }> } }>, exercise_content_media_mns: Array<{ __typename: 'exercise_content_media_mn', exercise_id: string, exercise_content_media_id: string, sort?: number | null, exercise_content_media: { __typename?: 'exercise_content_media', id: string, type: Exercise_Content_Media_Type_Enum, text?: string | null, is_media_right?: boolean | null, video_url?: string | null, created_at?: any | null, updated_at?: any | null, s3_file?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, exercise_content_media_editor?: { __typename?: 'exercise_content_media_editor', id: string, editor_data?: any | null, s3_file_image?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, s3_file_video?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null } | null } }>, exercise_taxonomy_mns: Array<{ __typename?: 'exercise_taxonomy_mn', exercise_id: string, taxonomy_id: string, exercise_taxonomy: { __typename?: 'exercise_taxonomy', id: string, category: Enum_Exercise_Categories_Enum, locale?: string | null, translation_key: string, created_at: any, updated_at?: any | null } }> };

export type ExerciseListFragment = { __typename?: 'exercise', id: string, created_at: any, updated_at: any, owner_id: string, title: string, exercise_club_mns: Array<{ __typename: 'exercise_club_mn', club_id: string, exercise_id: string, club: { __typename?: 'club', id: string, name: string, sport: Enum_Sport_Enum, owner_id: string, payments: Array<{ __typename?: 'payment', id: string, active?: boolean | null, license?: License_Enum | null, is_trial?: boolean | null, valid_until?: any | null, fastspring_id?: string | null, club_id: string }>, user_permissions: Array<{ __typename?: 'user_permission', id: number, role: User_Permission_Role_Enum, user_id: string, team_id?: string | null, team?: { __typename?: 'team', id: string, name: string } | null }> } }>, exercise_content_media_mns: Array<{ __typename: 'exercise_content_media_mn', exercise_id: string, exercise_content_media_id: string, sort?: number | null, exercise_content_media: { __typename?: 'exercise_content_media', id: string, type: Exercise_Content_Media_Type_Enum, text?: string | null, is_media_right?: boolean | null, video_url?: string | null, created_at?: any | null, updated_at?: any | null, s3_file?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, exercise_content_media_editor?: { __typename?: 'exercise_content_media_editor', id: string, editor_data?: any | null, s3_file_image?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, s3_file_video?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null } | null } }> };

export type ExerciseTaxonomiesBySportQueryVariables = Exact<{
  sport: Enum_Sport_Enum;
  category?: InputMaybe<Enum_Exercise_Categories_Enum>;
}>;


export type ExerciseTaxonomiesBySportQuery = { __typename?: 'query_root', exercise_taxonomy: Array<{ __typename: 'exercise_taxonomy', id: string, sport: Enum_Sport_Enum, category: Enum_Exercise_Categories_Enum, locale?: string | null, translation_key: string, exercise_taxonomy_mns: Array<{ __typename?: 'exercise_taxonomy_mn', exercise_id: string, taxonomy_id: string }> }> };

export type ExerciseTaxonomyFragment = { __typename: 'exercise_taxonomy', id: string, sport: Enum_Sport_Enum, category: Enum_Exercise_Categories_Enum, locale?: string | null, translation_key: string, exercise_taxonomy_mns: Array<{ __typename?: 'exercise_taxonomy_mn', exercise_id: string, taxonomy_id: string }> };

export type UpdateExerciseMutationVariables = Exact<{
  id: Scalars['String'];
  set: Exercise_Set_Input;
  exerciseClubMn: Array<Exercise_Club_Mn_Insert_Input> | Exercise_Club_Mn_Insert_Input;
  exerciseTaxonomyMn: Array<Exercise_Taxonomy_Mn_Insert_Input> | Exercise_Taxonomy_Mn_Insert_Input;
}>;


export type UpdateExerciseMutation = { __typename?: 'mutation_root', update_exercise_by_pk?: { __typename?: 'exercise', id: string, created_at: any, updated_at: any, owner_id: string, title: string, fitness_stars: number, technique_stars: number, tactics_stars: number, locale?: string | null, exercise_club_mns: Array<{ __typename: 'exercise_club_mn', club_id: string, exercise_id: string, club: { __typename?: 'club', id: string, name: string, sport: Enum_Sport_Enum, owner_id: string, payments: Array<{ __typename?: 'payment', id: string, active?: boolean | null, license?: License_Enum | null, is_trial?: boolean | null, valid_until?: any | null, fastspring_id?: string | null, club_id: string }>, user_permissions: Array<{ __typename?: 'user_permission', id: number, role: User_Permission_Role_Enum, user_id: string, team_id?: string | null, team?: { __typename?: 'team', id: string, name: string } | null }> } }>, exercise_content_media_mns: Array<{ __typename: 'exercise_content_media_mn', exercise_id: string, exercise_content_media_id: string, sort?: number | null, exercise_content_media: { __typename?: 'exercise_content_media', id: string, type: Exercise_Content_Media_Type_Enum, text?: string | null, is_media_right?: boolean | null, video_url?: string | null, created_at?: any | null, updated_at?: any | null, s3_file?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, exercise_content_media_editor?: { __typename?: 'exercise_content_media_editor', id: string, editor_data?: any | null, s3_file_image?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null, s3_file_video?: { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null } | null } | null } }>, exercise_taxonomy_mns: Array<{ __typename?: 'exercise_taxonomy_mn', exercise_id: string, taxonomy_id: string, exercise_taxonomy: { __typename?: 'exercise_taxonomy', id: string, category: Enum_Exercise_Categories_Enum, locale?: string | null, translation_key: string, created_at: any, updated_at?: any | null } }> } | null, delete_exercise_club_mn?: { __typename?: 'exercise_club_mn_mutation_response', affected_rows: number } | null, delete_exercise_taxonomy_mn?: { __typename?: 'exercise_taxonomy_mn_mutation_response', affected_rows: number } | null, insert_exercise_club_mn?: { __typename?: 'exercise_club_mn_mutation_response', affected_rows: number } | null, insert_exercise_taxonomy_mn?: { __typename?: 'exercise_taxonomy_mn_mutation_response', affected_rows: number } | null };

export type UpdateExerciseTaxonomyMnMutationVariables = Exact<{
  exerciseId: Scalars['String'];
  variables: Array<Exercise_Taxonomy_Mn_Insert_Input> | Exercise_Taxonomy_Mn_Insert_Input;
}>;


export type UpdateExerciseTaxonomyMnMutation = { __typename?: 'mutation_root', delete_exercise_taxonomy_mn?: { __typename?: 'exercise_taxonomy_mn_mutation_response', affected_rows: number } | null, insert_exercise_taxonomy_mn?: { __typename?: 'exercise_taxonomy_mn_mutation_response', affected_rows: number } | null };

export type ExerciseMediaMnMutationVariables = Exact<{
  exerciseId: Scalars['String'];
  sort: Scalars['Int'];
  mediaId: Scalars['String'];
  mediaOne: Exercise_Content_Media_Insert_Input;
}>;


export type ExerciseMediaMnMutation = { __typename?: 'mutation_root', insert_exercise_content_media_one?: { __typename?: 'exercise_content_media', id: string, text?: string | null, is_media_right?: boolean | null, type: Exercise_Content_Media_Type_Enum, video_url?: string | null, created_at?: any | null, updated_at?: any | null } | null, insert_exercise_content_media_mn_one?: { __typename: 'exercise_content_media_mn', exercise_id: string, exercise_content_media_id: string, sort?: number | null, exercise_content_media: { __typename?: 'exercise_content_media', id: string, type: Exercise_Content_Media_Type_Enum } } | null };

export type AllTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTeamsQuery = { __typename?: 'query_root', team: Array<{ __typename?: 'team', created_at: any, updated_at: any, id: string, name: string, club_id: string, club: { __typename?: 'club', id: string, name: string } }> };

export type DeleteTeamByPkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteTeamByPkMutation = { __typename?: 'mutation_root', delete_team_by_pk?: { __typename?: 'team', id: string } | null };

export type InsertTeamOneMutationVariables = Exact<{
  data: Team_Insert_Input;
}>;


export type InsertTeamOneMutation = { __typename?: 'mutation_root', insert_team_one?: { __typename?: 'team', id: string, name: string, updated_at: any, created_at: any, user_permissions: Array<{ __typename?: 'user_permission', id: number, role: User_Permission_Role_Enum, user_id: string, team_id?: string | null, team?: { __typename?: 'team', id: string, name: string } | null }>, club: { __typename?: 'club', id: string, name: string } } | null };

export type TeamFragment = { __typename?: 'team', id: string, name: string, updated_at: any, created_at: any, club: { __typename?: 'club', id: string, name: string } };

export type TeamListFragment = { __typename?: 'team', created_at: any, updated_at: any, id: string, name: string, club_id: string, club: { __typename?: 'club', id: string, name: string } };

export type UpdateTeamMutationVariables = Exact<{
  data: Team_Set_Input;
  id: Scalars['String'];
}>;


export type UpdateTeamMutation = { __typename?: 'mutation_root', update_team_by_pk?: { __typename?: 'team', id: string, name: string, updated_at: any, created_at: any, club: { __typename?: 'club', id: string, name: string } } | null };

export type S3FileFragment = { __typename?: 's3_file', name?: string | null, s3key: string, size: any, type: string, url?: string | null };

export const ExerciseClubMnsFragmentDoc = gql`
    fragment exerciseClubMns on exercise_club_mn {
  club_id
  exercise_id
  __typename
}
    `;
export const ClubFragmentDoc = gql`
    fragment club on club {
  id
  name
  sport
  owner_id
}
    `;
export const PaymentFragmentDoc = gql`
    fragment payment on payment {
  id
  active
  license
  is_trial
  valid_until
  fastspring_id
  club_id
}
    `;
export const UserPermissionFragmentDoc = gql`
    fragment userPermission on user_permission {
  id
  role
  user_id
  team_id
  team {
    id
    name
  }
}
    `;
export const UserClubFragmentDoc = gql`
    fragment userClub on club {
  ...club
  payments {
    ...payment
  }
  user_permissions {
    ...userPermission
  }
}
    ${ClubFragmentDoc}
${PaymentFragmentDoc}
${UserPermissionFragmentDoc}`;
export const ExerciseContentMnsFragmentDoc = gql`
    fragment exerciseContentMns on exercise_content_media_mn {
  exercise_id
  exercise_content_media_id
  exercise_content_media {
    id
    type
  }
  sort
  __typename
}
    `;
export const ExerciseContentMediaFragmentDoc = gql`
    fragment exerciseContentMedia on exercise_content_media {
  id
  text
  is_media_right
  type
  video_url
  created_at
  updated_at
}
    `;
export const S3FileFragmentDoc = gql`
    fragment s3File on s3_file {
  name
  s3key
  size
  type
  url
}
    `;
export const ExerciseContentMediaEditorFragmentDoc = gql`
    fragment exerciseContentMediaEditor on exercise_content_media_editor {
  id
  editor_data
  s3_file_image {
    ...s3File
  }
  s3_file_video {
    ...s3File
  }
}
    ${S3FileFragmentDoc}`;
export const ExerciseDetailFragmentDoc = gql`
    fragment exerciseDetail on exercise {
  id
  created_at
  updated_at
  owner_id
  title
  fitness_stars
  technique_stars
  tactics_stars
  locale
  exercise_club_mns {
    ...exerciseClubMns
    club {
      ...userClub
    }
  }
  exercise_content_media_mns(order_by: [{sort: asc}]) {
    ...exerciseContentMns
    exercise_content_media {
      ...exerciseContentMedia
      s3_file {
        ...s3File
      }
      exercise_content_media_editor {
        ...exerciseContentMediaEditor
      }
    }
  }
  exercise_taxonomy_mns {
    exercise_id
    taxonomy_id
    exercise_taxonomy {
      id
      category
      locale
      translation_key
      created_at
      updated_at
    }
  }
}
    ${ExerciseClubMnsFragmentDoc}
${UserClubFragmentDoc}
${ExerciseContentMnsFragmentDoc}
${ExerciseContentMediaFragmentDoc}
${S3FileFragmentDoc}
${ExerciseContentMediaEditorFragmentDoc}`;
export const ExerciseListFragmentDoc = gql`
    fragment exerciseList on exercise {
  id
  created_at
  updated_at
  owner_id
  title
  exercise_club_mns {
    ...exerciseClubMns
    club {
      ...userClub
    }
  }
  exercise_content_media_mns(limit: 1, order_by: [{sort: asc}]) {
    ...exerciseContentMns
    exercise_content_media {
      ...exerciseContentMedia
      s3_file {
        ...s3File
      }
      exercise_content_media_editor {
        ...exerciseContentMediaEditor
      }
    }
  }
}
    ${ExerciseClubMnsFragmentDoc}
${UserClubFragmentDoc}
${ExerciseContentMnsFragmentDoc}
${ExerciseContentMediaFragmentDoc}
${S3FileFragmentDoc}
${ExerciseContentMediaEditorFragmentDoc}`;
export const ExerciseTaxonomyFragmentDoc = gql`
    fragment exerciseTaxonomy on exercise_taxonomy {
  id
  sport
  category
  locale
  translation_key
  __typename
  exercise_taxonomy_mns {
    exercise_id
    taxonomy_id
  }
}
    `;
export const TeamFragmentDoc = gql`
    fragment team on team {
  id
  name
  club {
    id
    name
  }
  updated_at
  created_at
}
    `;
export const TeamListFragmentDoc = gql`
    fragment teamList on team {
  created_at
  updated_at
  id
  name
  club_id
  club {
    id
    name
  }
}
    `;
export const DeleteClubByPkDocument = gql`
    mutation deleteClubByPk($id: String!) {
  delete_club_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteClubByPkMutation() {
  return Urql.useMutation<DeleteClubByPkMutation, DeleteClubByPkMutationVariables>(DeleteClubByPkDocument);
};
export const InsertClubOneDocument = gql`
    mutation insertClubOne($data: club_insert_input!, $payment: payment_insert_input!) {
  insert_club_one(object: $data) {
    ...club
    payments {
      ...payment
    }
    user_permissions {
      ...userPermission
    }
  }
  insert_payment_one(object: $payment) {
    ...payment
  }
}
    ${ClubFragmentDoc}
${PaymentFragmentDoc}
${UserPermissionFragmentDoc}`;

export function useInsertClubOneMutation() {
  return Urql.useMutation<InsertClubOneMutation, InsertClubOneMutationVariables>(InsertClubOneDocument);
};
export const UpdateClubDocument = gql`
    mutation updateClub($data: club_set_input!, $id: String!) {
  update_club_by_pk(_set: $data, pk_columns: {id: $id}) {
    ...club
  }
}
    ${ClubFragmentDoc}`;

export function useUpdateClubMutation() {
  return Urql.useMutation<UpdateClubMutation, UpdateClubMutationVariables>(UpdateClubDocument);
};
export const UserClubPermissionsDocument = gql`
    query userClubPermissions($userId: String!) {
  club(
    where: {_or: [{owner_id: {_eq: $userId}}, {user_permissions: {user_id: {_eq: $userId}}}]}
    order_by: [{name: asc, created_at: desc}]
  ) {
    ...userClub
  }
}
    ${UserClubFragmentDoc}`;

export function useUserClubPermissionsQuery(options: Omit<Urql.UseQueryArgs<UserClubPermissionsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserClubPermissionsQuery>({ query: UserClubPermissionsDocument, ...options });
};
export const AllExercisesDocument = gql`
    query allExercises {
  exercise {
    ...exerciseList
  }
}
    ${ExerciseListFragmentDoc}`;

export function useAllExercisesQuery(options?: Omit<Urql.UseQueryArgs<AllExercisesQueryVariables>, 'query'>) {
  return Urql.useQuery<AllExercisesQuery>({ query: AllExercisesDocument, ...options });
};
export const CreateExerciseDocument = gql`
    mutation createExercise($object: exercise_insert_input!) {
  insert_exercise_one(object: $object) {
    ...exerciseDetail
  }
}
    ${ExerciseDetailFragmentDoc}`;

export function useCreateExerciseMutation() {
  return Urql.useMutation<CreateExerciseMutation, CreateExerciseMutationVariables>(CreateExerciseDocument);
};
export const DeleteExerciseMediaMnDocument = gql`
    mutation deleteExerciseMediaMn($exerciseId: String!, $exerciseContentMediaId: String!, $updatedMn: [exercise_content_media_mn_insert_input!]!) {
  delete_exercise_content_media_mn_by_pk(
    exercise_id: $exerciseId
    exercise_content_media_id: $exerciseContentMediaId
  ) {
    exercise_content_media_id
    exercise_id
    __typename
  }
  insert_exercise_content_media_mn(
    objects: $updatedMn
    on_conflict: {constraint: exercise_content_media_mn_pkey, update_columns: [sort]}
  ) {
    __typename
    returning {
      exercise_content_media_id
      exercise_id
      sort
    }
    affected_rows
  }
}
    `;

export function useDeleteExerciseMediaMnMutation() {
  return Urql.useMutation<DeleteExerciseMediaMnMutation, DeleteExerciseMediaMnMutationVariables>(DeleteExerciseMediaMnDocument);
};
export const ExerciseByPkDocument = gql`
    query exerciseByPk($id: String!) {
  exercise_by_pk(id: $id) {
    ...exerciseDetail
  }
}
    ${ExerciseDetailFragmentDoc}`;

export function useExerciseByPkQuery(options: Omit<Urql.UseQueryArgs<ExerciseByPkQueryVariables>, 'query'>) {
  return Urql.useQuery<ExerciseByPkQuery>({ query: ExerciseByPkDocument, ...options });
};
export const ExerciseTaxonomiesBySportDocument = gql`
    query exerciseTaxonomiesBySport($sport: enum_sport_enum!, $category: enum_exercise_categories_enum) {
  exercise_taxonomy(where: {sport: {_eq: $sport}}) {
    ...exerciseTaxonomy
  }
}
    ${ExerciseTaxonomyFragmentDoc}`;

export function useExerciseTaxonomiesBySportQuery(options: Omit<Urql.UseQueryArgs<ExerciseTaxonomiesBySportQueryVariables>, 'query'>) {
  return Urql.useQuery<ExerciseTaxonomiesBySportQuery>({ query: ExerciseTaxonomiesBySportDocument, ...options });
};
export const UpdateExerciseDocument = gql`
    mutation updateExercise($id: String!, $set: exercise_set_input!, $exerciseClubMn: [exercise_club_mn_insert_input!]!, $exerciseTaxonomyMn: [exercise_taxonomy_mn_insert_input!]!) {
  update_exercise_by_pk(pk_columns: {id: $id}, _set: $set) {
    ...exerciseDetail
  }
  delete_exercise_club_mn(where: {exercise_id: {_eq: $id}}) {
    affected_rows
  }
  delete_exercise_taxonomy_mn(where: {exercise_id: {_eq: $id}}) {
    affected_rows
  }
  insert_exercise_club_mn(
    objects: $exerciseClubMn
    on_conflict: {constraint: exercise_club_mn_pkey, update_columns: []}
  ) {
    affected_rows
  }
  insert_exercise_taxonomy_mn(
    objects: $exerciseTaxonomyMn
    on_conflict: {constraint: exercise_taxonomy_mn_pkey, update_columns: []}
  ) {
    affected_rows
  }
}
    ${ExerciseDetailFragmentDoc}`;

export function useUpdateExerciseMutation() {
  return Urql.useMutation<UpdateExerciseMutation, UpdateExerciseMutationVariables>(UpdateExerciseDocument);
};
export const UpdateExerciseTaxonomyMnDocument = gql`
    mutation updateExerciseTaxonomyMn($exerciseId: String!, $variables: [exercise_taxonomy_mn_insert_input!]!) {
  delete_exercise_taxonomy_mn(where: {exercise_id: {_eq: $exerciseId}}) {
    affected_rows
  }
  insert_exercise_taxonomy_mn(objects: $variables) {
    affected_rows
  }
}
    `;

export function useUpdateExerciseTaxonomyMnMutation() {
  return Urql.useMutation<UpdateExerciseTaxonomyMnMutation, UpdateExerciseTaxonomyMnMutationVariables>(UpdateExerciseTaxonomyMnDocument);
};
export const ExerciseMediaMnDocument = gql`
    mutation exerciseMediaMn($exerciseId: String!, $sort: Int!, $mediaId: String!, $mediaOne: exercise_content_media_insert_input!) {
  insert_exercise_content_media_one(
    object: $mediaOne
    on_conflict: {constraint: exercise_content_media_pkey, update_columns: [type, s3_file_id, editor_image_id, video_url, text, editor_animation_id]}
  ) {
    ...exerciseContentMedia
  }
  insert_exercise_content_media_mn_one(
    object: {exercise_id: $exerciseId, exercise_content_media_id: $mediaId, sort: $sort}
    on_conflict: {update_columns: [sort, exercise_content_media_id, exercise_id], constraint: exercise_content_media_mn_pkey}
  ) {
    ...exerciseContentMns
  }
}
    ${ExerciseContentMediaFragmentDoc}
${ExerciseContentMnsFragmentDoc}`;

export function useExerciseMediaMnMutation() {
  return Urql.useMutation<ExerciseMediaMnMutation, ExerciseMediaMnMutationVariables>(ExerciseMediaMnDocument);
};
export const AllTeamsDocument = gql`
    query allTeams {
  team {
    ...teamList
  }
}
    ${TeamListFragmentDoc}`;

export function useAllTeamsQuery(options?: Omit<Urql.UseQueryArgs<AllTeamsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllTeamsQuery>({ query: AllTeamsDocument, ...options });
};
export const DeleteTeamByPkDocument = gql`
    mutation deleteTeamByPk($id: String!) {
  delete_team_by_pk(id: $id) {
    id
  }
}
    `;

export function useDeleteTeamByPkMutation() {
  return Urql.useMutation<DeleteTeamByPkMutation, DeleteTeamByPkMutationVariables>(DeleteTeamByPkDocument);
};
export const InsertTeamOneDocument = gql`
    mutation insertTeamOne($data: team_insert_input!) {
  insert_team_one(object: $data) {
    ...team
    user_permissions {
      ...userPermission
    }
  }
}
    ${TeamFragmentDoc}
${UserPermissionFragmentDoc}`;

export function useInsertTeamOneMutation() {
  return Urql.useMutation<InsertTeamOneMutation, InsertTeamOneMutationVariables>(InsertTeamOneDocument);
};
export const UpdateTeamDocument = gql`
    mutation updateTeam($data: team_set_input!, $id: String!) {
  update_team_by_pk(_set: $data, pk_columns: {id: $id}) {
    ...team
  }
}
    ${TeamFragmentDoc}`;

export function useUpdateTeamMutation() {
  return Urql.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument);
};
export type WithTypename<T extends { __typename?: any }> = { [K in Exclude<keyof T, '__typename'>]?: T[K] } & { __typename: NonNullable<T['__typename']> };

export type GraphCacheKeysConfig = {
  club?: (data: WithTypename<Club>) => null | string,
  club_aggregate?: (data: WithTypename<Club_Aggregate>) => null | string,
  club_aggregate_fields?: (data: WithTypename<Club_Aggregate_Fields>) => null | string,
  club_max_fields?: (data: WithTypename<Club_Max_Fields>) => null | string,
  club_min_fields?: (data: WithTypename<Club_Min_Fields>) => null | string,
  club_mutation_response?: (data: WithTypename<Club_Mutation_Response>) => null | string,
  editor_type?: (data: WithTypename<Editor_Type>) => null | string,
  editor_type_aggregate?: (data: WithTypename<Editor_Type_Aggregate>) => null | string,
  editor_type_aggregate_fields?: (data: WithTypename<Editor_Type_Aggregate_Fields>) => null | string,
  editor_type_max_fields?: (data: WithTypename<Editor_Type_Max_Fields>) => null | string,
  editor_type_min_fields?: (data: WithTypename<Editor_Type_Min_Fields>) => null | string,
  editor_type_mutation_response?: (data: WithTypename<Editor_Type_Mutation_Response>) => null | string,
  enum_exercise_categories?: (data: WithTypename<Enum_Exercise_Categories>) => null | string,
  enum_exercise_categories_aggregate?: (data: WithTypename<Enum_Exercise_Categories_Aggregate>) => null | string,
  enum_exercise_categories_aggregate_fields?: (data: WithTypename<Enum_Exercise_Categories_Aggregate_Fields>) => null | string,
  enum_exercise_categories_max_fields?: (data: WithTypename<Enum_Exercise_Categories_Max_Fields>) => null | string,
  enum_exercise_categories_min_fields?: (data: WithTypename<Enum_Exercise_Categories_Min_Fields>) => null | string,
  enum_exercise_categories_mutation_response?: (data: WithTypename<Enum_Exercise_Categories_Mutation_Response>) => null | string,
  enum_languages?: (data: WithTypename<Enum_Languages>) => null | string,
  enum_languages_aggregate?: (data: WithTypename<Enum_Languages_Aggregate>) => null | string,
  enum_languages_aggregate_fields?: (data: WithTypename<Enum_Languages_Aggregate_Fields>) => null | string,
  enum_languages_max_fields?: (data: WithTypename<Enum_Languages_Max_Fields>) => null | string,
  enum_languages_min_fields?: (data: WithTypename<Enum_Languages_Min_Fields>) => null | string,
  enum_languages_mutation_response?: (data: WithTypename<Enum_Languages_Mutation_Response>) => null | string,
  enum_sport?: (data: WithTypename<Enum_Sport>) => null | string,
  enum_sport_aggregate?: (data: WithTypename<Enum_Sport_Aggregate>) => null | string,
  enum_sport_aggregate_fields?: (data: WithTypename<Enum_Sport_Aggregate_Fields>) => null | string,
  enum_sport_max_fields?: (data: WithTypename<Enum_Sport_Max_Fields>) => null | string,
  enum_sport_min_fields?: (data: WithTypename<Enum_Sport_Min_Fields>) => null | string,
  enum_sport_mutation_response?: (data: WithTypename<Enum_Sport_Mutation_Response>) => null | string,
  exercise?: (data: WithTypename<Exercise>) => null | string,
  exercise_aggregate?: (data: WithTypename<Exercise_Aggregate>) => null | string,
  exercise_aggregate_fields?: (data: WithTypename<Exercise_Aggregate_Fields>) => null | string,
  exercise_avg_fields?: (data: WithTypename<Exercise_Avg_Fields>) => null | string,
  exercise_club_mn?: (data: WithTypename<Exercise_Club_Mn>) => null | string,
  exercise_club_mn_aggregate?: (data: WithTypename<Exercise_Club_Mn_Aggregate>) => null | string,
  exercise_club_mn_aggregate_fields?: (data: WithTypename<Exercise_Club_Mn_Aggregate_Fields>) => null | string,
  exercise_club_mn_max_fields?: (data: WithTypename<Exercise_Club_Mn_Max_Fields>) => null | string,
  exercise_club_mn_min_fields?: (data: WithTypename<Exercise_Club_Mn_Min_Fields>) => null | string,
  exercise_club_mn_mutation_response?: (data: WithTypename<Exercise_Club_Mn_Mutation_Response>) => null | string,
  exercise_content_media?: (data: WithTypename<Exercise_Content_Media>) => null | string,
  exercise_content_media_aggregate?: (data: WithTypename<Exercise_Content_Media_Aggregate>) => null | string,
  exercise_content_media_aggregate_fields?: (data: WithTypename<Exercise_Content_Media_Aggregate_Fields>) => null | string,
  exercise_content_media_editor?: (data: WithTypename<Exercise_Content_Media_Editor>) => null | string,
  exercise_content_media_editor_aggregate?: (data: WithTypename<Exercise_Content_Media_Editor_Aggregate>) => null | string,
  exercise_content_media_editor_aggregate_fields?: (data: WithTypename<Exercise_Content_Media_Editor_Aggregate_Fields>) => null | string,
  exercise_content_media_editor_max_fields?: (data: WithTypename<Exercise_Content_Media_Editor_Max_Fields>) => null | string,
  exercise_content_media_editor_min_fields?: (data: WithTypename<Exercise_Content_Media_Editor_Min_Fields>) => null | string,
  exercise_content_media_editor_mutation_response?: (data: WithTypename<Exercise_Content_Media_Editor_Mutation_Response>) => null | string,
  exercise_content_media_max_fields?: (data: WithTypename<Exercise_Content_Media_Max_Fields>) => null | string,
  exercise_content_media_min_fields?: (data: WithTypename<Exercise_Content_Media_Min_Fields>) => null | string,
  exercise_content_media_mn?: (data: WithTypename<Exercise_Content_Media_Mn>) => null | string,
  exercise_content_media_mn_aggregate?: (data: WithTypename<Exercise_Content_Media_Mn_Aggregate>) => null | string,
  exercise_content_media_mn_aggregate_fields?: (data: WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields>) => null | string,
  exercise_content_media_mn_avg_fields?: (data: WithTypename<Exercise_Content_Media_Mn_Avg_Fields>) => null | string,
  exercise_content_media_mn_max_fields?: (data: WithTypename<Exercise_Content_Media_Mn_Max_Fields>) => null | string,
  exercise_content_media_mn_min_fields?: (data: WithTypename<Exercise_Content_Media_Mn_Min_Fields>) => null | string,
  exercise_content_media_mn_mutation_response?: (data: WithTypename<Exercise_Content_Media_Mn_Mutation_Response>) => null | string,
  exercise_content_media_mn_stddev_fields?: (data: WithTypename<Exercise_Content_Media_Mn_Stddev_Fields>) => null | string,
  exercise_content_media_mn_stddev_pop_fields?: (data: WithTypename<Exercise_Content_Media_Mn_Stddev_Pop_Fields>) => null | string,
  exercise_content_media_mn_stddev_samp_fields?: (data: WithTypename<Exercise_Content_Media_Mn_Stddev_Samp_Fields>) => null | string,
  exercise_content_media_mn_sum_fields?: (data: WithTypename<Exercise_Content_Media_Mn_Sum_Fields>) => null | string,
  exercise_content_media_mn_var_pop_fields?: (data: WithTypename<Exercise_Content_Media_Mn_Var_Pop_Fields>) => null | string,
  exercise_content_media_mn_var_samp_fields?: (data: WithTypename<Exercise_Content_Media_Mn_Var_Samp_Fields>) => null | string,
  exercise_content_media_mn_variance_fields?: (data: WithTypename<Exercise_Content_Media_Mn_Variance_Fields>) => null | string,
  exercise_content_media_mutation_response?: (data: WithTypename<Exercise_Content_Media_Mutation_Response>) => null | string,
  exercise_content_media_type?: (data: WithTypename<Exercise_Content_Media_Type>) => null | string,
  exercise_content_media_type_aggregate?: (data: WithTypename<Exercise_Content_Media_Type_Aggregate>) => null | string,
  exercise_content_media_type_aggregate_fields?: (data: WithTypename<Exercise_Content_Media_Type_Aggregate_Fields>) => null | string,
  exercise_content_media_type_max_fields?: (data: WithTypename<Exercise_Content_Media_Type_Max_Fields>) => null | string,
  exercise_content_media_type_min_fields?: (data: WithTypename<Exercise_Content_Media_Type_Min_Fields>) => null | string,
  exercise_content_media_type_mutation_response?: (data: WithTypename<Exercise_Content_Media_Type_Mutation_Response>) => null | string,
  exercise_max_fields?: (data: WithTypename<Exercise_Max_Fields>) => null | string,
  exercise_min_fields?: (data: WithTypename<Exercise_Min_Fields>) => null | string,
  exercise_mutation_response?: (data: WithTypename<Exercise_Mutation_Response>) => null | string,
  exercise_stddev_fields?: (data: WithTypename<Exercise_Stddev_Fields>) => null | string,
  exercise_stddev_pop_fields?: (data: WithTypename<Exercise_Stddev_Pop_Fields>) => null | string,
  exercise_stddev_samp_fields?: (data: WithTypename<Exercise_Stddev_Samp_Fields>) => null | string,
  exercise_sum_fields?: (data: WithTypename<Exercise_Sum_Fields>) => null | string,
  exercise_taxonomy?: (data: WithTypename<Exercise_Taxonomy>) => null | string,
  exercise_taxonomy_aggregate?: (data: WithTypename<Exercise_Taxonomy_Aggregate>) => null | string,
  exercise_taxonomy_aggregate_fields?: (data: WithTypename<Exercise_Taxonomy_Aggregate_Fields>) => null | string,
  exercise_taxonomy_max_fields?: (data: WithTypename<Exercise_Taxonomy_Max_Fields>) => null | string,
  exercise_taxonomy_min_fields?: (data: WithTypename<Exercise_Taxonomy_Min_Fields>) => null | string,
  exercise_taxonomy_mn?: (data: WithTypename<Exercise_Taxonomy_Mn>) => null | string,
  exercise_taxonomy_mn_aggregate?: (data: WithTypename<Exercise_Taxonomy_Mn_Aggregate>) => null | string,
  exercise_taxonomy_mn_aggregate_fields?: (data: WithTypename<Exercise_Taxonomy_Mn_Aggregate_Fields>) => null | string,
  exercise_taxonomy_mn_max_fields?: (data: WithTypename<Exercise_Taxonomy_Mn_Max_Fields>) => null | string,
  exercise_taxonomy_mn_min_fields?: (data: WithTypename<Exercise_Taxonomy_Mn_Min_Fields>) => null | string,
  exercise_taxonomy_mn_mutation_response?: (data: WithTypename<Exercise_Taxonomy_Mn_Mutation_Response>) => null | string,
  exercise_taxonomy_mutation_response?: (data: WithTypename<Exercise_Taxonomy_Mutation_Response>) => null | string,
  exercise_var_pop_fields?: (data: WithTypename<Exercise_Var_Pop_Fields>) => null | string,
  exercise_var_samp_fields?: (data: WithTypename<Exercise_Var_Samp_Fields>) => null | string,
  exercise_variance_fields?: (data: WithTypename<Exercise_Variance_Fields>) => null | string,
  license?: (data: WithTypename<License>) => null | string,
  license_aggregate?: (data: WithTypename<License_Aggregate>) => null | string,
  license_aggregate_fields?: (data: WithTypename<License_Aggregate_Fields>) => null | string,
  license_max_fields?: (data: WithTypename<License_Max_Fields>) => null | string,
  license_min_fields?: (data: WithTypename<License_Min_Fields>) => null | string,
  license_mutation_response?: (data: WithTypename<License_Mutation_Response>) => null | string,
  member?: (data: WithTypename<Member>) => null | string,
  member_aggregate?: (data: WithTypename<Member_Aggregate>) => null | string,
  member_aggregate_fields?: (data: WithTypename<Member_Aggregate_Fields>) => null | string,
  member_group?: (data: WithTypename<Member_Group>) => null | string,
  member_group_aggregate?: (data: WithTypename<Member_Group_Aggregate>) => null | string,
  member_group_aggregate_fields?: (data: WithTypename<Member_Group_Aggregate_Fields>) => null | string,
  member_group_max_fields?: (data: WithTypename<Member_Group_Max_Fields>) => null | string,
  member_group_min_fields?: (data: WithTypename<Member_Group_Min_Fields>) => null | string,
  member_group_mn?: (data: WithTypename<Member_Group_Mn>) => null | string,
  member_group_mn_aggregate?: (data: WithTypename<Member_Group_Mn_Aggregate>) => null | string,
  member_group_mn_aggregate_fields?: (data: WithTypename<Member_Group_Mn_Aggregate_Fields>) => null | string,
  member_group_mn_max_fields?: (data: WithTypename<Member_Group_Mn_Max_Fields>) => null | string,
  member_group_mn_min_fields?: (data: WithTypename<Member_Group_Mn_Min_Fields>) => null | string,
  member_group_mn_mutation_response?: (data: WithTypename<Member_Group_Mn_Mutation_Response>) => null | string,
  member_group_mutation_response?: (data: WithTypename<Member_Group_Mutation_Response>) => null | string,
  member_max_fields?: (data: WithTypename<Member_Max_Fields>) => null | string,
  member_min_fields?: (data: WithTypename<Member_Min_Fields>) => null | string,
  member_mutation_response?: (data: WithTypename<Member_Mutation_Response>) => null | string,
  payment?: (data: WithTypename<Payment>) => null | string,
  payment_aggregate?: (data: WithTypename<Payment_Aggregate>) => null | string,
  payment_aggregate_fields?: (data: WithTypename<Payment_Aggregate_Fields>) => null | string,
  payment_max_fields?: (data: WithTypename<Payment_Max_Fields>) => null | string,
  payment_min_fields?: (data: WithTypename<Payment_Min_Fields>) => null | string,
  payment_mutation_response?: (data: WithTypename<Payment_Mutation_Response>) => null | string,
  s3_file?: (data: WithTypename<S3_File>) => null | string,
  s3_file_aggregate?: (data: WithTypename<S3_File_Aggregate>) => null | string,
  s3_file_aggregate_fields?: (data: WithTypename<S3_File_Aggregate_Fields>) => null | string,
  s3_file_avg_fields?: (data: WithTypename<S3_File_Avg_Fields>) => null | string,
  s3_file_max_fields?: (data: WithTypename<S3_File_Max_Fields>) => null | string,
  s3_file_min_fields?: (data: WithTypename<S3_File_Min_Fields>) => null | string,
  s3_file_mutation_response?: (data: WithTypename<S3_File_Mutation_Response>) => null | string,
  s3_file_stddev_fields?: (data: WithTypename<S3_File_Stddev_Fields>) => null | string,
  s3_file_stddev_pop_fields?: (data: WithTypename<S3_File_Stddev_Pop_Fields>) => null | string,
  s3_file_stddev_samp_fields?: (data: WithTypename<S3_File_Stddev_Samp_Fields>) => null | string,
  s3_file_sum_fields?: (data: WithTypename<S3_File_Sum_Fields>) => null | string,
  s3_file_var_pop_fields?: (data: WithTypename<S3_File_Var_Pop_Fields>) => null | string,
  s3_file_var_samp_fields?: (data: WithTypename<S3_File_Var_Samp_Fields>) => null | string,
  s3_file_variance_fields?: (data: WithTypename<S3_File_Variance_Fields>) => null | string,
  team?: (data: WithTypename<Team>) => null | string,
  team_aggregate?: (data: WithTypename<Team_Aggregate>) => null | string,
  team_aggregate_fields?: (data: WithTypename<Team_Aggregate_Fields>) => null | string,
  team_max_fields?: (data: WithTypename<Team_Max_Fields>) => null | string,
  team_min_fields?: (data: WithTypename<Team_Min_Fields>) => null | string,
  team_mutation_response?: (data: WithTypename<Team_Mutation_Response>) => null | string,
  user_permission?: (data: WithTypename<User_Permission>) => null | string,
  user_permission_aggregate?: (data: WithTypename<User_Permission_Aggregate>) => null | string,
  user_permission_aggregate_fields?: (data: WithTypename<User_Permission_Aggregate_Fields>) => null | string,
  user_permission_avg_fields?: (data: WithTypename<User_Permission_Avg_Fields>) => null | string,
  user_permission_max_fields?: (data: WithTypename<User_Permission_Max_Fields>) => null | string,
  user_permission_min_fields?: (data: WithTypename<User_Permission_Min_Fields>) => null | string,
  user_permission_mutation_response?: (data: WithTypename<User_Permission_Mutation_Response>) => null | string,
  user_permission_role?: (data: WithTypename<User_Permission_Role>) => null | string,
  user_permission_role_aggregate?: (data: WithTypename<User_Permission_Role_Aggregate>) => null | string,
  user_permission_role_aggregate_fields?: (data: WithTypename<User_Permission_Role_Aggregate_Fields>) => null | string,
  user_permission_role_max_fields?: (data: WithTypename<User_Permission_Role_Max_Fields>) => null | string,
  user_permission_role_min_fields?: (data: WithTypename<User_Permission_Role_Min_Fields>) => null | string,
  user_permission_role_mutation_response?: (data: WithTypename<User_Permission_Role_Mutation_Response>) => null | string,
  user_permission_stddev_fields?: (data: WithTypename<User_Permission_Stddev_Fields>) => null | string,
  user_permission_stddev_pop_fields?: (data: WithTypename<User_Permission_Stddev_Pop_Fields>) => null | string,
  user_permission_stddev_samp_fields?: (data: WithTypename<User_Permission_Stddev_Samp_Fields>) => null | string,
  user_permission_sum_fields?: (data: WithTypename<User_Permission_Sum_Fields>) => null | string,
  user_permission_var_pop_fields?: (data: WithTypename<User_Permission_Var_Pop_Fields>) => null | string,
  user_permission_var_samp_fields?: (data: WithTypename<User_Permission_Var_Samp_Fields>) => null | string,
  user_permission_variance_fields?: (data: WithTypename<User_Permission_Variance_Fields>) => null | string,
  users?: (data: WithTypename<Users>) => null | string,
  users_aggregate?: (data: WithTypename<Users_Aggregate>) => null | string,
  users_aggregate_fields?: (data: WithTypename<Users_Aggregate_Fields>) => null | string,
  users_max_fields?: (data: WithTypename<Users_Max_Fields>) => null | string,
  users_min_fields?: (data: WithTypename<Users_Min_Fields>) => null | string,
  users_mutation_response?: (data: WithTypename<Users_Mutation_Response>) => null | string
}

export type GraphCacheResolvers = {
  query_root?: {
    club?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootClubArgs, Array<WithTypename<Club> | string>>,
    club_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootClub_AggregateArgs, WithTypename<Club_Aggregate> | string>,
    club_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootClub_By_PkArgs, WithTypename<Club> | string>,
    editor_type?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEditor_TypeArgs, Array<WithTypename<Editor_Type> | string>>,
    editor_type_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEditor_Type_AggregateArgs, WithTypename<Editor_Type_Aggregate> | string>,
    editor_type_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEditor_Type_By_PkArgs, WithTypename<Editor_Type> | string>,
    enum_exercise_categories?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEnum_Exercise_CategoriesArgs, Array<WithTypename<Enum_Exercise_Categories> | string>>,
    enum_exercise_categories_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEnum_Exercise_Categories_AggregateArgs, WithTypename<Enum_Exercise_Categories_Aggregate> | string>,
    enum_exercise_categories_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEnum_Exercise_Categories_By_PkArgs, WithTypename<Enum_Exercise_Categories> | string>,
    enum_languages?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEnum_LanguagesArgs, Array<WithTypename<Enum_Languages> | string>>,
    enum_languages_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEnum_Languages_AggregateArgs, WithTypename<Enum_Languages_Aggregate> | string>,
    enum_languages_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEnum_Languages_By_PkArgs, WithTypename<Enum_Languages> | string>,
    enum_sport?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEnum_SportArgs, Array<WithTypename<Enum_Sport> | string>>,
    enum_sport_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEnum_Sport_AggregateArgs, WithTypename<Enum_Sport_Aggregate> | string>,
    enum_sport_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootEnum_Sport_By_PkArgs, WithTypename<Enum_Sport> | string>,
    exercise?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExerciseArgs, Array<WithTypename<Exercise> | string>>,
    exercise_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_AggregateArgs, WithTypename<Exercise_Aggregate> | string>,
    exercise_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_By_PkArgs, WithTypename<Exercise> | string>,
    exercise_club_mn?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Club_MnArgs, Array<WithTypename<Exercise_Club_Mn> | string>>,
    exercise_club_mn_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Club_Mn_AggregateArgs, WithTypename<Exercise_Club_Mn_Aggregate> | string>,
    exercise_club_mn_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Club_Mn_By_PkArgs, WithTypename<Exercise_Club_Mn> | string>,
    exercise_content_media?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Content_MediaArgs, Array<WithTypename<Exercise_Content_Media> | string>>,
    exercise_content_media_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Content_Media_AggregateArgs, WithTypename<Exercise_Content_Media_Aggregate> | string>,
    exercise_content_media_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Content_Media_By_PkArgs, WithTypename<Exercise_Content_Media> | string>,
    exercise_content_media_editor?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Content_Media_EditorArgs, Array<WithTypename<Exercise_Content_Media_Editor> | string>>,
    exercise_content_media_editor_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Content_Media_Editor_AggregateArgs, WithTypename<Exercise_Content_Media_Editor_Aggregate> | string>,
    exercise_content_media_editor_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Content_Media_Editor_By_PkArgs, WithTypename<Exercise_Content_Media_Editor> | string>,
    exercise_content_media_mn?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Content_Media_MnArgs, Array<WithTypename<Exercise_Content_Media_Mn> | string>>,
    exercise_content_media_mn_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Content_Media_Mn_AggregateArgs, WithTypename<Exercise_Content_Media_Mn_Aggregate> | string>,
    exercise_content_media_mn_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Content_Media_Mn_By_PkArgs, WithTypename<Exercise_Content_Media_Mn> | string>,
    exercise_content_media_type?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Content_Media_TypeArgs, Array<WithTypename<Exercise_Content_Media_Type> | string>>,
    exercise_content_media_type_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Content_Media_Type_AggregateArgs, WithTypename<Exercise_Content_Media_Type_Aggregate> | string>,
    exercise_content_media_type_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Content_Media_Type_By_PkArgs, WithTypename<Exercise_Content_Media_Type> | string>,
    exercise_taxonomy?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_TaxonomyArgs, Array<WithTypename<Exercise_Taxonomy> | string>>,
    exercise_taxonomy_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Taxonomy_AggregateArgs, WithTypename<Exercise_Taxonomy_Aggregate> | string>,
    exercise_taxonomy_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Taxonomy_By_PkArgs, WithTypename<Exercise_Taxonomy> | string>,
    exercise_taxonomy_mn?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Taxonomy_MnArgs, Array<WithTypename<Exercise_Taxonomy_Mn> | string>>,
    exercise_taxonomy_mn_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Taxonomy_Mn_AggregateArgs, WithTypename<Exercise_Taxonomy_Mn_Aggregate> | string>,
    exercise_taxonomy_mn_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootExercise_Taxonomy_Mn_By_PkArgs, WithTypename<Exercise_Taxonomy_Mn> | string>,
    license?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootLicenseArgs, Array<WithTypename<License> | string>>,
    license_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootLicense_AggregateArgs, WithTypename<License_Aggregate> | string>,
    license_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootLicense_By_PkArgs, WithTypename<License> | string>,
    member?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMemberArgs, Array<WithTypename<Member> | string>>,
    member_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMember_AggregateArgs, WithTypename<Member_Aggregate> | string>,
    member_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMember_By_PkArgs, WithTypename<Member> | string>,
    member_group?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMember_GroupArgs, Array<WithTypename<Member_Group> | string>>,
    member_group_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMember_Group_AggregateArgs, WithTypename<Member_Group_Aggregate> | string>,
    member_group_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMember_Group_By_PkArgs, WithTypename<Member_Group> | string>,
    member_group_mn?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMember_Group_MnArgs, Array<WithTypename<Member_Group_Mn> | string>>,
    member_group_mn_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMember_Group_Mn_AggregateArgs, WithTypename<Member_Group_Mn_Aggregate> | string>,
    member_group_mn_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootMember_Group_Mn_By_PkArgs, WithTypename<Member_Group_Mn> | string>,
    payment?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootPaymentArgs, Array<WithTypename<Payment> | string>>,
    payment_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootPayment_AggregateArgs, WithTypename<Payment_Aggregate> | string>,
    payment_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootPayment_By_PkArgs, WithTypename<Payment> | string>,
    s3_file?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootS3_FileArgs, Array<WithTypename<S3_File> | string>>,
    s3_file_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootS3_File_AggregateArgs, WithTypename<S3_File_Aggregate> | string>,
    s3_file_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootS3_File_By_PkArgs, WithTypename<S3_File> | string>,
    team?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootTeamArgs, Array<WithTypename<Team> | string>>,
    team_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootTeam_AggregateArgs, WithTypename<Team_Aggregate> | string>,
    team_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootTeam_By_PkArgs, WithTypename<Team> | string>,
    user_permission?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUser_PermissionArgs, Array<WithTypename<User_Permission> | string>>,
    user_permission_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUser_Permission_AggregateArgs, WithTypename<User_Permission_Aggregate> | string>,
    user_permission_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUser_Permission_By_PkArgs, WithTypename<User_Permission> | string>,
    user_permission_role?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUser_Permission_RoleArgs, Array<WithTypename<User_Permission_Role> | string>>,
    user_permission_role_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUser_Permission_Role_AggregateArgs, WithTypename<User_Permission_Role_Aggregate> | string>,
    user_permission_role_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUser_Permission_Role_By_PkArgs, WithTypename<User_Permission_Role> | string>,
    users?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUsersArgs, Array<WithTypename<Users> | string>>,
    users_aggregate?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUsers_AggregateArgs, WithTypename<Users_Aggregate> | string>,
    users_by_pk?: GraphCacheResolver<WithTypename<Query_Root>, Query_RootUsers_By_PkArgs, WithTypename<Users> | string>
  },
  club?: {
    created_at?: GraphCacheResolver<WithTypename<Club>, Record<string, never>, Scalars['timestamptz'] | string>,
    exercise_club_mns?: GraphCacheResolver<WithTypename<Club>, ClubExercise_Club_MnsArgs, Array<WithTypename<Exercise_Club_Mn> | string>>,
    exercise_club_mns_aggregate?: GraphCacheResolver<WithTypename<Club>, ClubExercise_Club_Mns_AggregateArgs, WithTypename<Exercise_Club_Mn_Aggregate> | string>,
    id?: GraphCacheResolver<WithTypename<Club>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<Club>, Record<string, never>, Scalars['String'] | string>,
    owner_id?: GraphCacheResolver<WithTypename<Club>, Record<string, never>, Scalars['String'] | string>,
    payments?: GraphCacheResolver<WithTypename<Club>, ClubPaymentsArgs, Array<WithTypename<Payment> | string>>,
    payments_aggregate?: GraphCacheResolver<WithTypename<Club>, ClubPayments_AggregateArgs, WithTypename<Payment_Aggregate> | string>,
    sport?: GraphCacheResolver<WithTypename<Club>, Record<string, never>, Enum_Sport_Enum | string>,
    sport_enum?: GraphCacheResolver<WithTypename<Club>, Record<string, never>, WithTypename<Enum_Sport> | string>,
    teams?: GraphCacheResolver<WithTypename<Club>, ClubTeamsArgs, Array<WithTypename<Team> | string>>,
    teams_aggregate?: GraphCacheResolver<WithTypename<Club>, ClubTeams_AggregateArgs, WithTypename<Team_Aggregate> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Club>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Club>, Record<string, never>, WithTypename<Users> | string>,
    user_permissions?: GraphCacheResolver<WithTypename<Club>, ClubUser_PermissionsArgs, Array<WithTypename<User_Permission> | string>>,
    user_permissions_aggregate?: GraphCacheResolver<WithTypename<Club>, ClubUser_Permissions_AggregateArgs, WithTypename<User_Permission_Aggregate> | string>
  },
  club_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Club_Aggregate>, Record<string, never>, WithTypename<Club_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Club_Aggregate>, Record<string, never>, Array<WithTypename<Club> | string>>
  },
  club_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Club_Aggregate_Fields>, Club_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Club_Aggregate_Fields>, Record<string, never>, WithTypename<Club_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Club_Aggregate_Fields>, Record<string, never>, WithTypename<Club_Min_Fields> | string>
  },
  club_max_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Club_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Club_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<Club_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    owner_id?: GraphCacheResolver<WithTypename<Club_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Club_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  club_min_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Club_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Club_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<Club_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    owner_id?: GraphCacheResolver<WithTypename<Club_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Club_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  club_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Club_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Club_Mutation_Response>, Record<string, never>, Array<WithTypename<Club> | string>>
  },
  editor_type?: {
    name?: GraphCacheResolver<WithTypename<Editor_Type>, Record<string, never>, Scalars['String'] | string>
  },
  editor_type_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Editor_Type_Aggregate>, Record<string, never>, WithTypename<Editor_Type_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Editor_Type_Aggregate>, Record<string, never>, Array<WithTypename<Editor_Type> | string>>
  },
  editor_type_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Editor_Type_Aggregate_Fields>, Editor_Type_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Editor_Type_Aggregate_Fields>, Record<string, never>, WithTypename<Editor_Type_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Editor_Type_Aggregate_Fields>, Record<string, never>, WithTypename<Editor_Type_Min_Fields> | string>
  },
  editor_type_max_fields?: {
    name?: GraphCacheResolver<WithTypename<Editor_Type_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  editor_type_min_fields?: {
    name?: GraphCacheResolver<WithTypename<Editor_Type_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  editor_type_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Editor_Type_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Editor_Type_Mutation_Response>, Record<string, never>, Array<WithTypename<Editor_Type> | string>>
  },
  enum_exercise_categories?: {
    exercise_taxonomies?: GraphCacheResolver<WithTypename<Enum_Exercise_Categories>, Enum_Exercise_CategoriesExercise_TaxonomiesArgs, Array<WithTypename<Exercise_Taxonomy> | string>>,
    exercise_taxonomies_aggregate?: GraphCacheResolver<WithTypename<Enum_Exercise_Categories>, Enum_Exercise_CategoriesExercise_Taxonomies_AggregateArgs, WithTypename<Exercise_Taxonomy_Aggregate> | string>,
    name?: GraphCacheResolver<WithTypename<Enum_Exercise_Categories>, Record<string, never>, Scalars['String'] | string>
  },
  enum_exercise_categories_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Enum_Exercise_Categories_Aggregate>, Record<string, never>, WithTypename<Enum_Exercise_Categories_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Enum_Exercise_Categories_Aggregate>, Record<string, never>, Array<WithTypename<Enum_Exercise_Categories> | string>>
  },
  enum_exercise_categories_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Enum_Exercise_Categories_Aggregate_Fields>, Enum_Exercise_Categories_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Enum_Exercise_Categories_Aggregate_Fields>, Record<string, never>, WithTypename<Enum_Exercise_Categories_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Enum_Exercise_Categories_Aggregate_Fields>, Record<string, never>, WithTypename<Enum_Exercise_Categories_Min_Fields> | string>
  },
  enum_exercise_categories_max_fields?: {
    name?: GraphCacheResolver<WithTypename<Enum_Exercise_Categories_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  enum_exercise_categories_min_fields?: {
    name?: GraphCacheResolver<WithTypename<Enum_Exercise_Categories_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  enum_exercise_categories_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Enum_Exercise_Categories_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Enum_Exercise_Categories_Mutation_Response>, Record<string, never>, Array<WithTypename<Enum_Exercise_Categories> | string>>
  },
  enum_languages?: {
    name?: GraphCacheResolver<WithTypename<Enum_Languages>, Record<string, never>, Scalars['String'] | string>
  },
  enum_languages_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Enum_Languages_Aggregate>, Record<string, never>, WithTypename<Enum_Languages_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Enum_Languages_Aggregate>, Record<string, never>, Array<WithTypename<Enum_Languages> | string>>
  },
  enum_languages_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Enum_Languages_Aggregate_Fields>, Enum_Languages_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Enum_Languages_Aggregate_Fields>, Record<string, never>, WithTypename<Enum_Languages_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Enum_Languages_Aggregate_Fields>, Record<string, never>, WithTypename<Enum_Languages_Min_Fields> | string>
  },
  enum_languages_max_fields?: {
    name?: GraphCacheResolver<WithTypename<Enum_Languages_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  enum_languages_min_fields?: {
    name?: GraphCacheResolver<WithTypename<Enum_Languages_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  enum_languages_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Enum_Languages_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Enum_Languages_Mutation_Response>, Record<string, never>, Array<WithTypename<Enum_Languages> | string>>
  },
  enum_sport?: {
    clubs?: GraphCacheResolver<WithTypename<Enum_Sport>, Enum_SportClubsArgs, Array<WithTypename<Club> | string>>,
    clubs_aggregate?: GraphCacheResolver<WithTypename<Enum_Sport>, Enum_SportClubs_AggregateArgs, WithTypename<Club_Aggregate> | string>,
    exercise_taxonomies?: GraphCacheResolver<WithTypename<Enum_Sport>, Enum_SportExercise_TaxonomiesArgs, Array<WithTypename<Exercise_Taxonomy> | string>>,
    exercise_taxonomies_aggregate?: GraphCacheResolver<WithTypename<Enum_Sport>, Enum_SportExercise_Taxonomies_AggregateArgs, WithTypename<Exercise_Taxonomy_Aggregate> | string>,
    name?: GraphCacheResolver<WithTypename<Enum_Sport>, Record<string, never>, Scalars['String'] | string>
  },
  enum_sport_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Enum_Sport_Aggregate>, Record<string, never>, WithTypename<Enum_Sport_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Enum_Sport_Aggregate>, Record<string, never>, Array<WithTypename<Enum_Sport> | string>>
  },
  enum_sport_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Enum_Sport_Aggregate_Fields>, Enum_Sport_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Enum_Sport_Aggregate_Fields>, Record<string, never>, WithTypename<Enum_Sport_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Enum_Sport_Aggregate_Fields>, Record<string, never>, WithTypename<Enum_Sport_Min_Fields> | string>
  },
  enum_sport_max_fields?: {
    name?: GraphCacheResolver<WithTypename<Enum_Sport_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  enum_sport_min_fields?: {
    name?: GraphCacheResolver<WithTypename<Enum_Sport_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  enum_sport_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Enum_Sport_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Enum_Sport_Mutation_Response>, Record<string, never>, Array<WithTypename<Enum_Sport> | string>>
  },
  exercise?: {
    created_at?: GraphCacheResolver<WithTypename<Exercise>, Record<string, never>, Scalars['timestamptz'] | string>,
    exercise_club_mns?: GraphCacheResolver<WithTypename<Exercise>, ExerciseExercise_Club_MnsArgs, Array<WithTypename<Exercise_Club_Mn> | string>>,
    exercise_club_mns_aggregate?: GraphCacheResolver<WithTypename<Exercise>, ExerciseExercise_Club_Mns_AggregateArgs, WithTypename<Exercise_Club_Mn_Aggregate> | string>,
    exercise_content_media_mns?: GraphCacheResolver<WithTypename<Exercise>, ExerciseExercise_Content_Media_MnsArgs, Array<WithTypename<Exercise_Content_Media_Mn> | string>>,
    exercise_content_media_mns_aggregate?: GraphCacheResolver<WithTypename<Exercise>, ExerciseExercise_Content_Media_Mns_AggregateArgs, WithTypename<Exercise_Content_Media_Mn_Aggregate> | string>,
    exercise_taxonomy_mns?: GraphCacheResolver<WithTypename<Exercise>, ExerciseExercise_Taxonomy_MnsArgs, Array<WithTypename<Exercise_Taxonomy_Mn> | string>>,
    exercise_taxonomy_mns_aggregate?: GraphCacheResolver<WithTypename<Exercise>, ExerciseExercise_Taxonomy_Mns_AggregateArgs, WithTypename<Exercise_Taxonomy_Mn_Aggregate> | string>,
    fitness_stars?: GraphCacheResolver<WithTypename<Exercise>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<Exercise>, Record<string, never>, Scalars['String'] | string>,
    locale?: GraphCacheResolver<WithTypename<Exercise>, Record<string, never>, Scalars['String'] | string>,
    owner_id?: GraphCacheResolver<WithTypename<Exercise>, Record<string, never>, Scalars['String'] | string>,
    tactics_stars?: GraphCacheResolver<WithTypename<Exercise>, Record<string, never>, Scalars['Int'] | string>,
    technique_stars?: GraphCacheResolver<WithTypename<Exercise>, Record<string, never>, Scalars['Int'] | string>,
    title?: GraphCacheResolver<WithTypename<Exercise>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Exercise>, Record<string, never>, Scalars['timestamptz'] | string>,
    user?: GraphCacheResolver<WithTypename<Exercise>, Record<string, never>, WithTypename<Users> | string>
  },
  exercise_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Exercise_Aggregate>, Record<string, never>, WithTypename<Exercise_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Exercise_Aggregate>, Record<string, never>, Array<WithTypename<Exercise> | string>>
  },
  exercise_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Exercise_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Exercise_Aggregate_Fields>, Exercise_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Exercise_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Exercise_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Exercise_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Exercise_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Exercise_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Exercise_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Exercise_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Exercise_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Exercise_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Variance_Fields> | string>
  },
  exercise_avg_fields?: {
    fitness_stars?: GraphCacheResolver<WithTypename<Exercise_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tactics_stars?: GraphCacheResolver<WithTypename<Exercise_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>,
    technique_stars?: GraphCacheResolver<WithTypename<Exercise_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_club_mn?: {
    club?: GraphCacheResolver<WithTypename<Exercise_Club_Mn>, Record<string, never>, WithTypename<Club> | string>,
    club_id?: GraphCacheResolver<WithTypename<Exercise_Club_Mn>, Record<string, never>, Scalars['String'] | string>,
    exercise?: GraphCacheResolver<WithTypename<Exercise_Club_Mn>, Record<string, never>, WithTypename<Exercise> | string>,
    exercise_id?: GraphCacheResolver<WithTypename<Exercise_Club_Mn>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_club_mn_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Exercise_Club_Mn_Aggregate>, Record<string, never>, WithTypename<Exercise_Club_Mn_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Exercise_Club_Mn_Aggregate>, Record<string, never>, Array<WithTypename<Exercise_Club_Mn> | string>>
  },
  exercise_club_mn_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Exercise_Club_Mn_Aggregate_Fields>, Exercise_Club_Mn_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Exercise_Club_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Club_Mn_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Exercise_Club_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Club_Mn_Min_Fields> | string>
  },
  exercise_club_mn_max_fields?: {
    club_id?: GraphCacheResolver<WithTypename<Exercise_Club_Mn_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    exercise_id?: GraphCacheResolver<WithTypename<Exercise_Club_Mn_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_club_mn_min_fields?: {
    club_id?: GraphCacheResolver<WithTypename<Exercise_Club_Mn_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    exercise_id?: GraphCacheResolver<WithTypename<Exercise_Club_Mn_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_club_mn_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Exercise_Club_Mn_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Exercise_Club_Mn_Mutation_Response>, Record<string, never>, Array<WithTypename<Exercise_Club_Mn> | string>>
  },
  exercise_content_media?: {
    created_at?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, Scalars['timestamptz'] | string>,
    editor_animation_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, Scalars['String'] | string>,
    editor_image_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, Scalars['String'] | string>,
    exercise_content_media_editor?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, WithTypename<Exercise_Content_Media_Editor> | string>,
    exercise_content_media_mns?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Exercise_Content_MediaExercise_Content_Media_MnsArgs, Array<WithTypename<Exercise_Content_Media_Mn> | string>>,
    exercise_content_media_mns_aggregate?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Exercise_Content_MediaExercise_Content_Media_Mns_AggregateArgs, WithTypename<Exercise_Content_Media_Mn_Aggregate> | string>,
    exercise_content_media_type?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, WithTypename<Exercise_Content_Media_Type> | string>,
    id?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, Scalars['String'] | string>,
    is_media_right?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, Scalars['Boolean'] | string>,
    s3_file?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, WithTypename<S3_File> | string>,
    s3_file_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, Scalars['String'] | string>,
    text?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, Scalars['String'] | string>,
    type?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, Exercise_Content_Media_Type_Enum | string>,
    updated_at?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, Scalars['timestamptz'] | string>,
    video_url?: GraphCacheResolver<WithTypename<Exercise_Content_Media>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_content_media_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Aggregate>, Record<string, never>, WithTypename<Exercise_Content_Media_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Aggregate>, Record<string, never>, Array<WithTypename<Exercise_Content_Media> | string>>
  },
  exercise_content_media_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Aggregate_Fields>, Exercise_Content_Media_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Min_Fields> | string>
  },
  exercise_content_media_editor?: {
    content_media_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor>, Record<string, never>, Scalars['String'] | string>,
    editor_data?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor>, Exercise_Content_Media_EditorEditor_DataArgs, Scalars['jsonb'] | string>,
    exercise_content_media?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor>, Record<string, never>, WithTypename<Exercise_Content_Media> | string>,
    id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor>, Record<string, never>, Scalars['String'] | string>,
    image_s3_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor>, Record<string, never>, Scalars['String'] | string>,
    s3_file_image?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor>, Record<string, never>, WithTypename<S3_File> | string>,
    s3_file_video?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor>, Record<string, never>, WithTypename<S3_File> | string>,
    video_s3_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_content_media_editor_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Aggregate>, Record<string, never>, WithTypename<Exercise_Content_Media_Editor_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Aggregate>, Record<string, never>, Array<WithTypename<Exercise_Content_Media_Editor> | string>>
  },
  exercise_content_media_editor_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Aggregate_Fields>, Exercise_Content_Media_Editor_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Editor_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Editor_Min_Fields> | string>
  },
  exercise_content_media_editor_max_fields?: {
    content_media_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    image_s3_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    video_s3_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_content_media_editor_min_fields?: {
    content_media_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    image_s3_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    video_s3_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_content_media_editor_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Editor_Mutation_Response>, Record<string, never>, Array<WithTypename<Exercise_Content_Media_Editor> | string>>
  },
  exercise_content_media_max_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    editor_animation_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    editor_image_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    s3_file_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    text?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    video_url?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_content_media_min_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    editor_animation_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    editor_image_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    s3_file_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    text?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    video_url?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_content_media_mn?: {
    exercise?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn>, Record<string, never>, WithTypename<Exercise> | string>,
    exercise_content_media?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn>, Record<string, never>, WithTypename<Exercise_Content_Media> | string>,
    exercise_content_media_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn>, Record<string, never>, Scalars['String'] | string>,
    exercise_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn>, Record<string, never>, Scalars['String'] | string>,
    sort?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn>, Record<string, never>, Scalars['Int'] | string>
  },
  exercise_content_media_mn_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate>, Record<string, never>, WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate>, Record<string, never>, Array<WithTypename<Exercise_Content_Media_Mn> | string>>
  },
  exercise_content_media_mn_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Mn_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields>, Exercise_Content_Media_Mn_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Mn_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Mn_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Mn_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Mn_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Mn_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Mn_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Mn_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Mn_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Mn_Variance_Fields> | string>
  },
  exercise_content_media_mn_avg_fields?: {
    sort?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_content_media_mn_max_fields?: {
    exercise_content_media_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    exercise_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    sort?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Max_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  exercise_content_media_mn_min_fields?: {
    exercise_content_media_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    exercise_id?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    sort?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Min_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  exercise_content_media_mn_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Mutation_Response>, Record<string, never>, Array<WithTypename<Exercise_Content_Media_Mn> | string>>
  },
  exercise_content_media_mn_stddev_fields?: {
    sort?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_content_media_mn_stddev_pop_fields?: {
    sort?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_content_media_mn_stddev_samp_fields?: {
    sort?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_content_media_mn_sum_fields?: {
    sort?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  exercise_content_media_mn_var_pop_fields?: {
    sort?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_content_media_mn_var_samp_fields?: {
    sort?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_content_media_mn_variance_fields?: {
    sort?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mn_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_content_media_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Mutation_Response>, Record<string, never>, Array<WithTypename<Exercise_Content_Media> | string>>
  },
  exercise_content_media_type?: {
    exercise_content_media?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Type>, Exercise_Content_Media_TypeExercise_Content_MediaArgs, Array<WithTypename<Exercise_Content_Media> | string>>,
    exercise_content_media_aggregate?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Type>, Exercise_Content_Media_TypeExercise_Content_Media_AggregateArgs, WithTypename<Exercise_Content_Media_Aggregate> | string>,
    name?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Type>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_content_media_type_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Type_Aggregate>, Record<string, never>, WithTypename<Exercise_Content_Media_Type_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Type_Aggregate>, Record<string, never>, Array<WithTypename<Exercise_Content_Media_Type> | string>>
  },
  exercise_content_media_type_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Type_Aggregate_Fields>, Exercise_Content_Media_Type_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Type_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Type_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Type_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Content_Media_Type_Min_Fields> | string>
  },
  exercise_content_media_type_max_fields?: {
    name?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Type_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_content_media_type_min_fields?: {
    name?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Type_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_content_media_type_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Type_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Exercise_Content_Media_Type_Mutation_Response>, Record<string, never>, Array<WithTypename<Exercise_Content_Media_Type> | string>>
  },
  exercise_max_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Exercise_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    fitness_stars?: GraphCacheResolver<WithTypename<Exercise_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<Exercise_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    locale?: GraphCacheResolver<WithTypename<Exercise_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    owner_id?: GraphCacheResolver<WithTypename<Exercise_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    tactics_stars?: GraphCacheResolver<WithTypename<Exercise_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    technique_stars?: GraphCacheResolver<WithTypename<Exercise_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    title?: GraphCacheResolver<WithTypename<Exercise_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Exercise_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  exercise_min_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Exercise_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    fitness_stars?: GraphCacheResolver<WithTypename<Exercise_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    id?: GraphCacheResolver<WithTypename<Exercise_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    locale?: GraphCacheResolver<WithTypename<Exercise_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    owner_id?: GraphCacheResolver<WithTypename<Exercise_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    tactics_stars?: GraphCacheResolver<WithTypename<Exercise_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    technique_stars?: GraphCacheResolver<WithTypename<Exercise_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    title?: GraphCacheResolver<WithTypename<Exercise_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Exercise_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  exercise_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Exercise_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Exercise_Mutation_Response>, Record<string, never>, Array<WithTypename<Exercise> | string>>
  },
  exercise_stddev_fields?: {
    fitness_stars?: GraphCacheResolver<WithTypename<Exercise_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tactics_stars?: GraphCacheResolver<WithTypename<Exercise_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>,
    technique_stars?: GraphCacheResolver<WithTypename<Exercise_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_stddev_pop_fields?: {
    fitness_stars?: GraphCacheResolver<WithTypename<Exercise_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tactics_stars?: GraphCacheResolver<WithTypename<Exercise_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    technique_stars?: GraphCacheResolver<WithTypename<Exercise_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_stddev_samp_fields?: {
    fitness_stars?: GraphCacheResolver<WithTypename<Exercise_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tactics_stars?: GraphCacheResolver<WithTypename<Exercise_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    technique_stars?: GraphCacheResolver<WithTypename<Exercise_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_sum_fields?: {
    fitness_stars?: GraphCacheResolver<WithTypename<Exercise_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    tactics_stars?: GraphCacheResolver<WithTypename<Exercise_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>,
    technique_stars?: GraphCacheResolver<WithTypename<Exercise_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  exercise_taxonomy?: {
    category?: GraphCacheResolver<WithTypename<Exercise_Taxonomy>, Record<string, never>, Enum_Exercise_Categories_Enum | string>,
    club_id?: GraphCacheResolver<WithTypename<Exercise_Taxonomy>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Exercise_Taxonomy>, Record<string, never>, Scalars['timestamptz'] | string>,
    enum_exercise_category?: GraphCacheResolver<WithTypename<Exercise_Taxonomy>, Record<string, never>, WithTypename<Enum_Exercise_Categories> | string>,
    enum_sport?: GraphCacheResolver<WithTypename<Exercise_Taxonomy>, Record<string, never>, WithTypename<Enum_Sport> | string>,
    exercise_taxonomy_mns?: GraphCacheResolver<WithTypename<Exercise_Taxonomy>, Exercise_TaxonomyExercise_Taxonomy_MnsArgs, Array<WithTypename<Exercise_Taxonomy_Mn> | string>>,
    exercise_taxonomy_mns_aggregate?: GraphCacheResolver<WithTypename<Exercise_Taxonomy>, Exercise_TaxonomyExercise_Taxonomy_Mns_AggregateArgs, WithTypename<Exercise_Taxonomy_Mn_Aggregate> | string>,
    id?: GraphCacheResolver<WithTypename<Exercise_Taxonomy>, Record<string, never>, Scalars['String'] | string>,
    locale?: GraphCacheResolver<WithTypename<Exercise_Taxonomy>, Record<string, never>, Scalars['String'] | string>,
    sport?: GraphCacheResolver<WithTypename<Exercise_Taxonomy>, Record<string, never>, Enum_Sport_Enum | string>,
    translation_key?: GraphCacheResolver<WithTypename<Exercise_Taxonomy>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Exercise_Taxonomy>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  exercise_taxonomy_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Aggregate>, Record<string, never>, WithTypename<Exercise_Taxonomy_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Aggregate>, Record<string, never>, Array<WithTypename<Exercise_Taxonomy> | string>>
  },
  exercise_taxonomy_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Aggregate_Fields>, Exercise_Taxonomy_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Taxonomy_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Taxonomy_Min_Fields> | string>
  },
  exercise_taxonomy_max_fields?: {
    club_id?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    locale?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    translation_key?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  exercise_taxonomy_min_fields?: {
    club_id?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    locale?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    translation_key?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  exercise_taxonomy_mn?: {
    exercise?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn>, Record<string, never>, WithTypename<Exercise> | string>,
    exercise_id?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn>, Record<string, never>, Scalars['String'] | string>,
    exercise_taxonomy?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn>, Record<string, never>, WithTypename<Exercise_Taxonomy> | string>,
    taxonomy_id?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_taxonomy_mn_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn_Aggregate>, Record<string, never>, WithTypename<Exercise_Taxonomy_Mn_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn_Aggregate>, Record<string, never>, Array<WithTypename<Exercise_Taxonomy_Mn> | string>>
  },
  exercise_taxonomy_mn_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn_Aggregate_Fields>, Exercise_Taxonomy_Mn_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Taxonomy_Mn_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Exercise_Taxonomy_Mn_Min_Fields> | string>
  },
  exercise_taxonomy_mn_max_fields?: {
    exercise_id?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    taxonomy_id?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_taxonomy_mn_min_fields?: {
    exercise_id?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    taxonomy_id?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  exercise_taxonomy_mn_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mn_Mutation_Response>, Record<string, never>, Array<WithTypename<Exercise_Taxonomy_Mn> | string>>
  },
  exercise_taxonomy_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Exercise_Taxonomy_Mutation_Response>, Record<string, never>, Array<WithTypename<Exercise_Taxonomy> | string>>
  },
  exercise_var_pop_fields?: {
    fitness_stars?: GraphCacheResolver<WithTypename<Exercise_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tactics_stars?: GraphCacheResolver<WithTypename<Exercise_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>,
    technique_stars?: GraphCacheResolver<WithTypename<Exercise_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_var_samp_fields?: {
    fitness_stars?: GraphCacheResolver<WithTypename<Exercise_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tactics_stars?: GraphCacheResolver<WithTypename<Exercise_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>,
    technique_stars?: GraphCacheResolver<WithTypename<Exercise_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  exercise_variance_fields?: {
    fitness_stars?: GraphCacheResolver<WithTypename<Exercise_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    tactics_stars?: GraphCacheResolver<WithTypename<Exercise_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>,
    technique_stars?: GraphCacheResolver<WithTypename<Exercise_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  license?: {
    name?: GraphCacheResolver<WithTypename<License>, Record<string, never>, Scalars['String'] | string>,
    payments?: GraphCacheResolver<WithTypename<License>, LicensePaymentsArgs, Array<WithTypename<Payment> | string>>,
    payments_aggregate?: GraphCacheResolver<WithTypename<License>, LicensePayments_AggregateArgs, WithTypename<Payment_Aggregate> | string>
  },
  license_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<License_Aggregate>, Record<string, never>, WithTypename<License_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<License_Aggregate>, Record<string, never>, Array<WithTypename<License> | string>>
  },
  license_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<License_Aggregate_Fields>, License_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<License_Aggregate_Fields>, Record<string, never>, WithTypename<License_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<License_Aggregate_Fields>, Record<string, never>, WithTypename<License_Min_Fields> | string>
  },
  license_max_fields?: {
    name?: GraphCacheResolver<WithTypename<License_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  license_min_fields?: {
    name?: GraphCacheResolver<WithTypename<License_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  license_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<License_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<License_Mutation_Response>, Record<string, never>, Array<WithTypename<License> | string>>
  },
  member?: {
    email?: GraphCacheResolver<WithTypename<Member>, Record<string, never>, Scalars['String'] | string>,
    first_name?: GraphCacheResolver<WithTypename<Member>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Member>, Record<string, never>, Scalars['String'] | string>,
    last_name?: GraphCacheResolver<WithTypename<Member>, Record<string, never>, Scalars['String'] | string>,
    user_id?: GraphCacheResolver<WithTypename<Member>, Record<string, never>, Scalars['String'] | string>
  },
  member_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Member_Aggregate>, Record<string, never>, WithTypename<Member_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Member_Aggregate>, Record<string, never>, Array<WithTypename<Member> | string>>
  },
  member_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Member_Aggregate_Fields>, Member_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Member_Aggregate_Fields>, Record<string, never>, WithTypename<Member_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Member_Aggregate_Fields>, Record<string, never>, WithTypename<Member_Min_Fields> | string>
  },
  member_group?: {
    name?: GraphCacheResolver<WithTypename<Member_Group>, Record<string, never>, Scalars['String'] | string>
  },
  member_group_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Member_Group_Aggregate>, Record<string, never>, WithTypename<Member_Group_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Member_Group_Aggregate>, Record<string, never>, Array<WithTypename<Member_Group> | string>>
  },
  member_group_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Member_Group_Aggregate_Fields>, Member_Group_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Member_Group_Aggregate_Fields>, Record<string, never>, WithTypename<Member_Group_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Member_Group_Aggregate_Fields>, Record<string, never>, WithTypename<Member_Group_Min_Fields> | string>
  },
  member_group_max_fields?: {
    name?: GraphCacheResolver<WithTypename<Member_Group_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  member_group_min_fields?: {
    name?: GraphCacheResolver<WithTypename<Member_Group_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  member_group_mn?: {
    group_id?: GraphCacheResolver<WithTypename<Member_Group_Mn>, Record<string, never>, Scalars['String'] | string>,
    member_id?: GraphCacheResolver<WithTypename<Member_Group_Mn>, Record<string, never>, Scalars['String'] | string>
  },
  member_group_mn_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Member_Group_Mn_Aggregate>, Record<string, never>, WithTypename<Member_Group_Mn_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Member_Group_Mn_Aggregate>, Record<string, never>, Array<WithTypename<Member_Group_Mn> | string>>
  },
  member_group_mn_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Member_Group_Mn_Aggregate_Fields>, Member_Group_Mn_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Member_Group_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Member_Group_Mn_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Member_Group_Mn_Aggregate_Fields>, Record<string, never>, WithTypename<Member_Group_Mn_Min_Fields> | string>
  },
  member_group_mn_max_fields?: {
    group_id?: GraphCacheResolver<WithTypename<Member_Group_Mn_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    member_id?: GraphCacheResolver<WithTypename<Member_Group_Mn_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  member_group_mn_min_fields?: {
    group_id?: GraphCacheResolver<WithTypename<Member_Group_Mn_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    member_id?: GraphCacheResolver<WithTypename<Member_Group_Mn_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  member_group_mn_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Member_Group_Mn_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Member_Group_Mn_Mutation_Response>, Record<string, never>, Array<WithTypename<Member_Group_Mn> | string>>
  },
  member_group_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Member_Group_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Member_Group_Mutation_Response>, Record<string, never>, Array<WithTypename<Member_Group> | string>>
  },
  member_max_fields?: {
    email?: GraphCacheResolver<WithTypename<Member_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    first_name?: GraphCacheResolver<WithTypename<Member_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Member_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    last_name?: GraphCacheResolver<WithTypename<Member_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    user_id?: GraphCacheResolver<WithTypename<Member_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  member_min_fields?: {
    email?: GraphCacheResolver<WithTypename<Member_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    first_name?: GraphCacheResolver<WithTypename<Member_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Member_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    last_name?: GraphCacheResolver<WithTypename<Member_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    user_id?: GraphCacheResolver<WithTypename<Member_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  member_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Member_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Member_Mutation_Response>, Record<string, never>, Array<WithTypename<Member> | string>>
  },
  payment?: {
    active?: GraphCacheResolver<WithTypename<Payment>, Record<string, never>, Scalars['Boolean'] | string>,
    club?: GraphCacheResolver<WithTypename<Payment>, Record<string, never>, WithTypename<Club> | string>,
    club_id?: GraphCacheResolver<WithTypename<Payment>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Payment>, Record<string, never>, Scalars['timestamptz'] | string>,
    fastspring_id?: GraphCacheResolver<WithTypename<Payment>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Payment>, Record<string, never>, Scalars['String'] | string>,
    is_trial?: GraphCacheResolver<WithTypename<Payment>, Record<string, never>, Scalars['Boolean'] | string>,
    license?: GraphCacheResolver<WithTypename<Payment>, Record<string, never>, License_Enum | string>,
    licenseByLicense?: GraphCacheResolver<WithTypename<Payment>, Record<string, never>, WithTypename<License> | string>,
    updated_at?: GraphCacheResolver<WithTypename<Payment>, Record<string, never>, Scalars['timestamptz'] | string>,
    valid_until?: GraphCacheResolver<WithTypename<Payment>, Record<string, never>, Scalars['date'] | string>
  },
  payment_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Payment_Aggregate>, Record<string, never>, WithTypename<Payment_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Payment_Aggregate>, Record<string, never>, Array<WithTypename<Payment> | string>>
  },
  payment_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Payment_Aggregate_Fields>, Payment_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Payment_Aggregate_Fields>, Record<string, never>, WithTypename<Payment_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Payment_Aggregate_Fields>, Record<string, never>, WithTypename<Payment_Min_Fields> | string>
  },
  payment_max_fields?: {
    club_id?: GraphCacheResolver<WithTypename<Payment_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Payment_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    fastspring_id?: GraphCacheResolver<WithTypename<Payment_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Payment_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Payment_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    valid_until?: GraphCacheResolver<WithTypename<Payment_Max_Fields>, Record<string, never>, Scalars['date'] | string>
  },
  payment_min_fields?: {
    club_id?: GraphCacheResolver<WithTypename<Payment_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Payment_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    fastspring_id?: GraphCacheResolver<WithTypename<Payment_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Payment_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Payment_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    valid_until?: GraphCacheResolver<WithTypename<Payment_Min_Fields>, Record<string, never>, Scalars['date'] | string>
  },
  payment_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Payment_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Payment_Mutation_Response>, Record<string, never>, Array<WithTypename<Payment> | string>>
  },
  s3_file?: {
    exercise_content_media?: GraphCacheResolver<WithTypename<S3_File>, S3_FileExercise_Content_MediaArgs, Array<WithTypename<Exercise_Content_Media> | string>>,
    exercise_content_media_aggregate?: GraphCacheResolver<WithTypename<S3_File>, S3_FileExercise_Content_Media_AggregateArgs, WithTypename<Exercise_Content_Media_Aggregate> | string>,
    exercise_content_media_editor_image?: GraphCacheResolver<WithTypename<S3_File>, S3_FileExercise_Content_Media_Editor_ImageArgs, Array<WithTypename<Exercise_Content_Media_Editor> | string>>,
    exercise_content_media_editor_image_aggregate?: GraphCacheResolver<WithTypename<S3_File>, S3_FileExercise_Content_Media_Editor_Image_AggregateArgs, WithTypename<Exercise_Content_Media_Editor_Aggregate> | string>,
    exercise_content_media_editor_video?: GraphCacheResolver<WithTypename<S3_File>, S3_FileExercise_Content_Media_Editor_VideoArgs, Array<WithTypename<Exercise_Content_Media_Editor> | string>>,
    exercise_content_media_editor_video_aggregate?: GraphCacheResolver<WithTypename<S3_File>, S3_FileExercise_Content_Media_Editor_Video_AggregateArgs, WithTypename<Exercise_Content_Media_Editor_Aggregate> | string>,
    name?: GraphCacheResolver<WithTypename<S3_File>, Record<string, never>, Scalars['String'] | string>,
    s3key?: GraphCacheResolver<WithTypename<S3_File>, Record<string, never>, Scalars['String'] | string>,
    size?: GraphCacheResolver<WithTypename<S3_File>, Record<string, never>, Scalars['bigint'] | string>,
    type?: GraphCacheResolver<WithTypename<S3_File>, Record<string, never>, Scalars['String'] | string>,
    url?: GraphCacheResolver<WithTypename<S3_File>, Record<string, never>, Scalars['String'] | string>
  },
  s3_file_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<S3_File_Aggregate>, Record<string, never>, WithTypename<S3_File_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<S3_File_Aggregate>, Record<string, never>, Array<WithTypename<S3_File> | string>>
  },
  s3_file_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<S3_File_Aggregate_Fields>, Record<string, never>, WithTypename<S3_File_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<S3_File_Aggregate_Fields>, S3_File_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<S3_File_Aggregate_Fields>, Record<string, never>, WithTypename<S3_File_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<S3_File_Aggregate_Fields>, Record<string, never>, WithTypename<S3_File_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<S3_File_Aggregate_Fields>, Record<string, never>, WithTypename<S3_File_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<S3_File_Aggregate_Fields>, Record<string, never>, WithTypename<S3_File_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<S3_File_Aggregate_Fields>, Record<string, never>, WithTypename<S3_File_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<S3_File_Aggregate_Fields>, Record<string, never>, WithTypename<S3_File_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<S3_File_Aggregate_Fields>, Record<string, never>, WithTypename<S3_File_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<S3_File_Aggregate_Fields>, Record<string, never>, WithTypename<S3_File_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<S3_File_Aggregate_Fields>, Record<string, never>, WithTypename<S3_File_Variance_Fields> | string>
  },
  s3_file_avg_fields?: {
    size?: GraphCacheResolver<WithTypename<S3_File_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  s3_file_max_fields?: {
    name?: GraphCacheResolver<WithTypename<S3_File_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    s3key?: GraphCacheResolver<WithTypename<S3_File_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    size?: GraphCacheResolver<WithTypename<S3_File_Max_Fields>, Record<string, never>, Scalars['bigint'] | string>,
    type?: GraphCacheResolver<WithTypename<S3_File_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    url?: GraphCacheResolver<WithTypename<S3_File_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  s3_file_min_fields?: {
    name?: GraphCacheResolver<WithTypename<S3_File_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    s3key?: GraphCacheResolver<WithTypename<S3_File_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    size?: GraphCacheResolver<WithTypename<S3_File_Min_Fields>, Record<string, never>, Scalars['bigint'] | string>,
    type?: GraphCacheResolver<WithTypename<S3_File_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    url?: GraphCacheResolver<WithTypename<S3_File_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  s3_file_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<S3_File_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<S3_File_Mutation_Response>, Record<string, never>, Array<WithTypename<S3_File> | string>>
  },
  s3_file_stddev_fields?: {
    size?: GraphCacheResolver<WithTypename<S3_File_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  s3_file_stddev_pop_fields?: {
    size?: GraphCacheResolver<WithTypename<S3_File_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  s3_file_stddev_samp_fields?: {
    size?: GraphCacheResolver<WithTypename<S3_File_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  s3_file_sum_fields?: {
    size?: GraphCacheResolver<WithTypename<S3_File_Sum_Fields>, Record<string, never>, Scalars['bigint'] | string>
  },
  s3_file_var_pop_fields?: {
    size?: GraphCacheResolver<WithTypename<S3_File_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  s3_file_var_samp_fields?: {
    size?: GraphCacheResolver<WithTypename<S3_File_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  s3_file_variance_fields?: {
    size?: GraphCacheResolver<WithTypename<S3_File_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  team?: {
    club?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, WithTypename<Club> | string>,
    club_id?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Team>, Record<string, never>, Scalars['timestamptz'] | string>,
    user_permissions?: GraphCacheResolver<WithTypename<Team>, TeamUser_PermissionsArgs, Array<WithTypename<User_Permission> | string>>,
    user_permissions_aggregate?: GraphCacheResolver<WithTypename<Team>, TeamUser_Permissions_AggregateArgs, WithTypename<User_Permission_Aggregate> | string>
  },
  team_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Team_Aggregate>, Record<string, never>, WithTypename<Team_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Team_Aggregate>, Record<string, never>, Array<WithTypename<Team> | string>>
  },
  team_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Team_Aggregate_Fields>, Team_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Team_Aggregate_Fields>, Record<string, never>, WithTypename<Team_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Team_Aggregate_Fields>, Record<string, never>, WithTypename<Team_Min_Fields> | string>
  },
  team_max_fields?: {
    club_id?: GraphCacheResolver<WithTypename<Team_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Team_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Team_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<Team_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Team_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  team_min_fields?: {
    club_id?: GraphCacheResolver<WithTypename<Team_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    created_at?: GraphCacheResolver<WithTypename<Team_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    id?: GraphCacheResolver<WithTypename<Team_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    name?: GraphCacheResolver<WithTypename<Team_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Team_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  team_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Team_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Team_Mutation_Response>, Record<string, never>, Array<WithTypename<Team> | string>>
  },
  user_permission?: {
    club?: GraphCacheResolver<WithTypename<User_Permission>, Record<string, never>, WithTypename<Club> | string>,
    club_id?: GraphCacheResolver<WithTypename<User_Permission>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<User_Permission>, Record<string, never>, Scalars['Int'] | string>,
    role?: GraphCacheResolver<WithTypename<User_Permission>, Record<string, never>, User_Permission_Role_Enum | string>,
    team?: GraphCacheResolver<WithTypename<User_Permission>, Record<string, never>, WithTypename<Team> | string>,
    team_id?: GraphCacheResolver<WithTypename<User_Permission>, Record<string, never>, Scalars['String'] | string>,
    user?: GraphCacheResolver<WithTypename<User_Permission>, Record<string, never>, WithTypename<Users> | string>,
    user_id?: GraphCacheResolver<WithTypename<User_Permission>, Record<string, never>, Scalars['String'] | string>,
    user_permission_role?: GraphCacheResolver<WithTypename<User_Permission>, Record<string, never>, WithTypename<User_Permission_Role> | string>
  },
  user_permission_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<User_Permission_Aggregate>, Record<string, never>, WithTypename<User_Permission_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<User_Permission_Aggregate>, Record<string, never>, Array<WithTypename<User_Permission> | string>>
  },
  user_permission_aggregate_fields?: {
    avg?: GraphCacheResolver<WithTypename<User_Permission_Aggregate_Fields>, Record<string, never>, WithTypename<User_Permission_Avg_Fields> | string>,
    count?: GraphCacheResolver<WithTypename<User_Permission_Aggregate_Fields>, User_Permission_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<User_Permission_Aggregate_Fields>, Record<string, never>, WithTypename<User_Permission_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<User_Permission_Aggregate_Fields>, Record<string, never>, WithTypename<User_Permission_Min_Fields> | string>,
    stddev?: GraphCacheResolver<WithTypename<User_Permission_Aggregate_Fields>, Record<string, never>, WithTypename<User_Permission_Stddev_Fields> | string>,
    stddev_pop?: GraphCacheResolver<WithTypename<User_Permission_Aggregate_Fields>, Record<string, never>, WithTypename<User_Permission_Stddev_Pop_Fields> | string>,
    stddev_samp?: GraphCacheResolver<WithTypename<User_Permission_Aggregate_Fields>, Record<string, never>, WithTypename<User_Permission_Stddev_Samp_Fields> | string>,
    sum?: GraphCacheResolver<WithTypename<User_Permission_Aggregate_Fields>, Record<string, never>, WithTypename<User_Permission_Sum_Fields> | string>,
    var_pop?: GraphCacheResolver<WithTypename<User_Permission_Aggregate_Fields>, Record<string, never>, WithTypename<User_Permission_Var_Pop_Fields> | string>,
    var_samp?: GraphCacheResolver<WithTypename<User_Permission_Aggregate_Fields>, Record<string, never>, WithTypename<User_Permission_Var_Samp_Fields> | string>,
    variance?: GraphCacheResolver<WithTypename<User_Permission_Aggregate_Fields>, Record<string, never>, WithTypename<User_Permission_Variance_Fields> | string>
  },
  user_permission_avg_fields?: {
    id?: GraphCacheResolver<WithTypename<User_Permission_Avg_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  user_permission_max_fields?: {
    club_id?: GraphCacheResolver<WithTypename<User_Permission_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<User_Permission_Max_Fields>, Record<string, never>, Scalars['Int'] | string>,
    team_id?: GraphCacheResolver<WithTypename<User_Permission_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    user_id?: GraphCacheResolver<WithTypename<User_Permission_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  user_permission_min_fields?: {
    club_id?: GraphCacheResolver<WithTypename<User_Permission_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<User_Permission_Min_Fields>, Record<string, never>, Scalars['Int'] | string>,
    team_id?: GraphCacheResolver<WithTypename<User_Permission_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    user_id?: GraphCacheResolver<WithTypename<User_Permission_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  user_permission_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<User_Permission_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<User_Permission_Mutation_Response>, Record<string, never>, Array<WithTypename<User_Permission> | string>>
  },
  user_permission_role?: {
    name?: GraphCacheResolver<WithTypename<User_Permission_Role>, Record<string, never>, Scalars['String'] | string>,
    user_permissions?: GraphCacheResolver<WithTypename<User_Permission_Role>, User_Permission_RoleUser_PermissionsArgs, Array<WithTypename<User_Permission> | string>>,
    user_permissions_aggregate?: GraphCacheResolver<WithTypename<User_Permission_Role>, User_Permission_RoleUser_Permissions_AggregateArgs, WithTypename<User_Permission_Aggregate> | string>
  },
  user_permission_role_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<User_Permission_Role_Aggregate>, Record<string, never>, WithTypename<User_Permission_Role_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<User_Permission_Role_Aggregate>, Record<string, never>, Array<WithTypename<User_Permission_Role> | string>>
  },
  user_permission_role_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<User_Permission_Role_Aggregate_Fields>, User_Permission_Role_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<User_Permission_Role_Aggregate_Fields>, Record<string, never>, WithTypename<User_Permission_Role_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<User_Permission_Role_Aggregate_Fields>, Record<string, never>, WithTypename<User_Permission_Role_Min_Fields> | string>
  },
  user_permission_role_max_fields?: {
    name?: GraphCacheResolver<WithTypename<User_Permission_Role_Max_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  user_permission_role_min_fields?: {
    name?: GraphCacheResolver<WithTypename<User_Permission_Role_Min_Fields>, Record<string, never>, Scalars['String'] | string>
  },
  user_permission_role_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<User_Permission_Role_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<User_Permission_Role_Mutation_Response>, Record<string, never>, Array<WithTypename<User_Permission_Role> | string>>
  },
  user_permission_stddev_fields?: {
    id?: GraphCacheResolver<WithTypename<User_Permission_Stddev_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  user_permission_stddev_pop_fields?: {
    id?: GraphCacheResolver<WithTypename<User_Permission_Stddev_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  user_permission_stddev_samp_fields?: {
    id?: GraphCacheResolver<WithTypename<User_Permission_Stddev_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  user_permission_sum_fields?: {
    id?: GraphCacheResolver<WithTypename<User_Permission_Sum_Fields>, Record<string, never>, Scalars['Int'] | string>
  },
  user_permission_var_pop_fields?: {
    id?: GraphCacheResolver<WithTypename<User_Permission_Var_Pop_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  user_permission_var_samp_fields?: {
    id?: GraphCacheResolver<WithTypename<User_Permission_Var_Samp_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  user_permission_variance_fields?: {
    id?: GraphCacheResolver<WithTypename<User_Permission_Variance_Fields>, Record<string, never>, Scalars['Float'] | string>
  },
  users?: {
    clubs?: GraphCacheResolver<WithTypename<Users>, UsersClubsArgs, Array<WithTypename<Club> | string>>,
    clubs_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersClubs_AggregateArgs, WithTypename<Club_Aggregate> | string>,
    created_at?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['timestamptz'] | string>,
    exercises?: GraphCacheResolver<WithTypename<Users>, UsersExercisesArgs, Array<WithTypename<Exercise> | string>>,
    exercises_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersExercises_AggregateArgs, WithTypename<Exercise_Aggregate> | string>,
    first_name?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['String'] | string>,
    last_login?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['timestamptz'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Users>, Record<string, never>, Scalars['timestamptz'] | string>,
    user_permissions?: GraphCacheResolver<WithTypename<Users>, UsersUser_PermissionsArgs, Array<WithTypename<User_Permission> | string>>,
    user_permissions_aggregate?: GraphCacheResolver<WithTypename<Users>, UsersUser_Permissions_AggregateArgs, WithTypename<User_Permission_Aggregate> | string>
  },
  users_aggregate?: {
    aggregate?: GraphCacheResolver<WithTypename<Users_Aggregate>, Record<string, never>, WithTypename<Users_Aggregate_Fields> | string>,
    nodes?: GraphCacheResolver<WithTypename<Users_Aggregate>, Record<string, never>, Array<WithTypename<Users> | string>>
  },
  users_aggregate_fields?: {
    count?: GraphCacheResolver<WithTypename<Users_Aggregate_Fields>, Users_Aggregate_FieldsCountArgs, Scalars['Int'] | string>,
    max?: GraphCacheResolver<WithTypename<Users_Aggregate_Fields>, Record<string, never>, WithTypename<Users_Max_Fields> | string>,
    min?: GraphCacheResolver<WithTypename<Users_Aggregate_Fields>, Record<string, never>, WithTypename<Users_Min_Fields> | string>
  },
  users_max_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    first_name?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['String'] | string>,
    last_login?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Users_Max_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  users_min_fields?: {
    created_at?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    first_name?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    id?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['String'] | string>,
    last_login?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>,
    updated_at?: GraphCacheResolver<WithTypename<Users_Min_Fields>, Record<string, never>, Scalars['timestamptz'] | string>
  },
  users_mutation_response?: {
    affected_rows?: GraphCacheResolver<WithTypename<Users_Mutation_Response>, Record<string, never>, Scalars['Int'] | string>,
    returning?: GraphCacheResolver<WithTypename<Users_Mutation_Response>, Record<string, never>, Array<WithTypename<Users> | string>>
  }
};

export type GraphCacheOptimisticUpdaters = {
  delete_club?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_ClubArgs, Maybe<WithTypename<Club_Mutation_Response>>>,
  delete_club_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Club_By_PkArgs, Maybe<WithTypename<Club>>>,
  delete_editor_type?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Editor_TypeArgs, Maybe<WithTypename<Editor_Type_Mutation_Response>>>,
  delete_editor_type_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Editor_Type_By_PkArgs, Maybe<WithTypename<Editor_Type>>>,
  delete_enum_exercise_categories?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Enum_Exercise_CategoriesArgs, Maybe<WithTypename<Enum_Exercise_Categories_Mutation_Response>>>,
  delete_enum_exercise_categories_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Enum_Exercise_Categories_By_PkArgs, Maybe<WithTypename<Enum_Exercise_Categories>>>,
  delete_enum_languages?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Enum_LanguagesArgs, Maybe<WithTypename<Enum_Languages_Mutation_Response>>>,
  delete_enum_languages_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Enum_Languages_By_PkArgs, Maybe<WithTypename<Enum_Languages>>>,
  delete_enum_sport?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Enum_SportArgs, Maybe<WithTypename<Enum_Sport_Mutation_Response>>>,
  delete_enum_sport_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Enum_Sport_By_PkArgs, Maybe<WithTypename<Enum_Sport>>>,
  delete_exercise?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_ExerciseArgs, Maybe<WithTypename<Exercise_Mutation_Response>>>,
  delete_exercise_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_By_PkArgs, Maybe<WithTypename<Exercise>>>,
  delete_exercise_club_mn?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Club_MnArgs, Maybe<WithTypename<Exercise_Club_Mn_Mutation_Response>>>,
  delete_exercise_club_mn_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Club_Mn_By_PkArgs, Maybe<WithTypename<Exercise_Club_Mn>>>,
  delete_exercise_content_media?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Content_MediaArgs, Maybe<WithTypename<Exercise_Content_Media_Mutation_Response>>>,
  delete_exercise_content_media_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Content_Media_By_PkArgs, Maybe<WithTypename<Exercise_Content_Media>>>,
  delete_exercise_content_media_editor?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Content_Media_EditorArgs, Maybe<WithTypename<Exercise_Content_Media_Editor_Mutation_Response>>>,
  delete_exercise_content_media_editor_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Content_Media_Editor_By_PkArgs, Maybe<WithTypename<Exercise_Content_Media_Editor>>>,
  delete_exercise_content_media_mn?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Content_Media_MnArgs, Maybe<WithTypename<Exercise_Content_Media_Mn_Mutation_Response>>>,
  delete_exercise_content_media_mn_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Content_Media_Mn_By_PkArgs, Maybe<WithTypename<Exercise_Content_Media_Mn>>>,
  delete_exercise_content_media_type?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Content_Media_TypeArgs, Maybe<WithTypename<Exercise_Content_Media_Type_Mutation_Response>>>,
  delete_exercise_content_media_type_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Content_Media_Type_By_PkArgs, Maybe<WithTypename<Exercise_Content_Media_Type>>>,
  delete_exercise_taxonomy?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_TaxonomyArgs, Maybe<WithTypename<Exercise_Taxonomy_Mutation_Response>>>,
  delete_exercise_taxonomy_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Taxonomy_By_PkArgs, Maybe<WithTypename<Exercise_Taxonomy>>>,
  delete_exercise_taxonomy_mn?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Taxonomy_MnArgs, Maybe<WithTypename<Exercise_Taxonomy_Mn_Mutation_Response>>>,
  delete_exercise_taxonomy_mn_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Exercise_Taxonomy_Mn_By_PkArgs, Maybe<WithTypename<Exercise_Taxonomy_Mn>>>,
  delete_license?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_LicenseArgs, Maybe<WithTypename<License_Mutation_Response>>>,
  delete_license_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_License_By_PkArgs, Maybe<WithTypename<License>>>,
  delete_member?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_MemberArgs, Maybe<WithTypename<Member_Mutation_Response>>>,
  delete_member_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Member_By_PkArgs, Maybe<WithTypename<Member>>>,
  delete_member_group?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Member_GroupArgs, Maybe<WithTypename<Member_Group_Mutation_Response>>>,
  delete_member_group_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Member_Group_By_PkArgs, Maybe<WithTypename<Member_Group>>>,
  delete_member_group_mn?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Member_Group_MnArgs, Maybe<WithTypename<Member_Group_Mn_Mutation_Response>>>,
  delete_member_group_mn_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Member_Group_Mn_By_PkArgs, Maybe<WithTypename<Member_Group_Mn>>>,
  delete_payment?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_PaymentArgs, Maybe<WithTypename<Payment_Mutation_Response>>>,
  delete_payment_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Payment_By_PkArgs, Maybe<WithTypename<Payment>>>,
  delete_s3_file?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_S3_FileArgs, Maybe<WithTypename<S3_File_Mutation_Response>>>,
  delete_s3_file_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_S3_File_By_PkArgs, Maybe<WithTypename<S3_File>>>,
  delete_team?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_TeamArgs, Maybe<WithTypename<Team_Mutation_Response>>>,
  delete_team_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Team_By_PkArgs, Maybe<WithTypename<Team>>>,
  delete_user_permission?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_User_PermissionArgs, Maybe<WithTypename<User_Permission_Mutation_Response>>>,
  delete_user_permission_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_User_Permission_By_PkArgs, Maybe<WithTypename<User_Permission>>>,
  delete_user_permission_role?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_User_Permission_RoleArgs, Maybe<WithTypename<User_Permission_Role_Mutation_Response>>>,
  delete_user_permission_role_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_User_Permission_Role_By_PkArgs, Maybe<WithTypename<User_Permission_Role>>>,
  delete_users?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_UsersArgs, Maybe<WithTypename<Users_Mutation_Response>>>,
  delete_users_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootDelete_Users_By_PkArgs, Maybe<WithTypename<Users>>>,
  insert_club?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_ClubArgs, Maybe<WithTypename<Club_Mutation_Response>>>,
  insert_club_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Club_OneArgs, Maybe<WithTypename<Club>>>,
  insert_editor_type?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Editor_TypeArgs, Maybe<WithTypename<Editor_Type_Mutation_Response>>>,
  insert_editor_type_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Editor_Type_OneArgs, Maybe<WithTypename<Editor_Type>>>,
  insert_enum_exercise_categories?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Enum_Exercise_CategoriesArgs, Maybe<WithTypename<Enum_Exercise_Categories_Mutation_Response>>>,
  insert_enum_exercise_categories_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Enum_Exercise_Categories_OneArgs, Maybe<WithTypename<Enum_Exercise_Categories>>>,
  insert_enum_languages?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Enum_LanguagesArgs, Maybe<WithTypename<Enum_Languages_Mutation_Response>>>,
  insert_enum_languages_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Enum_Languages_OneArgs, Maybe<WithTypename<Enum_Languages>>>,
  insert_enum_sport?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Enum_SportArgs, Maybe<WithTypename<Enum_Sport_Mutation_Response>>>,
  insert_enum_sport_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Enum_Sport_OneArgs, Maybe<WithTypename<Enum_Sport>>>,
  insert_exercise?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_ExerciseArgs, Maybe<WithTypename<Exercise_Mutation_Response>>>,
  insert_exercise_club_mn?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Club_MnArgs, Maybe<WithTypename<Exercise_Club_Mn_Mutation_Response>>>,
  insert_exercise_club_mn_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Club_Mn_OneArgs, Maybe<WithTypename<Exercise_Club_Mn>>>,
  insert_exercise_content_media?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Content_MediaArgs, Maybe<WithTypename<Exercise_Content_Media_Mutation_Response>>>,
  insert_exercise_content_media_editor?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Content_Media_EditorArgs, Maybe<WithTypename<Exercise_Content_Media_Editor_Mutation_Response>>>,
  insert_exercise_content_media_editor_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Content_Media_Editor_OneArgs, Maybe<WithTypename<Exercise_Content_Media_Editor>>>,
  insert_exercise_content_media_mn?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Content_Media_MnArgs, Maybe<WithTypename<Exercise_Content_Media_Mn_Mutation_Response>>>,
  insert_exercise_content_media_mn_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Content_Media_Mn_OneArgs, Maybe<WithTypename<Exercise_Content_Media_Mn>>>,
  insert_exercise_content_media_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Content_Media_OneArgs, Maybe<WithTypename<Exercise_Content_Media>>>,
  insert_exercise_content_media_type?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Content_Media_TypeArgs, Maybe<WithTypename<Exercise_Content_Media_Type_Mutation_Response>>>,
  insert_exercise_content_media_type_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Content_Media_Type_OneArgs, Maybe<WithTypename<Exercise_Content_Media_Type>>>,
  insert_exercise_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_OneArgs, Maybe<WithTypename<Exercise>>>,
  insert_exercise_taxonomy?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_TaxonomyArgs, Maybe<WithTypename<Exercise_Taxonomy_Mutation_Response>>>,
  insert_exercise_taxonomy_mn?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Taxonomy_MnArgs, Maybe<WithTypename<Exercise_Taxonomy_Mn_Mutation_Response>>>,
  insert_exercise_taxonomy_mn_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Taxonomy_Mn_OneArgs, Maybe<WithTypename<Exercise_Taxonomy_Mn>>>,
  insert_exercise_taxonomy_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Exercise_Taxonomy_OneArgs, Maybe<WithTypename<Exercise_Taxonomy>>>,
  insert_license?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_LicenseArgs, Maybe<WithTypename<License_Mutation_Response>>>,
  insert_license_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_License_OneArgs, Maybe<WithTypename<License>>>,
  insert_member?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_MemberArgs, Maybe<WithTypename<Member_Mutation_Response>>>,
  insert_member_group?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Member_GroupArgs, Maybe<WithTypename<Member_Group_Mutation_Response>>>,
  insert_member_group_mn?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Member_Group_MnArgs, Maybe<WithTypename<Member_Group_Mn_Mutation_Response>>>,
  insert_member_group_mn_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Member_Group_Mn_OneArgs, Maybe<WithTypename<Member_Group_Mn>>>,
  insert_member_group_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Member_Group_OneArgs, Maybe<WithTypename<Member_Group>>>,
  insert_member_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Member_OneArgs, Maybe<WithTypename<Member>>>,
  insert_payment?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_PaymentArgs, Maybe<WithTypename<Payment_Mutation_Response>>>,
  insert_payment_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Payment_OneArgs, Maybe<WithTypename<Payment>>>,
  insert_s3_file?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_S3_FileArgs, Maybe<WithTypename<S3_File_Mutation_Response>>>,
  insert_s3_file_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_S3_File_OneArgs, Maybe<WithTypename<S3_File>>>,
  insert_team?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_TeamArgs, Maybe<WithTypename<Team_Mutation_Response>>>,
  insert_team_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Team_OneArgs, Maybe<WithTypename<Team>>>,
  insert_user_permission?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_User_PermissionArgs, Maybe<WithTypename<User_Permission_Mutation_Response>>>,
  insert_user_permission_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_User_Permission_OneArgs, Maybe<WithTypename<User_Permission>>>,
  insert_user_permission_role?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_User_Permission_RoleArgs, Maybe<WithTypename<User_Permission_Role_Mutation_Response>>>,
  insert_user_permission_role_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_User_Permission_Role_OneArgs, Maybe<WithTypename<User_Permission_Role>>>,
  insert_users?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_UsersArgs, Maybe<WithTypename<Users_Mutation_Response>>>,
  insert_users_one?: GraphCacheOptimisticMutationResolver<Mutation_RootInsert_Users_OneArgs, Maybe<WithTypename<Users>>>,
  update_club?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_ClubArgs, Maybe<WithTypename<Club_Mutation_Response>>>,
  update_club_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Club_By_PkArgs, Maybe<WithTypename<Club>>>,
  update_editor_type?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Editor_TypeArgs, Maybe<WithTypename<Editor_Type_Mutation_Response>>>,
  update_editor_type_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Editor_Type_By_PkArgs, Maybe<WithTypename<Editor_Type>>>,
  update_enum_exercise_categories?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Enum_Exercise_CategoriesArgs, Maybe<WithTypename<Enum_Exercise_Categories_Mutation_Response>>>,
  update_enum_exercise_categories_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Enum_Exercise_Categories_By_PkArgs, Maybe<WithTypename<Enum_Exercise_Categories>>>,
  update_enum_languages?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Enum_LanguagesArgs, Maybe<WithTypename<Enum_Languages_Mutation_Response>>>,
  update_enum_languages_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Enum_Languages_By_PkArgs, Maybe<WithTypename<Enum_Languages>>>,
  update_enum_sport?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Enum_SportArgs, Maybe<WithTypename<Enum_Sport_Mutation_Response>>>,
  update_enum_sport_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Enum_Sport_By_PkArgs, Maybe<WithTypename<Enum_Sport>>>,
  update_exercise?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_ExerciseArgs, Maybe<WithTypename<Exercise_Mutation_Response>>>,
  update_exercise_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_By_PkArgs, Maybe<WithTypename<Exercise>>>,
  update_exercise_club_mn?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Club_MnArgs, Maybe<WithTypename<Exercise_Club_Mn_Mutation_Response>>>,
  update_exercise_club_mn_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Club_Mn_By_PkArgs, Maybe<WithTypename<Exercise_Club_Mn>>>,
  update_exercise_content_media?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Content_MediaArgs, Maybe<WithTypename<Exercise_Content_Media_Mutation_Response>>>,
  update_exercise_content_media_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Content_Media_By_PkArgs, Maybe<WithTypename<Exercise_Content_Media>>>,
  update_exercise_content_media_editor?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Content_Media_EditorArgs, Maybe<WithTypename<Exercise_Content_Media_Editor_Mutation_Response>>>,
  update_exercise_content_media_editor_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Content_Media_Editor_By_PkArgs, Maybe<WithTypename<Exercise_Content_Media_Editor>>>,
  update_exercise_content_media_mn?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Content_Media_MnArgs, Maybe<WithTypename<Exercise_Content_Media_Mn_Mutation_Response>>>,
  update_exercise_content_media_mn_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Content_Media_Mn_By_PkArgs, Maybe<WithTypename<Exercise_Content_Media_Mn>>>,
  update_exercise_content_media_type?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Content_Media_TypeArgs, Maybe<WithTypename<Exercise_Content_Media_Type_Mutation_Response>>>,
  update_exercise_content_media_type_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Content_Media_Type_By_PkArgs, Maybe<WithTypename<Exercise_Content_Media_Type>>>,
  update_exercise_taxonomy?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_TaxonomyArgs, Maybe<WithTypename<Exercise_Taxonomy_Mutation_Response>>>,
  update_exercise_taxonomy_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Taxonomy_By_PkArgs, Maybe<WithTypename<Exercise_Taxonomy>>>,
  update_exercise_taxonomy_mn?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Taxonomy_MnArgs, Maybe<WithTypename<Exercise_Taxonomy_Mn_Mutation_Response>>>,
  update_exercise_taxonomy_mn_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Exercise_Taxonomy_Mn_By_PkArgs, Maybe<WithTypename<Exercise_Taxonomy_Mn>>>,
  update_license?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_LicenseArgs, Maybe<WithTypename<License_Mutation_Response>>>,
  update_license_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_License_By_PkArgs, Maybe<WithTypename<License>>>,
  update_member?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_MemberArgs, Maybe<WithTypename<Member_Mutation_Response>>>,
  update_member_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Member_By_PkArgs, Maybe<WithTypename<Member>>>,
  update_member_group?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Member_GroupArgs, Maybe<WithTypename<Member_Group_Mutation_Response>>>,
  update_member_group_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Member_Group_By_PkArgs, Maybe<WithTypename<Member_Group>>>,
  update_member_group_mn?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Member_Group_MnArgs, Maybe<WithTypename<Member_Group_Mn_Mutation_Response>>>,
  update_member_group_mn_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Member_Group_Mn_By_PkArgs, Maybe<WithTypename<Member_Group_Mn>>>,
  update_payment?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_PaymentArgs, Maybe<WithTypename<Payment_Mutation_Response>>>,
  update_payment_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Payment_By_PkArgs, Maybe<WithTypename<Payment>>>,
  update_s3_file?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_S3_FileArgs, Maybe<WithTypename<S3_File_Mutation_Response>>>,
  update_s3_file_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_S3_File_By_PkArgs, Maybe<WithTypename<S3_File>>>,
  update_team?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_TeamArgs, Maybe<WithTypename<Team_Mutation_Response>>>,
  update_team_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Team_By_PkArgs, Maybe<WithTypename<Team>>>,
  update_user_permission?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_User_PermissionArgs, Maybe<WithTypename<User_Permission_Mutation_Response>>>,
  update_user_permission_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_User_Permission_By_PkArgs, Maybe<WithTypename<User_Permission>>>,
  update_user_permission_role?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_User_Permission_RoleArgs, Maybe<WithTypename<User_Permission_Role_Mutation_Response>>>,
  update_user_permission_role_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_User_Permission_Role_By_PkArgs, Maybe<WithTypename<User_Permission_Role>>>,
  update_users?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_UsersArgs, Maybe<WithTypename<Users_Mutation_Response>>>,
  update_users_by_pk?: GraphCacheOptimisticMutationResolver<Mutation_RootUpdate_Users_By_PkArgs, Maybe<WithTypename<Users>>>
};

export type GraphCacheUpdaters = {
  Mutation?: {
    delete_club?: GraphCacheUpdateResolver<{ delete_club: Maybe<WithTypename<Club_Mutation_Response>> }, Mutation_RootDelete_ClubArgs>,
    delete_club_by_pk?: GraphCacheUpdateResolver<{ delete_club_by_pk: Maybe<WithTypename<Club>> }, Mutation_RootDelete_Club_By_PkArgs>,
    delete_editor_type?: GraphCacheUpdateResolver<{ delete_editor_type: Maybe<WithTypename<Editor_Type_Mutation_Response>> }, Mutation_RootDelete_Editor_TypeArgs>,
    delete_editor_type_by_pk?: GraphCacheUpdateResolver<{ delete_editor_type_by_pk: Maybe<WithTypename<Editor_Type>> }, Mutation_RootDelete_Editor_Type_By_PkArgs>,
    delete_enum_exercise_categories?: GraphCacheUpdateResolver<{ delete_enum_exercise_categories: Maybe<WithTypename<Enum_Exercise_Categories_Mutation_Response>> }, Mutation_RootDelete_Enum_Exercise_CategoriesArgs>,
    delete_enum_exercise_categories_by_pk?: GraphCacheUpdateResolver<{ delete_enum_exercise_categories_by_pk: Maybe<WithTypename<Enum_Exercise_Categories>> }, Mutation_RootDelete_Enum_Exercise_Categories_By_PkArgs>,
    delete_enum_languages?: GraphCacheUpdateResolver<{ delete_enum_languages: Maybe<WithTypename<Enum_Languages_Mutation_Response>> }, Mutation_RootDelete_Enum_LanguagesArgs>,
    delete_enum_languages_by_pk?: GraphCacheUpdateResolver<{ delete_enum_languages_by_pk: Maybe<WithTypename<Enum_Languages>> }, Mutation_RootDelete_Enum_Languages_By_PkArgs>,
    delete_enum_sport?: GraphCacheUpdateResolver<{ delete_enum_sport: Maybe<WithTypename<Enum_Sport_Mutation_Response>> }, Mutation_RootDelete_Enum_SportArgs>,
    delete_enum_sport_by_pk?: GraphCacheUpdateResolver<{ delete_enum_sport_by_pk: Maybe<WithTypename<Enum_Sport>> }, Mutation_RootDelete_Enum_Sport_By_PkArgs>,
    delete_exercise?: GraphCacheUpdateResolver<{ delete_exercise: Maybe<WithTypename<Exercise_Mutation_Response>> }, Mutation_RootDelete_ExerciseArgs>,
    delete_exercise_by_pk?: GraphCacheUpdateResolver<{ delete_exercise_by_pk: Maybe<WithTypename<Exercise>> }, Mutation_RootDelete_Exercise_By_PkArgs>,
    delete_exercise_club_mn?: GraphCacheUpdateResolver<{ delete_exercise_club_mn: Maybe<WithTypename<Exercise_Club_Mn_Mutation_Response>> }, Mutation_RootDelete_Exercise_Club_MnArgs>,
    delete_exercise_club_mn_by_pk?: GraphCacheUpdateResolver<{ delete_exercise_club_mn_by_pk: Maybe<WithTypename<Exercise_Club_Mn>> }, Mutation_RootDelete_Exercise_Club_Mn_By_PkArgs>,
    delete_exercise_content_media?: GraphCacheUpdateResolver<{ delete_exercise_content_media: Maybe<WithTypename<Exercise_Content_Media_Mutation_Response>> }, Mutation_RootDelete_Exercise_Content_MediaArgs>,
    delete_exercise_content_media_by_pk?: GraphCacheUpdateResolver<{ delete_exercise_content_media_by_pk: Maybe<WithTypename<Exercise_Content_Media>> }, Mutation_RootDelete_Exercise_Content_Media_By_PkArgs>,
    delete_exercise_content_media_editor?: GraphCacheUpdateResolver<{ delete_exercise_content_media_editor: Maybe<WithTypename<Exercise_Content_Media_Editor_Mutation_Response>> }, Mutation_RootDelete_Exercise_Content_Media_EditorArgs>,
    delete_exercise_content_media_editor_by_pk?: GraphCacheUpdateResolver<{ delete_exercise_content_media_editor_by_pk: Maybe<WithTypename<Exercise_Content_Media_Editor>> }, Mutation_RootDelete_Exercise_Content_Media_Editor_By_PkArgs>,
    delete_exercise_content_media_mn?: GraphCacheUpdateResolver<{ delete_exercise_content_media_mn: Maybe<WithTypename<Exercise_Content_Media_Mn_Mutation_Response>> }, Mutation_RootDelete_Exercise_Content_Media_MnArgs>,
    delete_exercise_content_media_mn_by_pk?: GraphCacheUpdateResolver<{ delete_exercise_content_media_mn_by_pk: Maybe<WithTypename<Exercise_Content_Media_Mn>> }, Mutation_RootDelete_Exercise_Content_Media_Mn_By_PkArgs>,
    delete_exercise_content_media_type?: GraphCacheUpdateResolver<{ delete_exercise_content_media_type: Maybe<WithTypename<Exercise_Content_Media_Type_Mutation_Response>> }, Mutation_RootDelete_Exercise_Content_Media_TypeArgs>,
    delete_exercise_content_media_type_by_pk?: GraphCacheUpdateResolver<{ delete_exercise_content_media_type_by_pk: Maybe<WithTypename<Exercise_Content_Media_Type>> }, Mutation_RootDelete_Exercise_Content_Media_Type_By_PkArgs>,
    delete_exercise_taxonomy?: GraphCacheUpdateResolver<{ delete_exercise_taxonomy: Maybe<WithTypename<Exercise_Taxonomy_Mutation_Response>> }, Mutation_RootDelete_Exercise_TaxonomyArgs>,
    delete_exercise_taxonomy_by_pk?: GraphCacheUpdateResolver<{ delete_exercise_taxonomy_by_pk: Maybe<WithTypename<Exercise_Taxonomy>> }, Mutation_RootDelete_Exercise_Taxonomy_By_PkArgs>,
    delete_exercise_taxonomy_mn?: GraphCacheUpdateResolver<{ delete_exercise_taxonomy_mn: Maybe<WithTypename<Exercise_Taxonomy_Mn_Mutation_Response>> }, Mutation_RootDelete_Exercise_Taxonomy_MnArgs>,
    delete_exercise_taxonomy_mn_by_pk?: GraphCacheUpdateResolver<{ delete_exercise_taxonomy_mn_by_pk: Maybe<WithTypename<Exercise_Taxonomy_Mn>> }, Mutation_RootDelete_Exercise_Taxonomy_Mn_By_PkArgs>,
    delete_license?: GraphCacheUpdateResolver<{ delete_license: Maybe<WithTypename<License_Mutation_Response>> }, Mutation_RootDelete_LicenseArgs>,
    delete_license_by_pk?: GraphCacheUpdateResolver<{ delete_license_by_pk: Maybe<WithTypename<License>> }, Mutation_RootDelete_License_By_PkArgs>,
    delete_member?: GraphCacheUpdateResolver<{ delete_member: Maybe<WithTypename<Member_Mutation_Response>> }, Mutation_RootDelete_MemberArgs>,
    delete_member_by_pk?: GraphCacheUpdateResolver<{ delete_member_by_pk: Maybe<WithTypename<Member>> }, Mutation_RootDelete_Member_By_PkArgs>,
    delete_member_group?: GraphCacheUpdateResolver<{ delete_member_group: Maybe<WithTypename<Member_Group_Mutation_Response>> }, Mutation_RootDelete_Member_GroupArgs>,
    delete_member_group_by_pk?: GraphCacheUpdateResolver<{ delete_member_group_by_pk: Maybe<WithTypename<Member_Group>> }, Mutation_RootDelete_Member_Group_By_PkArgs>,
    delete_member_group_mn?: GraphCacheUpdateResolver<{ delete_member_group_mn: Maybe<WithTypename<Member_Group_Mn_Mutation_Response>> }, Mutation_RootDelete_Member_Group_MnArgs>,
    delete_member_group_mn_by_pk?: GraphCacheUpdateResolver<{ delete_member_group_mn_by_pk: Maybe<WithTypename<Member_Group_Mn>> }, Mutation_RootDelete_Member_Group_Mn_By_PkArgs>,
    delete_payment?: GraphCacheUpdateResolver<{ delete_payment: Maybe<WithTypename<Payment_Mutation_Response>> }, Mutation_RootDelete_PaymentArgs>,
    delete_payment_by_pk?: GraphCacheUpdateResolver<{ delete_payment_by_pk: Maybe<WithTypename<Payment>> }, Mutation_RootDelete_Payment_By_PkArgs>,
    delete_s3_file?: GraphCacheUpdateResolver<{ delete_s3_file: Maybe<WithTypename<S3_File_Mutation_Response>> }, Mutation_RootDelete_S3_FileArgs>,
    delete_s3_file_by_pk?: GraphCacheUpdateResolver<{ delete_s3_file_by_pk: Maybe<WithTypename<S3_File>> }, Mutation_RootDelete_S3_File_By_PkArgs>,
    delete_team?: GraphCacheUpdateResolver<{ delete_team: Maybe<WithTypename<Team_Mutation_Response>> }, Mutation_RootDelete_TeamArgs>,
    delete_team_by_pk?: GraphCacheUpdateResolver<{ delete_team_by_pk: Maybe<WithTypename<Team>> }, Mutation_RootDelete_Team_By_PkArgs>,
    delete_user_permission?: GraphCacheUpdateResolver<{ delete_user_permission: Maybe<WithTypename<User_Permission_Mutation_Response>> }, Mutation_RootDelete_User_PermissionArgs>,
    delete_user_permission_by_pk?: GraphCacheUpdateResolver<{ delete_user_permission_by_pk: Maybe<WithTypename<User_Permission>> }, Mutation_RootDelete_User_Permission_By_PkArgs>,
    delete_user_permission_role?: GraphCacheUpdateResolver<{ delete_user_permission_role: Maybe<WithTypename<User_Permission_Role_Mutation_Response>> }, Mutation_RootDelete_User_Permission_RoleArgs>,
    delete_user_permission_role_by_pk?: GraphCacheUpdateResolver<{ delete_user_permission_role_by_pk: Maybe<WithTypename<User_Permission_Role>> }, Mutation_RootDelete_User_Permission_Role_By_PkArgs>,
    delete_users?: GraphCacheUpdateResolver<{ delete_users: Maybe<WithTypename<Users_Mutation_Response>> }, Mutation_RootDelete_UsersArgs>,
    delete_users_by_pk?: GraphCacheUpdateResolver<{ delete_users_by_pk: Maybe<WithTypename<Users>> }, Mutation_RootDelete_Users_By_PkArgs>,
    insert_club?: GraphCacheUpdateResolver<{ insert_club: Maybe<WithTypename<Club_Mutation_Response>> }, Mutation_RootInsert_ClubArgs>,
    insert_club_one?: GraphCacheUpdateResolver<{ insert_club_one: Maybe<WithTypename<Club>> }, Mutation_RootInsert_Club_OneArgs>,
    insert_editor_type?: GraphCacheUpdateResolver<{ insert_editor_type: Maybe<WithTypename<Editor_Type_Mutation_Response>> }, Mutation_RootInsert_Editor_TypeArgs>,
    insert_editor_type_one?: GraphCacheUpdateResolver<{ insert_editor_type_one: Maybe<WithTypename<Editor_Type>> }, Mutation_RootInsert_Editor_Type_OneArgs>,
    insert_enum_exercise_categories?: GraphCacheUpdateResolver<{ insert_enum_exercise_categories: Maybe<WithTypename<Enum_Exercise_Categories_Mutation_Response>> }, Mutation_RootInsert_Enum_Exercise_CategoriesArgs>,
    insert_enum_exercise_categories_one?: GraphCacheUpdateResolver<{ insert_enum_exercise_categories_one: Maybe<WithTypename<Enum_Exercise_Categories>> }, Mutation_RootInsert_Enum_Exercise_Categories_OneArgs>,
    insert_enum_languages?: GraphCacheUpdateResolver<{ insert_enum_languages: Maybe<WithTypename<Enum_Languages_Mutation_Response>> }, Mutation_RootInsert_Enum_LanguagesArgs>,
    insert_enum_languages_one?: GraphCacheUpdateResolver<{ insert_enum_languages_one: Maybe<WithTypename<Enum_Languages>> }, Mutation_RootInsert_Enum_Languages_OneArgs>,
    insert_enum_sport?: GraphCacheUpdateResolver<{ insert_enum_sport: Maybe<WithTypename<Enum_Sport_Mutation_Response>> }, Mutation_RootInsert_Enum_SportArgs>,
    insert_enum_sport_one?: GraphCacheUpdateResolver<{ insert_enum_sport_one: Maybe<WithTypename<Enum_Sport>> }, Mutation_RootInsert_Enum_Sport_OneArgs>,
    insert_exercise?: GraphCacheUpdateResolver<{ insert_exercise: Maybe<WithTypename<Exercise_Mutation_Response>> }, Mutation_RootInsert_ExerciseArgs>,
    insert_exercise_club_mn?: GraphCacheUpdateResolver<{ insert_exercise_club_mn: Maybe<WithTypename<Exercise_Club_Mn_Mutation_Response>> }, Mutation_RootInsert_Exercise_Club_MnArgs>,
    insert_exercise_club_mn_one?: GraphCacheUpdateResolver<{ insert_exercise_club_mn_one: Maybe<WithTypename<Exercise_Club_Mn>> }, Mutation_RootInsert_Exercise_Club_Mn_OneArgs>,
    insert_exercise_content_media?: GraphCacheUpdateResolver<{ insert_exercise_content_media: Maybe<WithTypename<Exercise_Content_Media_Mutation_Response>> }, Mutation_RootInsert_Exercise_Content_MediaArgs>,
    insert_exercise_content_media_editor?: GraphCacheUpdateResolver<{ insert_exercise_content_media_editor: Maybe<WithTypename<Exercise_Content_Media_Editor_Mutation_Response>> }, Mutation_RootInsert_Exercise_Content_Media_EditorArgs>,
    insert_exercise_content_media_editor_one?: GraphCacheUpdateResolver<{ insert_exercise_content_media_editor_one: Maybe<WithTypename<Exercise_Content_Media_Editor>> }, Mutation_RootInsert_Exercise_Content_Media_Editor_OneArgs>,
    insert_exercise_content_media_mn?: GraphCacheUpdateResolver<{ insert_exercise_content_media_mn: Maybe<WithTypename<Exercise_Content_Media_Mn_Mutation_Response>> }, Mutation_RootInsert_Exercise_Content_Media_MnArgs>,
    insert_exercise_content_media_mn_one?: GraphCacheUpdateResolver<{ insert_exercise_content_media_mn_one: Maybe<WithTypename<Exercise_Content_Media_Mn>> }, Mutation_RootInsert_Exercise_Content_Media_Mn_OneArgs>,
    insert_exercise_content_media_one?: GraphCacheUpdateResolver<{ insert_exercise_content_media_one: Maybe<WithTypename<Exercise_Content_Media>> }, Mutation_RootInsert_Exercise_Content_Media_OneArgs>,
    insert_exercise_content_media_type?: GraphCacheUpdateResolver<{ insert_exercise_content_media_type: Maybe<WithTypename<Exercise_Content_Media_Type_Mutation_Response>> }, Mutation_RootInsert_Exercise_Content_Media_TypeArgs>,
    insert_exercise_content_media_type_one?: GraphCacheUpdateResolver<{ insert_exercise_content_media_type_one: Maybe<WithTypename<Exercise_Content_Media_Type>> }, Mutation_RootInsert_Exercise_Content_Media_Type_OneArgs>,
    insert_exercise_one?: GraphCacheUpdateResolver<{ insert_exercise_one: Maybe<WithTypename<Exercise>> }, Mutation_RootInsert_Exercise_OneArgs>,
    insert_exercise_taxonomy?: GraphCacheUpdateResolver<{ insert_exercise_taxonomy: Maybe<WithTypename<Exercise_Taxonomy_Mutation_Response>> }, Mutation_RootInsert_Exercise_TaxonomyArgs>,
    insert_exercise_taxonomy_mn?: GraphCacheUpdateResolver<{ insert_exercise_taxonomy_mn: Maybe<WithTypename<Exercise_Taxonomy_Mn_Mutation_Response>> }, Mutation_RootInsert_Exercise_Taxonomy_MnArgs>,
    insert_exercise_taxonomy_mn_one?: GraphCacheUpdateResolver<{ insert_exercise_taxonomy_mn_one: Maybe<WithTypename<Exercise_Taxonomy_Mn>> }, Mutation_RootInsert_Exercise_Taxonomy_Mn_OneArgs>,
    insert_exercise_taxonomy_one?: GraphCacheUpdateResolver<{ insert_exercise_taxonomy_one: Maybe<WithTypename<Exercise_Taxonomy>> }, Mutation_RootInsert_Exercise_Taxonomy_OneArgs>,
    insert_license?: GraphCacheUpdateResolver<{ insert_license: Maybe<WithTypename<License_Mutation_Response>> }, Mutation_RootInsert_LicenseArgs>,
    insert_license_one?: GraphCacheUpdateResolver<{ insert_license_one: Maybe<WithTypename<License>> }, Mutation_RootInsert_License_OneArgs>,
    insert_member?: GraphCacheUpdateResolver<{ insert_member: Maybe<WithTypename<Member_Mutation_Response>> }, Mutation_RootInsert_MemberArgs>,
    insert_member_group?: GraphCacheUpdateResolver<{ insert_member_group: Maybe<WithTypename<Member_Group_Mutation_Response>> }, Mutation_RootInsert_Member_GroupArgs>,
    insert_member_group_mn?: GraphCacheUpdateResolver<{ insert_member_group_mn: Maybe<WithTypename<Member_Group_Mn_Mutation_Response>> }, Mutation_RootInsert_Member_Group_MnArgs>,
    insert_member_group_mn_one?: GraphCacheUpdateResolver<{ insert_member_group_mn_one: Maybe<WithTypename<Member_Group_Mn>> }, Mutation_RootInsert_Member_Group_Mn_OneArgs>,
    insert_member_group_one?: GraphCacheUpdateResolver<{ insert_member_group_one: Maybe<WithTypename<Member_Group>> }, Mutation_RootInsert_Member_Group_OneArgs>,
    insert_member_one?: GraphCacheUpdateResolver<{ insert_member_one: Maybe<WithTypename<Member>> }, Mutation_RootInsert_Member_OneArgs>,
    insert_payment?: GraphCacheUpdateResolver<{ insert_payment: Maybe<WithTypename<Payment_Mutation_Response>> }, Mutation_RootInsert_PaymentArgs>,
    insert_payment_one?: GraphCacheUpdateResolver<{ insert_payment_one: Maybe<WithTypename<Payment>> }, Mutation_RootInsert_Payment_OneArgs>,
    insert_s3_file?: GraphCacheUpdateResolver<{ insert_s3_file: Maybe<WithTypename<S3_File_Mutation_Response>> }, Mutation_RootInsert_S3_FileArgs>,
    insert_s3_file_one?: GraphCacheUpdateResolver<{ insert_s3_file_one: Maybe<WithTypename<S3_File>> }, Mutation_RootInsert_S3_File_OneArgs>,
    insert_team?: GraphCacheUpdateResolver<{ insert_team: Maybe<WithTypename<Team_Mutation_Response>> }, Mutation_RootInsert_TeamArgs>,
    insert_team_one?: GraphCacheUpdateResolver<{ insert_team_one: Maybe<WithTypename<Team>> }, Mutation_RootInsert_Team_OneArgs>,
    insert_user_permission?: GraphCacheUpdateResolver<{ insert_user_permission: Maybe<WithTypename<User_Permission_Mutation_Response>> }, Mutation_RootInsert_User_PermissionArgs>,
    insert_user_permission_one?: GraphCacheUpdateResolver<{ insert_user_permission_one: Maybe<WithTypename<User_Permission>> }, Mutation_RootInsert_User_Permission_OneArgs>,
    insert_user_permission_role?: GraphCacheUpdateResolver<{ insert_user_permission_role: Maybe<WithTypename<User_Permission_Role_Mutation_Response>> }, Mutation_RootInsert_User_Permission_RoleArgs>,
    insert_user_permission_role_one?: GraphCacheUpdateResolver<{ insert_user_permission_role_one: Maybe<WithTypename<User_Permission_Role>> }, Mutation_RootInsert_User_Permission_Role_OneArgs>,
    insert_users?: GraphCacheUpdateResolver<{ insert_users: Maybe<WithTypename<Users_Mutation_Response>> }, Mutation_RootInsert_UsersArgs>,
    insert_users_one?: GraphCacheUpdateResolver<{ insert_users_one: Maybe<WithTypename<Users>> }, Mutation_RootInsert_Users_OneArgs>,
    update_club?: GraphCacheUpdateResolver<{ update_club: Maybe<WithTypename<Club_Mutation_Response>> }, Mutation_RootUpdate_ClubArgs>,
    update_club_by_pk?: GraphCacheUpdateResolver<{ update_club_by_pk: Maybe<WithTypename<Club>> }, Mutation_RootUpdate_Club_By_PkArgs>,
    update_editor_type?: GraphCacheUpdateResolver<{ update_editor_type: Maybe<WithTypename<Editor_Type_Mutation_Response>> }, Mutation_RootUpdate_Editor_TypeArgs>,
    update_editor_type_by_pk?: GraphCacheUpdateResolver<{ update_editor_type_by_pk: Maybe<WithTypename<Editor_Type>> }, Mutation_RootUpdate_Editor_Type_By_PkArgs>,
    update_enum_exercise_categories?: GraphCacheUpdateResolver<{ update_enum_exercise_categories: Maybe<WithTypename<Enum_Exercise_Categories_Mutation_Response>> }, Mutation_RootUpdate_Enum_Exercise_CategoriesArgs>,
    update_enum_exercise_categories_by_pk?: GraphCacheUpdateResolver<{ update_enum_exercise_categories_by_pk: Maybe<WithTypename<Enum_Exercise_Categories>> }, Mutation_RootUpdate_Enum_Exercise_Categories_By_PkArgs>,
    update_enum_languages?: GraphCacheUpdateResolver<{ update_enum_languages: Maybe<WithTypename<Enum_Languages_Mutation_Response>> }, Mutation_RootUpdate_Enum_LanguagesArgs>,
    update_enum_languages_by_pk?: GraphCacheUpdateResolver<{ update_enum_languages_by_pk: Maybe<WithTypename<Enum_Languages>> }, Mutation_RootUpdate_Enum_Languages_By_PkArgs>,
    update_enum_sport?: GraphCacheUpdateResolver<{ update_enum_sport: Maybe<WithTypename<Enum_Sport_Mutation_Response>> }, Mutation_RootUpdate_Enum_SportArgs>,
    update_enum_sport_by_pk?: GraphCacheUpdateResolver<{ update_enum_sport_by_pk: Maybe<WithTypename<Enum_Sport>> }, Mutation_RootUpdate_Enum_Sport_By_PkArgs>,
    update_exercise?: GraphCacheUpdateResolver<{ update_exercise: Maybe<WithTypename<Exercise_Mutation_Response>> }, Mutation_RootUpdate_ExerciseArgs>,
    update_exercise_by_pk?: GraphCacheUpdateResolver<{ update_exercise_by_pk: Maybe<WithTypename<Exercise>> }, Mutation_RootUpdate_Exercise_By_PkArgs>,
    update_exercise_club_mn?: GraphCacheUpdateResolver<{ update_exercise_club_mn: Maybe<WithTypename<Exercise_Club_Mn_Mutation_Response>> }, Mutation_RootUpdate_Exercise_Club_MnArgs>,
    update_exercise_club_mn_by_pk?: GraphCacheUpdateResolver<{ update_exercise_club_mn_by_pk: Maybe<WithTypename<Exercise_Club_Mn>> }, Mutation_RootUpdate_Exercise_Club_Mn_By_PkArgs>,
    update_exercise_content_media?: GraphCacheUpdateResolver<{ update_exercise_content_media: Maybe<WithTypename<Exercise_Content_Media_Mutation_Response>> }, Mutation_RootUpdate_Exercise_Content_MediaArgs>,
    update_exercise_content_media_by_pk?: GraphCacheUpdateResolver<{ update_exercise_content_media_by_pk: Maybe<WithTypename<Exercise_Content_Media>> }, Mutation_RootUpdate_Exercise_Content_Media_By_PkArgs>,
    update_exercise_content_media_editor?: GraphCacheUpdateResolver<{ update_exercise_content_media_editor: Maybe<WithTypename<Exercise_Content_Media_Editor_Mutation_Response>> }, Mutation_RootUpdate_Exercise_Content_Media_EditorArgs>,
    update_exercise_content_media_editor_by_pk?: GraphCacheUpdateResolver<{ update_exercise_content_media_editor_by_pk: Maybe<WithTypename<Exercise_Content_Media_Editor>> }, Mutation_RootUpdate_Exercise_Content_Media_Editor_By_PkArgs>,
    update_exercise_content_media_mn?: GraphCacheUpdateResolver<{ update_exercise_content_media_mn: Maybe<WithTypename<Exercise_Content_Media_Mn_Mutation_Response>> }, Mutation_RootUpdate_Exercise_Content_Media_MnArgs>,
    update_exercise_content_media_mn_by_pk?: GraphCacheUpdateResolver<{ update_exercise_content_media_mn_by_pk: Maybe<WithTypename<Exercise_Content_Media_Mn>> }, Mutation_RootUpdate_Exercise_Content_Media_Mn_By_PkArgs>,
    update_exercise_content_media_type?: GraphCacheUpdateResolver<{ update_exercise_content_media_type: Maybe<WithTypename<Exercise_Content_Media_Type_Mutation_Response>> }, Mutation_RootUpdate_Exercise_Content_Media_TypeArgs>,
    update_exercise_content_media_type_by_pk?: GraphCacheUpdateResolver<{ update_exercise_content_media_type_by_pk: Maybe<WithTypename<Exercise_Content_Media_Type>> }, Mutation_RootUpdate_Exercise_Content_Media_Type_By_PkArgs>,
    update_exercise_taxonomy?: GraphCacheUpdateResolver<{ update_exercise_taxonomy: Maybe<WithTypename<Exercise_Taxonomy_Mutation_Response>> }, Mutation_RootUpdate_Exercise_TaxonomyArgs>,
    update_exercise_taxonomy_by_pk?: GraphCacheUpdateResolver<{ update_exercise_taxonomy_by_pk: Maybe<WithTypename<Exercise_Taxonomy>> }, Mutation_RootUpdate_Exercise_Taxonomy_By_PkArgs>,
    update_exercise_taxonomy_mn?: GraphCacheUpdateResolver<{ update_exercise_taxonomy_mn: Maybe<WithTypename<Exercise_Taxonomy_Mn_Mutation_Response>> }, Mutation_RootUpdate_Exercise_Taxonomy_MnArgs>,
    update_exercise_taxonomy_mn_by_pk?: GraphCacheUpdateResolver<{ update_exercise_taxonomy_mn_by_pk: Maybe<WithTypename<Exercise_Taxonomy_Mn>> }, Mutation_RootUpdate_Exercise_Taxonomy_Mn_By_PkArgs>,
    update_license?: GraphCacheUpdateResolver<{ update_license: Maybe<WithTypename<License_Mutation_Response>> }, Mutation_RootUpdate_LicenseArgs>,
    update_license_by_pk?: GraphCacheUpdateResolver<{ update_license_by_pk: Maybe<WithTypename<License>> }, Mutation_RootUpdate_License_By_PkArgs>,
    update_member?: GraphCacheUpdateResolver<{ update_member: Maybe<WithTypename<Member_Mutation_Response>> }, Mutation_RootUpdate_MemberArgs>,
    update_member_by_pk?: GraphCacheUpdateResolver<{ update_member_by_pk: Maybe<WithTypename<Member>> }, Mutation_RootUpdate_Member_By_PkArgs>,
    update_member_group?: GraphCacheUpdateResolver<{ update_member_group: Maybe<WithTypename<Member_Group_Mutation_Response>> }, Mutation_RootUpdate_Member_GroupArgs>,
    update_member_group_by_pk?: GraphCacheUpdateResolver<{ update_member_group_by_pk: Maybe<WithTypename<Member_Group>> }, Mutation_RootUpdate_Member_Group_By_PkArgs>,
    update_member_group_mn?: GraphCacheUpdateResolver<{ update_member_group_mn: Maybe<WithTypename<Member_Group_Mn_Mutation_Response>> }, Mutation_RootUpdate_Member_Group_MnArgs>,
    update_member_group_mn_by_pk?: GraphCacheUpdateResolver<{ update_member_group_mn_by_pk: Maybe<WithTypename<Member_Group_Mn>> }, Mutation_RootUpdate_Member_Group_Mn_By_PkArgs>,
    update_payment?: GraphCacheUpdateResolver<{ update_payment: Maybe<WithTypename<Payment_Mutation_Response>> }, Mutation_RootUpdate_PaymentArgs>,
    update_payment_by_pk?: GraphCacheUpdateResolver<{ update_payment_by_pk: Maybe<WithTypename<Payment>> }, Mutation_RootUpdate_Payment_By_PkArgs>,
    update_s3_file?: GraphCacheUpdateResolver<{ update_s3_file: Maybe<WithTypename<S3_File_Mutation_Response>> }, Mutation_RootUpdate_S3_FileArgs>,
    update_s3_file_by_pk?: GraphCacheUpdateResolver<{ update_s3_file_by_pk: Maybe<WithTypename<S3_File>> }, Mutation_RootUpdate_S3_File_By_PkArgs>,
    update_team?: GraphCacheUpdateResolver<{ update_team: Maybe<WithTypename<Team_Mutation_Response>> }, Mutation_RootUpdate_TeamArgs>,
    update_team_by_pk?: GraphCacheUpdateResolver<{ update_team_by_pk: Maybe<WithTypename<Team>> }, Mutation_RootUpdate_Team_By_PkArgs>,
    update_user_permission?: GraphCacheUpdateResolver<{ update_user_permission: Maybe<WithTypename<User_Permission_Mutation_Response>> }, Mutation_RootUpdate_User_PermissionArgs>,
    update_user_permission_by_pk?: GraphCacheUpdateResolver<{ update_user_permission_by_pk: Maybe<WithTypename<User_Permission>> }, Mutation_RootUpdate_User_Permission_By_PkArgs>,
    update_user_permission_role?: GraphCacheUpdateResolver<{ update_user_permission_role: Maybe<WithTypename<User_Permission_Role_Mutation_Response>> }, Mutation_RootUpdate_User_Permission_RoleArgs>,
    update_user_permission_role_by_pk?: GraphCacheUpdateResolver<{ update_user_permission_role_by_pk: Maybe<WithTypename<User_Permission_Role>> }, Mutation_RootUpdate_User_Permission_Role_By_PkArgs>,
    update_users?: GraphCacheUpdateResolver<{ update_users: Maybe<WithTypename<Users_Mutation_Response>> }, Mutation_RootUpdate_UsersArgs>,
    update_users_by_pk?: GraphCacheUpdateResolver<{ update_users_by_pk: Maybe<WithTypename<Users>> }, Mutation_RootUpdate_Users_By_PkArgs>
  },
  Subscription?: {
    club?: GraphCacheUpdateResolver<{ club: Array<WithTypename<Club>> }, Subscription_RootClubArgs>,
    club_aggregate?: GraphCacheUpdateResolver<{ club_aggregate: WithTypename<Club_Aggregate> }, Subscription_RootClub_AggregateArgs>,
    club_by_pk?: GraphCacheUpdateResolver<{ club_by_pk: Maybe<WithTypename<Club>> }, Subscription_RootClub_By_PkArgs>,
    editor_type?: GraphCacheUpdateResolver<{ editor_type: Array<WithTypename<Editor_Type>> }, Subscription_RootEditor_TypeArgs>,
    editor_type_aggregate?: GraphCacheUpdateResolver<{ editor_type_aggregate: WithTypename<Editor_Type_Aggregate> }, Subscription_RootEditor_Type_AggregateArgs>,
    editor_type_by_pk?: GraphCacheUpdateResolver<{ editor_type_by_pk: Maybe<WithTypename<Editor_Type>> }, Subscription_RootEditor_Type_By_PkArgs>,
    enum_exercise_categories?: GraphCacheUpdateResolver<{ enum_exercise_categories: Array<WithTypename<Enum_Exercise_Categories>> }, Subscription_RootEnum_Exercise_CategoriesArgs>,
    enum_exercise_categories_aggregate?: GraphCacheUpdateResolver<{ enum_exercise_categories_aggregate: WithTypename<Enum_Exercise_Categories_Aggregate> }, Subscription_RootEnum_Exercise_Categories_AggregateArgs>,
    enum_exercise_categories_by_pk?: GraphCacheUpdateResolver<{ enum_exercise_categories_by_pk: Maybe<WithTypename<Enum_Exercise_Categories>> }, Subscription_RootEnum_Exercise_Categories_By_PkArgs>,
    enum_languages?: GraphCacheUpdateResolver<{ enum_languages: Array<WithTypename<Enum_Languages>> }, Subscription_RootEnum_LanguagesArgs>,
    enum_languages_aggregate?: GraphCacheUpdateResolver<{ enum_languages_aggregate: WithTypename<Enum_Languages_Aggregate> }, Subscription_RootEnum_Languages_AggregateArgs>,
    enum_languages_by_pk?: GraphCacheUpdateResolver<{ enum_languages_by_pk: Maybe<WithTypename<Enum_Languages>> }, Subscription_RootEnum_Languages_By_PkArgs>,
    enum_sport?: GraphCacheUpdateResolver<{ enum_sport: Array<WithTypename<Enum_Sport>> }, Subscription_RootEnum_SportArgs>,
    enum_sport_aggregate?: GraphCacheUpdateResolver<{ enum_sport_aggregate: WithTypename<Enum_Sport_Aggregate> }, Subscription_RootEnum_Sport_AggregateArgs>,
    enum_sport_by_pk?: GraphCacheUpdateResolver<{ enum_sport_by_pk: Maybe<WithTypename<Enum_Sport>> }, Subscription_RootEnum_Sport_By_PkArgs>,
    exercise?: GraphCacheUpdateResolver<{ exercise: Array<WithTypename<Exercise>> }, Subscription_RootExerciseArgs>,
    exercise_aggregate?: GraphCacheUpdateResolver<{ exercise_aggregate: WithTypename<Exercise_Aggregate> }, Subscription_RootExercise_AggregateArgs>,
    exercise_by_pk?: GraphCacheUpdateResolver<{ exercise_by_pk: Maybe<WithTypename<Exercise>> }, Subscription_RootExercise_By_PkArgs>,
    exercise_club_mn?: GraphCacheUpdateResolver<{ exercise_club_mn: Array<WithTypename<Exercise_Club_Mn>> }, Subscription_RootExercise_Club_MnArgs>,
    exercise_club_mn_aggregate?: GraphCacheUpdateResolver<{ exercise_club_mn_aggregate: WithTypename<Exercise_Club_Mn_Aggregate> }, Subscription_RootExercise_Club_Mn_AggregateArgs>,
    exercise_club_mn_by_pk?: GraphCacheUpdateResolver<{ exercise_club_mn_by_pk: Maybe<WithTypename<Exercise_Club_Mn>> }, Subscription_RootExercise_Club_Mn_By_PkArgs>,
    exercise_content_media?: GraphCacheUpdateResolver<{ exercise_content_media: Array<WithTypename<Exercise_Content_Media>> }, Subscription_RootExercise_Content_MediaArgs>,
    exercise_content_media_aggregate?: GraphCacheUpdateResolver<{ exercise_content_media_aggregate: WithTypename<Exercise_Content_Media_Aggregate> }, Subscription_RootExercise_Content_Media_AggregateArgs>,
    exercise_content_media_by_pk?: GraphCacheUpdateResolver<{ exercise_content_media_by_pk: Maybe<WithTypename<Exercise_Content_Media>> }, Subscription_RootExercise_Content_Media_By_PkArgs>,
    exercise_content_media_editor?: GraphCacheUpdateResolver<{ exercise_content_media_editor: Array<WithTypename<Exercise_Content_Media_Editor>> }, Subscription_RootExercise_Content_Media_EditorArgs>,
    exercise_content_media_editor_aggregate?: GraphCacheUpdateResolver<{ exercise_content_media_editor_aggregate: WithTypename<Exercise_Content_Media_Editor_Aggregate> }, Subscription_RootExercise_Content_Media_Editor_AggregateArgs>,
    exercise_content_media_editor_by_pk?: GraphCacheUpdateResolver<{ exercise_content_media_editor_by_pk: Maybe<WithTypename<Exercise_Content_Media_Editor>> }, Subscription_RootExercise_Content_Media_Editor_By_PkArgs>,
    exercise_content_media_mn?: GraphCacheUpdateResolver<{ exercise_content_media_mn: Array<WithTypename<Exercise_Content_Media_Mn>> }, Subscription_RootExercise_Content_Media_MnArgs>,
    exercise_content_media_mn_aggregate?: GraphCacheUpdateResolver<{ exercise_content_media_mn_aggregate: WithTypename<Exercise_Content_Media_Mn_Aggregate> }, Subscription_RootExercise_Content_Media_Mn_AggregateArgs>,
    exercise_content_media_mn_by_pk?: GraphCacheUpdateResolver<{ exercise_content_media_mn_by_pk: Maybe<WithTypename<Exercise_Content_Media_Mn>> }, Subscription_RootExercise_Content_Media_Mn_By_PkArgs>,
    exercise_content_media_type?: GraphCacheUpdateResolver<{ exercise_content_media_type: Array<WithTypename<Exercise_Content_Media_Type>> }, Subscription_RootExercise_Content_Media_TypeArgs>,
    exercise_content_media_type_aggregate?: GraphCacheUpdateResolver<{ exercise_content_media_type_aggregate: WithTypename<Exercise_Content_Media_Type_Aggregate> }, Subscription_RootExercise_Content_Media_Type_AggregateArgs>,
    exercise_content_media_type_by_pk?: GraphCacheUpdateResolver<{ exercise_content_media_type_by_pk: Maybe<WithTypename<Exercise_Content_Media_Type>> }, Subscription_RootExercise_Content_Media_Type_By_PkArgs>,
    exercise_taxonomy?: GraphCacheUpdateResolver<{ exercise_taxonomy: Array<WithTypename<Exercise_Taxonomy>> }, Subscription_RootExercise_TaxonomyArgs>,
    exercise_taxonomy_aggregate?: GraphCacheUpdateResolver<{ exercise_taxonomy_aggregate: WithTypename<Exercise_Taxonomy_Aggregate> }, Subscription_RootExercise_Taxonomy_AggregateArgs>,
    exercise_taxonomy_by_pk?: GraphCacheUpdateResolver<{ exercise_taxonomy_by_pk: Maybe<WithTypename<Exercise_Taxonomy>> }, Subscription_RootExercise_Taxonomy_By_PkArgs>,
    exercise_taxonomy_mn?: GraphCacheUpdateResolver<{ exercise_taxonomy_mn: Array<WithTypename<Exercise_Taxonomy_Mn>> }, Subscription_RootExercise_Taxonomy_MnArgs>,
    exercise_taxonomy_mn_aggregate?: GraphCacheUpdateResolver<{ exercise_taxonomy_mn_aggregate: WithTypename<Exercise_Taxonomy_Mn_Aggregate> }, Subscription_RootExercise_Taxonomy_Mn_AggregateArgs>,
    exercise_taxonomy_mn_by_pk?: GraphCacheUpdateResolver<{ exercise_taxonomy_mn_by_pk: Maybe<WithTypename<Exercise_Taxonomy_Mn>> }, Subscription_RootExercise_Taxonomy_Mn_By_PkArgs>,
    license?: GraphCacheUpdateResolver<{ license: Array<WithTypename<License>> }, Subscription_RootLicenseArgs>,
    license_aggregate?: GraphCacheUpdateResolver<{ license_aggregate: WithTypename<License_Aggregate> }, Subscription_RootLicense_AggregateArgs>,
    license_by_pk?: GraphCacheUpdateResolver<{ license_by_pk: Maybe<WithTypename<License>> }, Subscription_RootLicense_By_PkArgs>,
    member?: GraphCacheUpdateResolver<{ member: Array<WithTypename<Member>> }, Subscription_RootMemberArgs>,
    member_aggregate?: GraphCacheUpdateResolver<{ member_aggregate: WithTypename<Member_Aggregate> }, Subscription_RootMember_AggregateArgs>,
    member_by_pk?: GraphCacheUpdateResolver<{ member_by_pk: Maybe<WithTypename<Member>> }, Subscription_RootMember_By_PkArgs>,
    member_group?: GraphCacheUpdateResolver<{ member_group: Array<WithTypename<Member_Group>> }, Subscription_RootMember_GroupArgs>,
    member_group_aggregate?: GraphCacheUpdateResolver<{ member_group_aggregate: WithTypename<Member_Group_Aggregate> }, Subscription_RootMember_Group_AggregateArgs>,
    member_group_by_pk?: GraphCacheUpdateResolver<{ member_group_by_pk: Maybe<WithTypename<Member_Group>> }, Subscription_RootMember_Group_By_PkArgs>,
    member_group_mn?: GraphCacheUpdateResolver<{ member_group_mn: Array<WithTypename<Member_Group_Mn>> }, Subscription_RootMember_Group_MnArgs>,
    member_group_mn_aggregate?: GraphCacheUpdateResolver<{ member_group_mn_aggregate: WithTypename<Member_Group_Mn_Aggregate> }, Subscription_RootMember_Group_Mn_AggregateArgs>,
    member_group_mn_by_pk?: GraphCacheUpdateResolver<{ member_group_mn_by_pk: Maybe<WithTypename<Member_Group_Mn>> }, Subscription_RootMember_Group_Mn_By_PkArgs>,
    payment?: GraphCacheUpdateResolver<{ payment: Array<WithTypename<Payment>> }, Subscription_RootPaymentArgs>,
    payment_aggregate?: GraphCacheUpdateResolver<{ payment_aggregate: WithTypename<Payment_Aggregate> }, Subscription_RootPayment_AggregateArgs>,
    payment_by_pk?: GraphCacheUpdateResolver<{ payment_by_pk: Maybe<WithTypename<Payment>> }, Subscription_RootPayment_By_PkArgs>,
    s3_file?: GraphCacheUpdateResolver<{ s3_file: Array<WithTypename<S3_File>> }, Subscription_RootS3_FileArgs>,
    s3_file_aggregate?: GraphCacheUpdateResolver<{ s3_file_aggregate: WithTypename<S3_File_Aggregate> }, Subscription_RootS3_File_AggregateArgs>,
    s3_file_by_pk?: GraphCacheUpdateResolver<{ s3_file_by_pk: Maybe<WithTypename<S3_File>> }, Subscription_RootS3_File_By_PkArgs>,
    team?: GraphCacheUpdateResolver<{ team: Array<WithTypename<Team>> }, Subscription_RootTeamArgs>,
    team_aggregate?: GraphCacheUpdateResolver<{ team_aggregate: WithTypename<Team_Aggregate> }, Subscription_RootTeam_AggregateArgs>,
    team_by_pk?: GraphCacheUpdateResolver<{ team_by_pk: Maybe<WithTypename<Team>> }, Subscription_RootTeam_By_PkArgs>,
    user_permission?: GraphCacheUpdateResolver<{ user_permission: Array<WithTypename<User_Permission>> }, Subscription_RootUser_PermissionArgs>,
    user_permission_aggregate?: GraphCacheUpdateResolver<{ user_permission_aggregate: WithTypename<User_Permission_Aggregate> }, Subscription_RootUser_Permission_AggregateArgs>,
    user_permission_by_pk?: GraphCacheUpdateResolver<{ user_permission_by_pk: Maybe<WithTypename<User_Permission>> }, Subscription_RootUser_Permission_By_PkArgs>,
    user_permission_role?: GraphCacheUpdateResolver<{ user_permission_role: Array<WithTypename<User_Permission_Role>> }, Subscription_RootUser_Permission_RoleArgs>,
    user_permission_role_aggregate?: GraphCacheUpdateResolver<{ user_permission_role_aggregate: WithTypename<User_Permission_Role_Aggregate> }, Subscription_RootUser_Permission_Role_AggregateArgs>,
    user_permission_role_by_pk?: GraphCacheUpdateResolver<{ user_permission_role_by_pk: Maybe<WithTypename<User_Permission_Role>> }, Subscription_RootUser_Permission_Role_By_PkArgs>,
    users?: GraphCacheUpdateResolver<{ users: Array<WithTypename<Users>> }, Subscription_RootUsersArgs>,
    users_aggregate?: GraphCacheUpdateResolver<{ users_aggregate: WithTypename<Users_Aggregate> }, Subscription_RootUsers_AggregateArgs>,
    users_by_pk?: GraphCacheUpdateResolver<{ users_by_pk: Maybe<WithTypename<Users>> }, Subscription_RootUsers_By_PkArgs>
  },
};

export type GraphCacheConfig = {
  schema?: IntrospectionData,
  updates?: GraphCacheUpdaters,
  keys?: GraphCacheKeysConfig,
  optimistic?: GraphCacheOptimisticUpdaters,
  resolvers?: GraphCacheResolvers,
  storage?: GraphCacheStorageAdapter
};